(function() {
  'use strict';

  angular
    .module('lms', [
      'ngAnimate',
      'ngCookies',
      'ngTouch',
      'ngSanitize',
      'ngMessages',
      'ngAria',
      'ngResource',
      'ui.router',
      'toastr',
      'ng-token-auth',
      'angular-toArrayFilter',
      'angularUtils.directives.dirPagination',
      'ui.bootstrap',
      'ui.select',
      'vModal',
      'angular-confirm',
      'ngFileSaver',
      'infinite-scroll',
      'ui.mask',
      'ui.bootstrap',
      'angular-confirm',
      'ngIdle'
    ]).run(['$confirmModalDefaults', function($confirmModalDefaults) {
      $confirmModalDefaults.templateUrl = 'app/confirm/confirm.html';
  }]);

})();

// Controller

(function() {
   angular.module('lms').controller(
       'statesController',
       ['$scope', '$confirm','statesFactory', '$rootScope', function($scope, $confirm, statesFactory){
           var init = function() {

               var that = $scope;

               that.states = [];

               statesFactory.index().then(
                   function(response) {
                       console.log(JSON.stringify(response));
                       if (response) {
                           if (response.status == undefined) {
                               that.states = response;
                           } else {
                               that.states = [];
                           }
                       }else{
                           that.states = [];
                       }
                   }
               );
           };
           init();

           $scope.addState = function() {

               var that = $scope;

               statesFactory.create(that.newState).then(
                   function(response) {
                       // response.status is undefined if call was successful
                       if (response.status == undefined) {
                         that.states.push(response);
                         that.newState = null;
                         that.newAbbreviation = null;
                       }
                   }
               );
           };

           $scope.removeState = function(item) {
               var that = $scope;

               statesFactory.remove(that.states[item].id).then(
                   function(response) {
                       if (response.status == undefined) {
                           that.states.splice(item, 1);
                       }
                   }
               )

               $confirm({text: 'Are you sure you want to remove this state?', title: 'Remove State', ok: 'Yes', cancel: 'No'})
                  .then(function(){
                      statesFactory.remove(that.states[item].id).then(
                         function(response) {
                             if (response.status == undefined) {
                                 that.states.splice(item,1);
                             }
                         }
                     )
                  });

           }

       }]
   );
}());
// Controller

(function() {
   angular.module('lms').controller(
       'licenseTypesController',
       ['$scope', '$confirm', 'licenseTypesFactory', '$rootScope', function($scope, $confirm, licenseTypesFactory){
           var init = function() {

               var that = $scope;

               that.licenseTypes = [];
               licenseTypesFactory.index().then(
                   function(response) {
                       if (response.status == undefined) {
                           that.licenseTypes = response;
                       } else {
                           that.licenseTypes = [];
                       }
                   }
               );
           };
           init();

           $scope.addLicenseType = function() {

               var that = $scope;

               console.log('New License Type: ' + JSON.stringify(that.newLicenseType));

               licenseTypesFactory.create(that.newLicenseType).then(
                   function(response) {
                       // response.status is undefined if call was successful
                       if (response.status == undefined) {
                         that.licenseTypes.push(response);
                         that.newLicenseType = null;
                       }
                   }
               );
           };

           $scope.removeLicenseType = function(item) {
               var that = $scope;

               $confirm({text: 'Are you sure you want to remove this license type?', title: 'Remove License Type', ok: 'Yes', cancel: 'No'})
                  .then(function(){
                      licenseTypesFactory.remove(that.licenseTypes[item].id).then(
                         function(response) {
                             if (response.status == undefined) {
                                 that.licenseTypes.splice(item,1);
                             }
                         }
                     )
                  });

           }

       }]
   );
}());
// Controller

(function() {
   angular.module('lms').controller(
       'licenseSettingsController',
       ['$scope', '$confirm', 'toastr', 'licenseSettingsFactory', '$rootScope', function($scope, $confirm, toastr, licenseSettingsFactory){
           var init = function() {

               var that = $scope;

               that.licenseSetting = null;
               licenseSettingsFactory.index().then(
                   function(response) {

                       console.log(JSON.stringify(response));

                       if (response.status == undefined) {
                           that.licenseSetting = response;
                       } else {
                           that.licenseSetting = null;
                       }
                   }
               );
           };
           init();

           $scope.updateLicenseSetting = function() {

               var that = $scope;

               // console.log('New License Settings: ' + JSON.stringify(that.licenseSetting));

               licenseSettingsFactory.update(that.licenseSetting).then(
                   function(response) {
                       // response.status is undefined if call was successful
                       // console.log(JSON.stringify(response.status));
                       if (response.status == undefined) {
                         that.licenseSetting = response;
                         toastr.success('License settings updated...');
                       }

                   }
               );
           };

       }]
   );
}());
// Controller

(function() {
   angular.module('lms').controller(
       'licensePurposesController',
       ['$scope', '$confirm', 'licensePurposesFactory', '$rootScope', function($scope, $confirm, licensePurposesFactory){
           var init = function() {

               var that = $scope;

               that.licensePurposes = [];
               licensePurposesFactory.index().then(
                   function(response) {
                       if (response.status == undefined) {
                           that.licensePurposes = response;
                       } else {
                           that.licensePurposes = [];
                       }
                   }
               );
           };
           init();

           $scope.addLicensePurpose = function() {

               var that = $scope;

               //console.log('New License Purpose: ' + JSON.stringify(that.newLicenseType));

               licensePurposesFactory.create(that.newLicensePurpose).then(
                   function(response) {
                       // response.status is undefined if call was successful
                       if (response.status == undefined) {
                         that.licensePurposes.push(response);
                         that.newLicensePurpose = null;
                       }
                   }
               );
           };

           $scope.removeLicensePurpose = function(item) {
               var that = $scope;

               $confirm({text: 'Are you sure you want to remove this license purpose?', title: 'Remove License Purpose', ok: 'Yes', cancel: 'No'})
                  .then(function(){
                      licensePurposesFactory.remove(that.licensePurposes[item].id).then(
                         function(response) {
                             if (response.status == undefined) {
                                 that.licensePurposes.splice(item,1);
                             }
                         }
                     )
                  });

           }

       }]
   );
}());
// Controller

(function() {
   angular.module('lms').controller(
       'licenseOfficialsController',
       ['$scope', '$confirm', 'licenseOfficialsFactory', '$rootScope', function($scope, $confirm, licenseOfficialsFactory){
           var init = function() {

               var that = $scope;

               that.licenseOfficials = [];
               licenseOfficialsFactory.index().then(
                   function(response) {
                       if (response.status == undefined) {
                           that.licenseOfficials = response;
                       } else {
                           that.licenseOfficials = [];
                       }
                   }
               );
           };
           init();

           $scope.addLicenseOfficial = function() {

               var that = $scope;

               //console.log('New License Purpose: ' + JSON.stringify(that.newLicenseType));

               licenseOfficialsFactory.create(that.newLicenseOfficial).then(
                   function(response) {
                       // response.status is undefined if call was successful
                       if (response.status == undefined) {
                         that.licenseOfficials.push(response);
                         that.newLicenseOfficial = null;
                         that.newOfficialTitle = null;
                       }
                   }
               );
           };

           $scope.removeLicenseOfficial = function(item) {
               var that = $scope;

               $confirm({text: 'Are you sure you want to remove this license official?', title: 'Remove License Official', ok: 'Yes', cancel: 'No'})
                  .then(function(){
                      licenseOfficialsFactory.remove(that.licenseOfficials[item].id).then(
                         function(response) {
                             if (response.status == undefined) {
                                 that.licenseOfficials.splice(item,1);
                             }
                         }
                     )
                  });

           }

       }]
   );
}());
// Controller

(function() {
   angular.module('lms').controller(
       'inspectionTypesController',
       ['$scope', '$confirm', 'inspectionTypesFactory', '$rootScope', function($scope, $confirm, inspectionTypesFactory){
           var init = function() {

               var that = $scope;

               that.inspectionTypes = [];
               inspectionTypesFactory.index().then(
                   function(response) {
                       if (response.status == undefined) {
                           that.inspectionTypes = response;
                       } else {
                           that.inspectionTypes = [];
                       }
                   }
               );
           };
           init();

           $scope.addInspectionType = function() {

               var that = $scope;

               console.log('New Inspection Type: ' + JSON.stringify(that.newInspectionType));

               inspectionTypesFactory.create(that.newInspectionType).then(
                   function(response) {
                       // response.status is undefined if call was successful
                       if (response.status == undefined) {
                         that.inspectionTypes.push(response);
                         that.newInspectionType = null;
                       }
                   }
               );
           };

           $scope.removeInspectionType = function(item) {
               var that = $scope;

               $confirm({text: 'Are you sure you want to remove this inspection type?', title: 'Remove Inspection Type', ok: 'Yes', cancel: 'No'})
                  .then(function(){
                      inspectionTypesFactory.remove(that.inspectionTypes[item].id).then(
                         function(response) {
                             if (response.status == undefined) {
                                 that.inspectionTypes.splice(item,1);
                             }
                         }
                     )
                  });

           }

       }]
   );
}());
// Controller

(function() {
   angular.module('lms').controller(
       'inspectionReasonsController',
       ['$scope', '$confirm', 'inspectionReasonsFactory', '$rootScope', function($scope, $confirm, inspectionReasonsFactory){
           var init = function() {

               var that = $scope;

               that.inspectionReasons = [];
               inspectionReasonsFactory.index().then(
                   function(response) {
                       if (response.status == undefined) {
                           that.inspectionReasons = response;
                       } else {
                           that.inspectionReasons = [];
                       }
                   }
               );
           };
           init();

           $scope.addInspectionReason = function() {

               var that = $scope;

               console.log('New Inspection Reason: ' + JSON.stringify(that.newInspectionReason));

               inspectionReasonsFactory.create(that.newInspectionReason).then(
                   function(response) {
                       // response.status is undefined if call was successful
                       if (response.status == undefined) {
                         that.inspectionReasons.push(response);
                         that.newInspectionReason = null;
                       }
                   }
               );
           };

           $scope.removeInspectionReason = function(item) {
               var that = $scope;

               $confirm({text: 'Are you sure you want to remove this inspection reason?', title: 'Remove Inspection Reason', ok: 'Yes', cancel: 'No'})
                  .then(function(){
                      inspectionReasonsFactory.remove(that.inspectionReasons[item].id).then(
                         function(response) {
                             if (response.status == undefined) {
                                 that.inspectionReasons.splice(item,1);
                             }
                         }
                     )
                  });
           }

       }]
   );
}());
// Controller

(function() {
   angular.module('lms').controller(
       'evaluationStatusesController',
       ['$scope', '$confirm','evaluationStatusesFactory', '$rootScope', function($scope, $confirm, evaluationStatusesFactory){
           var init = function() {

               var that = $scope;

               that.evaluationStatuses = [];
               evaluationStatusesFactory.index().then(
                   function(response) {
                       if (response.status == undefined) {
                           that.evaluationStatuses = response;
                       } else {
                           that.evaluationStatuses = [];
                       }
                   }
               );
           };
           init();

           $scope.addEvaluationStatus = function() {

               var that = $scope;

               console.log('New Evaluation Status: ' + JSON.stringify(that.newEvaluationStatus));

               evaluationStatusesFactory.create(that.newEvaluationStatus).then(
                   function(response) {
                       // response.status is undefined if call was successful
                       if (response.status == undefined) {
                         that.evaluationStatuses.push(response);
                         that.newEvaluationStatus = null;
                       }
                   }
               );
           };

           $scope.removeEvaluationStatus = function(item) {
               var that = $scope;

               //evaluationStatusesFactory.remove(that.evaluationStatuses[item].id).then(
               //    function(response) {
               //        if (response.status == undefined) {
               //            that.evaluationStatuses.splice(item, 1);
               //        }
               //    }
               //)

               $confirm({text: 'Are you sure you want to remove this evaluation status?', title: 'Remove Evaluation Status', ok: 'Yes', cancel: 'No'})
                  .then(function(){
                      evaluationStatusesFactory.remove(that.evaluationStatuses[item].id).then(
                         function(response) {
                             if (response.status == undefined) {
                                 that.evaluationStatuses.splice(item,1);
                             }
                         }
                     )
                  });
           }

       }]
   );
}());
// Controller

(function () {
    angular.module('lms').controller(
        'contractorsController',
        ['$scope', '$confirm', 'contractorsFactory', 'modalFactory', '$rootScope', function ($scope, $confirm, contractorsFactory, modalFactory, $rootScope) {

            var init = function () {
                var that = $scope;
                that.currentPage = 1;
                that.itemsPerPage = 20;
                that.contractors = [];
                that.sortColumnz = 'contractor_name';
                that.sortOrderz = 'asc';
                that.sortReverse = false;
                console.log("init called");
                getMoreResults();
            };
            

            var that = $scope;

            var getMoreResults = that.getMoreResults = function () {
                console.log("getMoreResults called");
                that = $scope;
                contractorsFactory.index(that.currentPage, that.itemsPerPage, that.sortColumnz, that.sortOrderz).then(
                    function (response) {
                        console.log("that.currentPage: " + that.currentPage);
                        if (response.status == undefined) {
                            if (response.contractors.length > 0) {
                                that.totalContractors = response.size;
                                console.log("that.totalContractors: " + that.totalContractors);
                                that.contractors = [];
                                for (var i = 0; i < response.contractors.length; i++) {
                                    that.contractors.push(response.contractors[i]);
                                }
                                console.log("contractors: " + JSON.stringify(that.contractors[0]));
                                //that.currentPage += 1;
                            }
                        }
                    }
                )
            };

            init();

            var setConditions = that.setConditions = function(column, ascending) {
               that = $scope;
               that.contractors = [];
               that.sortColumnz = column;
               if(ascending){that.sortOrderz = 'asc'}else{that.sortOrderz = 'desc'};
               that.currentPage = 1;
               getMoreResults();
           };

            var findWithAttr = function (array, attr, value) {
                for (var i = 0; i < array.length; i += 1) {
                    if (array[i][attr] === value) {
                        return i;
                    }
                }
            };

            var showContractorModal = that.showContractorModal = function () {
                var modal = modalFactory.showModal('newContractorsModalController', 'app/contractors/add_contractor.html');
                modal.activate();
            };

            var showEditContractorModal = that.showEditContractorModal = function (contractor_id) {
                $rootScope.contractor_id = contractor_id;
                var modal = modalFactory.showModal('editContractorsModalController', 'app/contractors/edit_contractor.html');
                modal.activate();
            }

            var addContractor = that.addContractor = function () {
                showContractorModal();
            };

            var editContractor = that.editContractor = function (item) {
                showEditContractorModal(that.contractors[item].id);
            };

            $rootScope.$on('addContractorToList', function (event, data) {
                that.contractors.push(data);
            });

            $rootScope.$on('updateContractorInList', function (event, data) {
                that.contractors.contractors[findWithAttr(that.contractors, 'id', data.id)] = data;
            });

            $scope.removeContractor = function (item) {
                var that = $scope;

                $confirm({
                    text: 'Are you sure you want to remove this contractor?',
                    title: 'Remove Contractor',
                    ok: 'Yes',
                    cancel: 'No'
                })
                    .then(function () {
                        contractorsFactory.remove(that.contractors[item].id).then(
                            function (response) {
                                if (response.status == undefined) {
                                    that.contractors.splice(item, 1);
                                }
                            }
                        )
                    });
            }

        }]
    );
}());
// Controller

(function() {
   angular.module('lms').controller(
       'contractorTypesController',
       ['$scope', '$confirm', 'contractorTypesFactory', '$rootScope', function($scope, $confirm, contractorTypesFactory){
           var init = function() {

               var that = $scope;

               that.contractorTypes = [];
               contractorTypesFactory.index().then(
                   function(response) {
                       if (response.status == undefined) {
                           that.contractorTypes = response;
                       } else {
                           that.contractorTypes = [];
                       }
                   }
               );
           };
           init();

           $scope.addContractorType = function() {

               var that = $scope;

               console.log('New Contractor Type: ' + JSON.stringify(that.newContractorType));

               contractorTypesFactory.create(that.newContractorType).then(
                   function(response) {
                       // response.status is undefined if call was successful
                       if (response.status == undefined) {
                         that.contractorTypes.push(response);
                         that.newContractorType = null;
                       }
                   }
               );
           };

           $scope.removeContractorType = function(item) {
               var that = $scope;

               $confirm({text: 'Are you sure you want to remove this Contractor Type?', title: 'Remove Contractor Type', ok: 'Yes', cancel: 'No'})
                  .then(function(){
                      contractorTypesFactory.remove(that.contractorTypes[item].id).then(
                         function(response) {
                             if (response.status == undefined) {
                                 that.contractorTypes.splice(item,1);
                             }
                         }
                     )
                  });
           }

       }]
   );
}());
// Controller

(function() {
   angular.module('lms').controller(
       'contactTypesController',
       ['$scope', '$confirm', 'contactTypesFactory', '$rootScope', function($scope, $confirm, contactTypesFactory){
           var init = function() {

               var that = $scope;

               that.contactTypes = [];
               contactTypesFactory.index().then(
                   function(response) {
                       if (response.status == undefined) {
                           that.contactTypes = response;
                       } else {
                           that.contactTypes = [];
                       }
                   }
               );
           };
           init();

           $scope.addContactType = function() {

               var that = $scope;

               contactTypesFactory.create(that.newContactType).then(
                   function(response) {
                       // response.status is undefined if call was successful
                       if (response.status == undefined) {
                         that.contactTypes.push(response);
                         that.newContactType = null;
                       }
                   }
               );
           };

           $scope.removeContactType = function(item) {
               var that = $scope;

               //contactTypesFactory.remove(that.contactTypes[item].id).then(
               //    function(response) {
               //        if (response.status == undefined) {
               //            that.contactTypes.splice(item, 1);
               //        }
               //    }
               //)

               $confirm({text: 'Are you sure you want to remove this contact type?', title: 'Remove Contact Type', ok: 'Yes', cancel: 'No'})
                  .then(function(){
                      contactTypesFactory.remove(that.contactTypes[item].id).then(
                         function(response) {
                             if (response.status == undefined) {
                                 that.contactTypes.splice(item,1);
                             }
                         }
                     )
                  });
           }

       }]
   );
}());
// Controller

(function() {
  angular.module('lms').controller(
    'businessTypesController',
    ['$scope', '$confirm', 'businessTypesFactory', '$rootScope', function($scope, $confirm, businessTypesFactory){
      var init = function() {

        var that = $scope;

        that.businessTypes = [];
        businessTypesFactory.index().then(
          function(response) {
            if (response.status == undefined) {
              that.businessTypes = response;
            } else {
              that.businessTypes = [];
            }
          }
        );
      };
      init();

      $scope.addBusinessType = function() {

        var that = $scope;

        businessTypesFactory.create(that.newBusinessType).then(
          function(response) {
            // response.status is undefined if call was successful
            if (response.status == undefined) {
              that.businessTypes.push(response);
              that.newBusinessType = null;
            }
          }
        );
      };

      $scope.removeBusinessType = function(item) {
        var that = $scope;

        $confirm({text: 'Are you sure you want to remove this business type?', title: 'Remove Business Type', ok: 'Yes', cancel: 'No'})
          .then(function(){
            businessTypesFactory.remove(that.businessTypes[item].id).then(
              function(response) {
                if (response.status == undefined) {
                  that.businessTypes.splice(item,1);
                }
              }
            )
          });

      }

      $scope.updateAnnualLicenseRequirement = function(item) {



        var that = $scope;

        //console.log('Attempting to update License Requirement: ' + JSON.stringify(that.businessTypes[item]) );

        businessTypesFactory.update(that.businessTypes[item]).then(
          function(response) {
            if (response.status == undefined) {
              that.businessTypes[item] = response;
            }
          }
        );

      };

    }]
  );
}());

(function() {
  'use strict';

  angular
      .module('lms')
      .service('webDevTec', webDevTec);

  /** @ngInject */
  function webDevTec() {
    var data = [
      {
        'title': 'AngularJS',
        'url': 'https://angularjs.org/',
        'description': 'HTML enhanced for web apps!',
        'logo': 'angular.png'
      },
      {
        'title': 'BrowserSync',
        'url': 'http://browsersync.io/',
        'description': 'Time-saving synchronised browser testing.',
        'logo': 'browsersync.png'
      },
      {
        'title': 'GulpJS',
        'url': 'http://gulpjs.com/',
        'description': 'The streaming build system.',
        'logo': 'gulp.png'
      },
      {
        'title': 'Jasmine',
        'url': 'http://jasmine.github.io/',
        'description': 'Behavior-Driven JavaScript.',
        'logo': 'jasmine.png'
      },
      {
        'title': 'Karma',
        'url': 'http://karma-runner.github.io/',
        'description': 'Spectacular Test Runner for JavaScript.',
        'logo': 'karma.png'
      },
      {
        'title': 'Protractor',
        'url': 'https://github.com/angular/protractor',
        'description': 'End to end test framework for AngularJS applications built on top of WebDriverJS.',
        'logo': 'protractor.png'
      },
      {
        'title': 'Bootstrap',
        'url': 'http://getbootstrap.com/',
        'description': 'Bootstrap is the most popular HTML, CSS, and JS framework for developing responsive, mobile first projects on the web.',
        'logo': 'bootstrap.png'
      },
      {
        'title': 'Angular UI Bootstrap',
        'url': 'http://angular-ui.github.io/bootstrap/',
        'description': 'Bootstrap components written in pure AngularJS by the AngularUI Team.',
        'logo': 'ui-bootstrap.png'
      },
      {
        'title': 'Sass (Node)',
        'url': 'https://github.com/sass/node-sass',
        'description': 'Node.js binding to libsass, the C version of the popular stylesheet preprocessor, Sass.',
        'logo': 'node-sass.png'
      }
    ];

    this.getTec = getTec;

    function getTec() {
      return data;
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('lms')
    .directive('acmeNavbar', acmeNavbar);

  /** @ngInject */
  function acmeNavbar() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/navbar/navbar.html',
      scope: {
          creationDate: '='
      },
      controller: NavbarController,
      controllerAs: 'vm',
      bindToController: true
    };

    return directive;

    /** @ngInject */
    function NavbarController(moment) {
      var vm = this;

      // "vm.creationDate" is available by directive option "bindToController: true"
      vm.relativeDate = moment(vm.creationDate).fromNow();
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('lms')
    .directive('acmeMalarkey', acmeMalarkey);

  /** @ngInject */
  function acmeMalarkey(malarkey) {
    var directive = {
      restrict: 'E',
      scope: {
        extraValues: '='
      },
      template: '&nbsp;',
      link: linkFunc,
      controller: MalarkeyController,
      controllerAs: 'vm'
    };

    return directive;

    function linkFunc(scope, el, attr, vm) {
      var watcher;
      var typist = malarkey(el[0], {
        typeSpeed: 40,
        deleteSpeed: 40,
        pauseDelay: 800,
        loop: true,
        postfix: ' '
      });

      el.addClass('acme-malarkey');

      angular.forEach(scope.extraValues, function(value) {
        typist.type(value).pause().delete();
      });

      watcher = scope.$watch('vm.contributors', function() {
        angular.forEach(vm.contributors, function(contributor) {
          typist.type(contributor.login).pause().delete();
        });
      });

      scope.$on('$destroy', function () {
        watcher();
      });
    }

    /** @ngInject */
    function MalarkeyController($log, githubContributor) {
      var vm = this;

      vm.contributors = [];

      activate();

      function activate() {
        return getContributors().then(function() {
          $log.info('Activated Contributors View');
        });
      }

      function getContributors() {
        return githubContributor.getContributors(10).then(function(data) {
          vm.contributors = data;

          return vm.contributors;
        });
      }
    }

  }

})();

(function() {
  'use strict';

  angular
    .module('lms')
    .factory('githubContributor', githubContributor);

  /** @ngInject */
  function githubContributor($log, $http) {
    var apiHost = 'https://api.github.com/repos/Swiip/generator-gulp-angular';

    var service = {
      apiHost: apiHost,
      getContributors: getContributors
    };

    return service;

    function getContributors(limit) {
      if (!limit) {
        limit = 30;
      }

      return $http.get(apiHost + '/contributors?per_page=' + limit)
        .then(getContributorsComplete)
        .catch(getContributorsFailed);

      function getContributorsComplete(response) {
        return response.data;
      }

      function getContributorsFailed(error) {
        $log.error('XHR Failed for getContributors.\n' + angular.toJson(error.data, true));
      }
    }
  }
})();

;(function () {
    var SignInCtrl = angular.module('lms').controller(
        'SignInController',
        ['$scope', '$state', 'api', '$rootScope', 'Idle', function ($scope, $state, api, $rootScope, Idle) {
            $scope.isAuthenticationError = api.isAuthenticationError;
            $rootScope.pageSignature = "signin";

            $scope.attemptLogin = function (email, password) {
                api.logIn(email, password).then(
                    function(user) {
                        $state.go('list_businesses');
                        Idle.watch();
                    }
                );
            };
        }]
    );
}());
(function() {
    angular.module('lms').controller(
        'MainController',
        ['$scope', '$location', '$rootScope', 'api', 'modalFactory', 'Idle', '$uibModal', function ($scope, $location, $rootScope, api, modalFactory, Idle, $uibModal) {

            var history = [];

            function closeModals() {
                if ($scope.warning) {
                    $scope.warning.close();
                    $scope.warning = null;
                }
                if ($scope.timedout) {
                    $scope.timedout.close();
                    $scope.timedout = null;
                }
            }

            $scope.$on('IdleStart', function() {
                // the user appears to have gone idle
                closeModals();
                if (api.isLoggedIn()){
                    $scope.warning = $uibModal.open({
                        templateUrl: 'warning-dialog.html',
                        windowClass: 'modal-danger'
                    });
                }
            });

            $scope.$on('IdleWarn', function(e, coundown) {
                // follows afterthe IdleStart event, but includes a countdouwn until the user is considered timed out
                // the countdown argument is the number of seconds remaining until then
                // you can change the title or display a warning dialog from here
                // you can let them resume their session by calling Idle.watch()
            });

            $scope.$on('IdleTimeout', function() {
                // the user has timed out (meaning idelDuration + timeout has passd without any activity)
                // this is where you'd log them out
                if (api.isLoggedIn()) {
                    modalFactory.closeAll();
                    api.logOut();
                    $location.path('/');
                    $scope.$apply();
                    closeModals();
                }
            });

            $scope.$on('IdleEnd', function() {
                // the user has come back from AFK and is doing stuff. if you are warning them you can use this to hide the dialog
                closeModals();
            });

            $scope.$on('Keepalive', function() {
                // do something to keep the user's session alive
            });



            // Dump the user on the login page if not logged in.
            //$rootScope.$watch(api.isLoggedIn, function(isLoggedIn, oldIsLoggedIn) {
            //    if(!isLoggedIn && oldIsLoggedIn) {
            //      $location.path('/');
            //    }
            //});

            $rootScope.$on('$stateChangeStart', function (event) {
                if (!api.isLoggedIn() && $location.path() !== '/' && $location.path() !== '/register') {
                    event.preventDefault();
                    $location.path('/');
                }
            });

            $rootScope.$on('$routeChangeSuccess', function(){
                history.push($location.$$path);
            });

            $rootScope.back = function() {

                var prevUrl = history.length > 0 ? history.splice(-1)[0] : "/";

                console.log("Previous URL: " + prevUrl);

                $location.path(prevUrl);
            };

        }]
    ).config(function(IdleProvider, KeepaliveProvider){
        // configure Idle settings
        IdleProvider.idle(900); // in seconds
        IdleProvider.timeout(10); // in seconds
        KeepaliveProvider.interval(2); // inseconds
    });
}());
(function () {
    angular.module('lms').controller(
        'MainNavigationController',
        ['$scope', 'api', function ($scope, api) {
            $scope.MainNavigation = [
                {url: '#/businesses', caption: 'Businesses', pageSignature: 'businesses'},
                {url: '#/licenses', caption: 'Licenses', pageSignature: 'licenses'},
                {url: '#/inspections', caption: 'Inspections', pageSignature: 'inspection'},
                {url: '#/configure', caption: 'Configure Settings', pageSignature: 'configure'},
                {url: '#/account', caption: 'My Account', pageSignature: 'account'},
                {url: '#/logout', caption: 'Sign Out', pageSignature: 'logout'}
            ];
            $scope.configNavigation = [
                           {url: '#/business_types', caption: 'Business Types', pageSignature: 'business_types'},
                           {url: '#/contact_types', caption: 'Contact Types', pageSignature: 'contact_types'},
                           {url: '#/contractor_types', caption: 'Contractor Types', pageSignature: 'contractor_types'},
                           {url: '#/evaluation_reasons', caption: 'Evaluation Reasons', pageSignature: 'evaluation_reasons'},
                           {url: '#/inspection_reasons', caption: 'Inspection Reasons', pageSignature: 'inspection_reasons'},
                           {url: '#/states', caption: 'States', pageSignature: 'states'}
                       ];
            $scope.api = api;

        }]
    );
}());
;(function () {
    angular.module('lms').controller(
        'LogoutController',
        ['$scope', 'api', function ($scope, api) {
            api.logOut();
        }]
    );
}());
// Controller

(function () {
    angular.module('lms').controller(
        'newLicenseModalController',
        ['$scope', '$stateParams', 'licensesFactory', 'licenseTypesFactory', 'licensePurposesFactory', 'licenseOfficialsFactory', 'modalFactory',
            function ($scope, $stateParams, licensesFactory, licenseTypesFactory, licensePurposesFactory, licenseOfficialsFactory, modalFactory) {

                var that = $scope;

                var init = function () {
                    var that = $scope;
                    that.license = {};

                    getLicenseTypes();
                    getLicensePurposes();
                    getLicenseOfficials();
                    getNewLicenseNumber();
                    setDefaults();

                    console.log('licenses_new_modal.js running...');

                };

                var getLicenseTypes = that.getLicenseTypes = function () {
                    var that = $scope;
                    licenseTypesFactory.index().then(
                        function (response) {
                            if (response.status == undefined) {
                                that.licenseTypes = response;
                            } else {
                                that.licenseTypes = [];
                            }
                        }
                    )
                };

                var getLicensePurposes = that.getLicensePurposes = function () {
                    var that = $scope;
                    licensePurposesFactory.index().then(
                        function (response) {
                            if (response.status == undefined) {
                                that.licensePurposes = response;
                            } else {
                                that.licensePurposes = [];
                            }
                        }
                    )
                };

                var getLicenseOfficials = that.getLicenseOfficials = function () {
                    var that = $scope;
                    licenseOfficialsFactory.index().then(
                        function (response) {
                            if (response.status == undefined) {
                                that.licenseOfficials = response;
                            } else {
                                that.licenseOfficials = [];
                            }
                        }
                    )
                };


                var closeModal = that.closeModal = function () {
                    console.log('closing...');
                    modalFactory.closeAll();
                };


                //var save = that.save = function () {
                //    console.log('Saving!....');
                //    var that = $scope;
                //    that.submitted = true;
                //    if (that.lick.$valid) {
                //        console.log("Current params:  " + JSON.stringify(that.license));
                //        licensesFactory.add({license: that.license})
                //            .then(
                //                function (response) {
                //                    if (response.status == undefined) {
                //                        that.$emit('addLicenseToList', response);
                //                    }
                //                }
                //            );
                //        modalFactory.closeAll();
                //
                //    }
                //};

                var getNewLicenseNumber = that.getNewLicenseNumber = function () {
                    var that = $scope;
                    licensesFactory.newNumber().then(
                        function (response) {
                            if (response.status == undefined) {
                                //console.log('Response: ' + JSON.stringify(response));
                                that.license_number = response.number;
                            }
                        }
                    )
                };


                var addYear = function (date) {

                    date = moment(date);

                    // Add date
                    date = date.add(1, 'year');

                    // if new date falls on a weekend add 1 day
                    while (date.isoWeekday() == 6 || date.isoWeekday() == 7) {
                        date = date.add(1, 'days');
                    }
                    return date;
                };

                var setDates = that.setDates = function () {
                    var that = $scope.license;
                    //that.end_date = new Date(addYear(that.begin_date));
                    //that.license.end_date = new Date(new Date().getFullYear() + '-12-31 00:00:00');
                    //that.license_year = new Date(that.begin_date).getFullYear();
                    that.license_year = new Date(that.begin_date).getFullYear();
                    that.end_date = new Date('12/31/'+ that.license_year);
                };

                var save = that.save = function () {

                    var that = $scope;

                    that.submitted = true;

                    if (that.lick.$valid) {

                        var ln = that.license;

                        newLicense = {
                          license_number: that.license_number,
                          business_id: $stateParams.businessId,
                          license_type_id: ln.license_type.id,
                          license_purpose_id: ln.license_purpose.id,
                          license_official_id: ln.license_official.id,
                          begin_date: ln.begin_date,
                          end_date: ln.end_date,
                          license_year: ln.license_year,
                          amount: ln.amount,
                          notes: ln.notes
                        };

                        licensesFactory.create({license: newLicense}).then(
                            function(response){
                                that.$emit('addLicenseToList', response);
                                closeModal();
                            }
                        );

                    };
                };

                var setDefaults = function () {
                    var that = $scope;

                    that.license.begin_date = new Date(new Date().getFullYear() + '-01-01 00:00:00');
                    that.license.end_date = new Date(new Date().getFullYear() + '-12-31 00:00:00');
                    that.license.license_year = new Date().getFullYear();
                    that.license.amount = 150.00

                };

                init();

            }
        ]
    );
}());

// Controller

(function () {
    angular.module('lms').controller(
        'newLicensesController',
        ['$scope', 'businessesFactory', 'licensesFactory', 'licenseTypesFactory', 'licensePurposesFactory', 'licenseOfficialsFactory', '$location', function ($scope, businessesFactory, licensesFactory, licenseTypesFactory, licensePurposesFactory, licenseOfficialsFactory, $location) {

            var that = $scope;



            var gotoLocation = function (path) {
                $location.path(path);
            };

            var getBusinesses = that.getBusinesses = function () {
                var that = $scope;
                businessesFactory.index().then(
                    function (response) {
                        if (response.status == undefined) {
                            console.log(JSON.stringify(response));
                            that.businesses = response.businesses;
                        } else {
                            that.businesses = [];
                        }
                    }
                )
            };

            var getLicenseTypes = that.getLicenseTypes = function () {
                var that = $scope;
                licenseTypesFactory.index().then(
                    function (response) {
                        if (response.status == undefined) {
                            that.licenseTypes = response;
                        } else {
                            that.licenseTypes = [];
                        }
                    }
                )
            };

            var getLicensePurposes = that.getLicensePurposes = function () {
                var that = $scope;
                licensePurposesFactory.index().then(
                    function (response) {
                        if (response.status == undefined) {
                            that.licensePurposes = response;
                        } else {
                            that.licensePurposes = [];
                        }
                    }
                )
            };

            var getLicenseOfficials = that.getLicenseOfficials = function () {
                var that = $scope;
                licenseOfficialsFactory.index().then(
                    function (response) {
                        if (response.status == undefined) {
                            console.log('License Officials: ' + JSON.stringify(response));
                            that.licenseOfficials = response;
                        } else {
                            that.liceseOfficials = [];
                        }
                    }
                )
            };

            var getNewLicenseNumber = that.getNewLicenseNumber = function () {
                var that = $scope;
                licensesFactory.newNumber().then(
                    function (response) {
                        if (response.status == undefined) {
                            console.log('Response: ' + JSON.stringify(response));
                            that.license_number = response.number;
                        }
                    }
                )
            };


            var addYear = function (date) {

                date = moment(date);

                // Add date
                date = date.add(1, 'year');

                // if new date falls on a weekend add 1 day
                while (date.isoWeekday() == 6 || date.isoWeekday() == 7) {
                    date = date.add(1, 'days');
                }
                return date;
            };

            // var setDates = that.setDates = function () {
            //     var that = $scope.license;
            //     //that.end_date = new Date(addYear(that.begin_date));
            //     that.end_date = new Date(new Date().getFullYear() + '-12-31 00:00:00');
            //     that.license_year = new Date(that.begin_date).getFullYear();
            // };

          var setDates = that.setDates = function(){
            //console.log('Changing date!');
            //var that = $scope.license;
            $scope.license_year = new Date($scope.begin_date).getFullYear();
            $scope.end_date = new Date('12/31/'+ $scope.license_year);
          };

            var save = that.save = function () {

                var that = $scope;

                that.submitted = true;

                if (that.lic.$valid) {
                    //console.log("License params:  " + JSON.stringify(that.lic));

                    var ln = that.license;

                    //console.log('License:  ' + JSON.stringify(ln));

                    newLicense = {
                        license_number: that.license_number,
                        business_id: ln.business,
                        license_type_id: ln.license_type,
                        license_purpose_id: ln.license_purpose,
                        license_official_id: ln.license_official,
                        begin_date: that.begin_date,
                        end_date: that.end_date,
                        license_year: that.license_year,
                        amount: that.amount,
                        notes: ln.notes
                    };

                    console.log('Saving license: ' + JSON.stringify(newLicense));

                    licensesFactory.create({license: newLicense});
                    gotoLocation('/licenses');


                };
            };

            var setDefaults  = function() {
                var that = $scope;
                that.begin_date = new Date(new Date().getFullYear() + '-01-01 00:00:00');
                that.end_date = new Date(new Date().getFullYear() + '-12-31 00:00:00');
                that.license_year = new Date().getFullYear();
                that.amount = 150.00
            };

            var init = function () {
                var that = $scope;
                that.license = {};
                getBusinesses();
                getLicenseTypes();
                getLicensePurposes();
                getLicenseOfficials();
                getNewLicenseNumber();
                setDefaults();
            };

            init();

        }
        ]
    );
}());

// Controller

(function() {
   angular.module('lms').controller(
       'editLicensesController',
       ['$scope', 'businessesFactory', 'licensesFactory', 'licenseTypesFactory','licensePurposesFactory','licenseOfficialsFactory','$location', '$stateParams', function($scope, businessesFactory, licensesFactory, licenseTypesFactory, licensePurposesFactory, licenseOfficialsFactory, $location, $stateParams)
       {

           var that = $scope;

           var init = function() {
               var that = $scope;
               getBusinesses();
               getLicenseTypes();
               getLicensePurposes();
               getLicenseOfficials();
               getLicense();
           };

           var gotoLocation = function(path){
               $location.path(path);
           };

           var getBusinesses = that.getBusinesses = function(){
               var that = $scope;
               businessesFactory.index().then(
                   function(response){
                       if(response.status == undefined) {
                         that.businesses = response.businesses;
                       } else {
                         that.businesses = [];
                       }
                   }
               )
           };

           var getLicenseTypes = that.getLicenseTypes = function(){
               var that = $scope;
               licenseTypesFactory.index().then(
                   function(response){
                       if(response.status == undefined){
                           that.licenseTypes = response;
                       } else {
                           that.licenseTypes = [];
                       }
                   }
               )
           };

            var getLicensePurposes = that.getLicensePurposes = function(){
              var that = $scope;
              licensePurposesFactory.index().then(
                  function(response){
                      if(response.status == undefined){
                          that.licensePurposes = response;
                      } else {
                          that.licensePurposes = [];
                      }
                  }
              )
            };

           var getLicenseOfficials = that.getLicenseOfficials = function(){
              var that = $scope;
              licenseOfficialsFactory.index().then(
                  function(response){
                      if(response.status == undefined){
                          that.licenseOfficials = response;
                      } else {
                          that.liceseOfficials = [];
                      }
                  }
              )
            };

           var addYear = function(date) {

              date = moment(date);

              // Add date
              date = date.add(1, 'year');

              // if new date falls on a weekend add 1 day
              while(date.isoWeekday() == 6 || date.isoWeekday() == 7) {
                  date = date.add(1, 'days');
              }
              return date;
          }

           var setDates = that.setDates = function(){
               var that = $scope.license;

               that.license_year = new Date(that.begin_date).getFullYear();
               that.end_date = new Date('12/31/'+ that.license_year);
           }

           var getLicense = that.getLicense = function(){
                licensesFactory.get($stateParams.licenseId).then(
                    function(response){
                        if(response.status == undefined) {
                            that.license = response;

                            var bd = new Date(response.begin_date);
                            var ed = new Date(response.end_date);
                            var userTimezoneOffset = new Date().getTimezoneOffset()*60000 + 3600000;

                            that.license.begin_date = new Date(bd.getTime() + userTimezoneOffset);
                            that.license.end_date = new Date(ed.getTime() + userTimezoneOffset);

                            if(that.license.active==1){that.license.active=true}else{that.license.active=false};
                            if(that.license.paid==1){that.license.paid=true}else{that.license.paid=false};
                        }else{
                            that.license = [];
                        }
                    }
                )
           };

           var save = that.save = function(){

              var that = $scope;

              that.submitted = true;

              if (that.lic.$valid){
                  console.log("License params:  " + JSON.stringify(that.license));

                  var ln = that.license;

                  if(ln.active==1){ln.active=true}else{ln.active=false};
                  if(ln.paid==1){ln.paid=true}else{ln.paid=false};

                  newLicense = {
                    id: ln.id,
                    license_number: ln.license_number,
                    business_id: ln.business,
                    license_type_id: ln.license_type,
                    license_official_id: ln.license_official,
                    license_purpose_id: ln.license_purpose,
                    begin_date: ln.begin_date,
                    end_date: ln.end_date,
                    license_year: ln.license_year,
                    amount: ln.amount,
                    notes: ln.notes,
                    active: ln.active,
                    paid: ln.paid,
                    amount_paid: ln.amount_paid
                  }

                  licensesFactory.update({license: newLicense});
                  gotoLocation('/licenses');


              }
          }

          init();

       }
       ]
   );
}());
// Controller

(function () {
  angular.module('lms').controller(
    'licensesController',
    ['$scope', '$rootScope', '$confirm', 'licensesFactory', 'pdfFactory', 'filtersFactory', 'FileSaver', 'Blob', function ($scope, $rootScope, $confirm, licensesFactory, pdfFactory, filtersFactory, FileSaver, Blob) {

      var that = $scope;

      // var getMoreResults = that.getMoreResults = function (currentPage = that.currentPage,
      //                                                      itemsPerPage = that.itemsPerPage,
      //                                                      search = that.search,
      //                                                      status = that.licensesStatus,
      //                                                      cityFilter = that.licensesCityFilter,
      //                                                      licenseTypeFilter = that.licensesLicenseTypeFilter,
      //                                                      licensePurposeFilter = that.licensesLicensePurposeFilter,
      //                                                      sortColumn = that.sortColumnz,
      //                                                      sortOrder = that.sortOrderz,
      //                                                      unpaid = that.unpaid,
      //                                                      yearFilter = that.licensesYearFilter) {
      //
      //   that = $scope;
      //
      //   var _status;
      //   if (status === true) {
      //     _status = 1;
      //   } else {
      //     _status = 0;
      //   }
      //
      //   licensesFactory.index(currentPage, itemsPerPage, search, _status, cityFilter, licenseTypeFilter, licensePurposeFilter, sortColumn, sortOrder, unpaid, yearFilter).then(
      //     function (response) {
      //
      //       if (angular.isUndefined(response.status)) {
      //         //console.log("Licenses response: " + JSON.stringify(response));
      //         that.licenses = response;
      //         that.totalLicenses = response.size;
      //       } else {
      //         that.licenses = [];
      //         that.totalLicenses = 0;
      //       }
      //     }
      //   )
      //
      //   return that;
      //
      // };

      "use strict";

      var getMoreResults = that.getMoreResults = function () {
        var currentPage = arguments.length > 0 && arguments[0] !== angular.isUndefined ? arguments[0] : that.currentPage;
        var itemsPerPage = arguments.length > 1 && arguments[1] !== angular.isUndefined ? arguments[1] : that.itemsPerPage;
        var search = arguments.length > 2 && arguments[2] !== angular.isUndefined ? arguments[2] : that.licensesSearch;
        var status = arguments.length > 3 && arguments[3] !== angular.isUndefined ? arguments[3] : that.licensesStatus;
        var cityFilter = arguments.length > 4 && arguments[4] !== angular.isUndefined ? arguments[4] : that.licensesCityFilter;
        var licenseTypeFilter = arguments.length > 5 && arguments[5] !== angular.isUndefined ? arguments[5] : that.licensesLicenseTypeFilter;
        var licensePurposeFilter = arguments.length > 6 && arguments[6] !== angular.isUndefined ? arguments[6] : that.licensesLicensePurposeFilter;
        var sortColumn = arguments.length > 7 && arguments[7] !== angular.isUndefined ? arguments[7] : that.sortColumnz;
        var sortOrder = arguments.length > 8 && arguments[8] !== angular.isUndefined ? arguments[8] : that.sortOrderz;
        var unpaid = arguments.length > 9 && arguments[9] !== angular.isUndefined ? arguments[9] : that.unpaid;
        var yearFilter = arguments.length > 10 && arguments[10] !== angular.isUndefined ? arguments[10] : that.licensesYearFilter;
        that = $scope;

        var _status;

        if (status === true) {
          _status = 1;
        } else {
          _status = 0;
        }

        licensesFactory.index(currentPage, itemsPerPage, search, _status, cityFilter, licenseTypeFilter, licensePurposeFilter, sortColumn, sortOrder, unpaid, yearFilter).then(function (response) {
          if (angular.isUndefined(response.status)) {
            //console.log("Licenses response: " + JSON.stringify(response));
            that.licenses = response;
            that.totalLicenses = response.size;
          } else {
            that.licenses = [];
            that.totalLicenses = 0;
          }
        });
        return that;
      };

      that.setCityFilter = function (obj) {
        if (typeof (obj) != "undefined") {
          var that = $scope;
          $rootScope.licensesObjCityFilter = obj;
          that.cf = [];
          that.licenses = [];
          that.lastPage = 0;
          that.currentPage = 1;
          for (var i = 0; i < obj.length; i++) {
            that.cf.push({"id": obj[i].id,"city": obj[i].city});
          }
          $rootScope.licensesCityFilter = that.licensesCityFilter = that.cf;
        }
        return that;
      };

      that.setLicenseTypeFilter = function (obj) {
        var that = $scope;
        if (typeof (obj) != "undefined") {
          that.ltf = [];
          that.licenses = [];
          that.lastPage = 0;
          that.currentPage = 1;
          for (var i = 0; i < obj.length; i++) {
            that.ltf.push({"id": obj[i].id, "name": obj[i].name});
          }
          $rootScope.licensesLicenseTypeFilter = that.licensesLicenseTypeFilter = that.ltf;
        }
        return that;
      };

      that.setYearFilter = function (obj) {
        var that = $scope;
        if (typeof(obj) != "undefined") {
          that.yf = [];
          that.licenses = [];
          that.lastPage = 0;
          that.currentPage = 1;
          for (var i = 0; i < obj.length; i++) {
            that.yf.push({"id":obj[i].id, "license_year":obj[i].license_year});
          }
          $rootScope.licensesYearFilter = that.licensesYearFilter = that.yf;
        }
        return that;
      };

      that.setLicensePurposeFilter = function (obj) {
        var that = $scope;
        if (typeof(obj) != "undefined") {
          $rootScope.licensesObjLicensePurposeFilter = obj;
          that.lpf = [];
          that.licenses = [];
          that.lastPage = 0;
          that.currentPage = 1;
          for (var i = 0; i < obj.length; i++) {
            that.lpf.push({"id":obj[i].id,"name":obj[i].name});
          }
          $rootScope.licensesLicensePurposeFilter = that.licensesLicensePurposeFilter = that.lpf;
        }
        return that;
      };

      that.setConditions = function (column, sortSwitch) {
        that = $scope;
        that.licenses = [];

        // if the column has changed then reset sortSwitch to 0
        if (that.licensesSortColumnz != column) {
          sortSwitch = 0;
        }

        that.sortSwitch = sortSwitch;
        that.sortSwitch += 1;
        if (that.sortSwitch > 2) {
          that.sortSwitch = 0;
        }


        console.log('New Sort Switch:  ' + that.sortSwitch);

        that.sortColumnz = column;

        switch(that.sortSwitch) {
          case 0:
            that.sortColumnz = null;
            that.sortOrderz = null;
            $rootScope.licensesSortColumnz = null;
            that.licensesSortColumnz = null;
            that.licensesSortOrderz = null;
            $rootScope.sortColumnz = null;
            break;
          case 1:
            console.log('Case 1 - Met');
            that.sortOrderz = 'asc';
            that.licensesSortOrderz = that.sortOrderz;
            $rootScope.licensesSortOrderz = that.sortOrderz;
            that.sortReverse = false;
            that.licensesSortColumnz = column;
            $rootScope.licensesSortColumnz = column;
            break;
          case 2:
            console.log('Case 2 - Met');
            that.sortOrderz = 'desc';
            that.licensesSortOrderz = that.sortOrderz;
            $rootScope.licensesSortOrderz = that.sortOrderz;
            that.sortReverse = true;
            that.licensesSortColumnz = column;
            $rootScope.licensesSortColumnz = column;
            break;
        }

        that.lastPage = 0;
        that.currentPage = 1;
        getMoreResults(that.currentPage, that.itemsPerPage,
          that.licensesSearch, that.licensesStatus,
          that.licensesCityFilter, that.licensesLicenseTypeFilter,
          that.licensesLicensePurposeFilter, that.licensesSortColumnz,
          that.licensesSortOrderz, that.unpaid,
          that.licensesYearFilter);
      };

      that.clearSearch = function() {
        that = $scope;
        that.licensesSearch = null;
        getMoreResults();
      };


      that.removeLicense = function (item) {
        var that = $scope;

        $confirm({
          text: 'Are you sure you want to delete this license?',
          title: 'Delete License',
          ok: 'Yes',
          cancel: 'No'
        })
          .then(function () {
            licensesFactory.remove(that.licenses.licenses[item].id).then(
              function (response) {
                if (response.status == undefined) {
                  that.licenses.licenses.splice(item, 1);
                }
              }
            )
          });

      };

      that.createLicensePDF = function (item) {

        var that = $scope;

        pdfFactory.create(that.licenses.licenses[item].id).then(
          function (response) {
            if (response.status == undefined) {
              var file = new Blob([response], {type: 'application/pdf'});
              FileSaver.saveAs(file, 'license.pdf');
            }
          }
        )


      };

      var populateYears = that.populateYears = function () {
        that = $scope;

        filtersFactory.years().then(
          function (response) {

            //console.log("populateYears called. years response: " + JSON.stringify(response));

            if (response.status == undefined) {
              for (var i = 0; i < response.length; i++) {
                that.years.push(response[i]);
              }
            }

          }
        );
      };

      var populateCities = that.populateCities = function () {
        that = $scope;

        filtersFactory.cities().then(
          function (response) {

            if (response.status == undefined) {
              for (var i = 0; i < response.length; i++) {
                that.cities.push(response[i]);
              }
            }

          }
        );
      };

      var populateLicenseTypes = that.populateLicenseTypes = function () {
        that = $scope;
        filtersFactory.licenseTypes().then(
          function (response) {

            if (response.status == undefined) {
              for (var i = 0; i < response.length; i++) {
                that.licenseTypes.push(response[i]);
              }
            }
          }
        );
      };

      var populateLicensePurposes = that.populateLicensePurposes = function () {
        that = $scope;
        filtersFactory.licensePurposes().then(
          function (response) {

            if (response.status == undefined) {
              for (var i = 0; i < response.length; i++) {
                that.licensePurposes.push(response[i]);
              }
            }
          }
        );
      };

      that.exportLicenses = function() {
        that = $scope;

        licensesFactory.export(that.licensesSearch, that.licensesStatus, that.licensesYearFilter, that.licensesCityFilter, that.licensesLicenseTypeFilter, that.licensesLicensePurposeFilter, that.licensesSortColumnz, that.licensesSortOrderz).then(
          function (response) {
            if (response.status == undefined) {
              var data = new Blob([response], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'}, true);
              FileSaver.saveAs(data, 'licenses.xlsx');
            }
          }
        );
      }
      var init = function () {

        var that = $scope;

        that.currentPage = that.currentPage || 1;
        that.itemsPerPage = that.itemsPerPage || 65;
        that.lastPage = 0;

        that.licensesSearch = that.licensesSearch || [];
        that.licensesStatus = that.licensesStatus || true;

        that.licensesCityFilter = that.licensesCityFilter || [];
        that.licensesLicenseTypeFilter = that.licensesLicenseTypeFilter || [];
        that.licensesLicensePurposeFilter = that.licensesLicensePurposeFilter || [];
        that.licensesYearFilter = that.licensesYearFilter || [];

        that.sortColumnz = that.licensesSortColumnz = that.licensesSortColumnz || 'business_name';
        that.sortOrderz = that.licensesSortOrderz = that.licensesSortOrderz || 'asc';

        that.lunpaid = false;
        that.licenses = [];

        that.licenseTypes = [];
        that.licensePurposes = [];
        that.cities = [];
        that.years = [];

        that.sortColumnz = 'end_date';

        that.sortSwitch = 0;

        getMoreResults();

      };
      init();
      populateCities();
      populateLicenseTypes();
      populateLicensePurposes();
      populateYears();
    }
    ]
  );
}());

// Controller

(function () {
    angular.module('lms').controller(
        'editLicenseModalController',
        ['$scope', '$rootScope', '$stateParams', 'licenseTypesFactory', 'licensesFactory', 'licensePurposesFactory', 'licenseOfficialsFactory', 'modalFactory',
            function ($scope, $rootScope, $stateParams, licenseTypesFactory, licensesFactory, licensePurposesFactory, licenseOfficialsFactory, modalFactory) {

                var that = $scope;


                var init = function () {
                    //var that = $scope;
                    that.license = {};
                    that.getLicense();
                    that.getLicenseTypes();
                    that.getLicensePurposes();
                    that.getLicenseOfficials();

                };

                var getLicense = that.getLicense = function () {
                    licensesFactory.get($rootScope.licenseParams.licenseId).then(
                        function (response) {
                            if (response.status == undefined) {
                                that.license = response;

                                // fix stupid javascript date display
                                // new Date(response.inspected_on.replace(new RegExp("-", 'g'), "/") - different way

                                var bd = new Date(response.begin_date);
                                var ed = new Date(response.end_date);
                                var userTimezoneOffset = new Date().getTimezoneOffset()*60000 + 3600000;
                                //getTimezoneOffset() by itself was only adding 4 hours instead of 5

                                that.license.begin_date = new Date(bd.getTime() + userTimezoneOffset);
                                that.license.end_date = new Date(ed.getTime() + userTimezoneOffset);
                                if (that.license.active == 1) {
                                    that.license.active = true
                                } else {
                                    that.license.active = false
                                }
                                ;
                                if (that.license.paid == 1) {
                                    that.license.paid = true
                                } else {
                                    that.license.paid = false
                                }
                                ;
                            } else {
                                that.license = [];
                            }
                        }
                    )
                };

                var getLicenseTypes = that.getLicenseTypes = function () {
                    var that = $scope;
                    licenseTypesFactory.index().then(
                        function (response) {
                            if (response.status == undefined) {
                                that.licenseTypes = response;
                            } else {
                                that.licenseTypes = [];
                            }
                        }
                    )
                };

                var getLicensePurposes = that.getLicensePurposes = function () {
                    var that = $scope;
                    licensePurposesFactory.index().then(
                        function (response) {
                            if (response.status == undefined) {
                                that.licensePurposes = response;
                            } else {
                                that.licensePurposes = [];
                            }
                        }
                    )
                };

                var getLicenseOfficials = that.getLicenseOfficials = function () {
                    var that = $scope;
                    licenseOfficialsFactory.index().then(
                        function (response) {
                            if (response.status == undefined) {
                                that.licenseOfficials = response;
                            } else {
                                that.licenseOfficials = [];
                            }
                        }
                    )
                };


                var closeModal = that.closeModal = function () {
                    console.log('closing...');
                    modalFactory.closeAll();
                };


                var save = that.save = function () {

                    var that = $scope;

                    that.submitted = true;

                    if (that.lick.$valid) {

                        console.log("Current params:  " + JSON.stringify(that.license));

                        var ln = that.license;

                        if(ln.active==1){ln.active=true}else{ln.active=false};
                        if(ln.paid==1){ln.paid=true}else{ln.paid=false};

                          newLicense = {
                            id: ln.id,
                            license_number: ln.license_number,
                            business_id: ln.business,
                            license_type_id: ln.license_type.id,
                            license_official_id: ln.license_official.id,
                            license_purpose_id: ln.license_purpose.id,
                            begin_date: ln.begin_date,
                            end_date: ln.end_date,
                            license_year: ln.license_year,
                            amount: ln.amount,
                            notes: ln.notes,
                            active: ln.active,
                            paid: ln.paid,
                            amount_paid: ln.amount_paid
                          }

                        licensesFactory.update({license: newLicense})
                            .then(
                                function (response) {
                                    if (response.status == undefined) {
                                        that.$emit('updateLicenseInList', response);
                                    }
                                }
                            );
                        modalFactory.closeAll();

                    }
                }



                init();

            }
        ]
    );
}());
// Controller

(function() {
   angular.module('lms').controller(
       'newInspectionsController',
       ['$scope', 'inspectionTypesFactory', 'inspectionsFactory', 'businessesFactory', 'inspectionReasonsFactory', 'evaluationStatusesFactory','licenseOfficialsFactory','$location',
           function($scope, inspectionTypesFactory, inspectionsFactory, businessesFactory, inspectionReasonsFactory, evaluationStatusesFactory, licenseOfficialsFactory, $location)
       {

           var that = $scope;

           var init = function() {
               var that = $scope;
               that.inspection = {};

               getInspectionTypes();
               getBusinesses();
               getInspectionReasons();
               getEvaluationStatuses();
               getLicenseOfficials();


           };

           var gotoLocation = function(path){
               $location.path(path);
           };

           var getLicenseOfficials = function () {
               var that = $scope;
               licenseOfficialsFactory.index().then(
                   function (response) {

                       //console.log('Testing:  ' + JSON.stringify(response));

                       if (response.status == undefined) {
                           that.inspectors = response;
                       } else {
                           that.inspectors = [];
                       }
                   }
               )
           };

           var getInspectionTypes = function(){
               var that = $scope;
               inspectionTypesFactory.index().then(
                   function(response){
                       if(response.status == undefined){
                           that.inspectionTypes = response;
                       } else {
                           that.inspectionTypes = [];
                       }
                   }
               )
           };

           var getBusinesses = function(){
              var that = $scope;
              businessesFactory.index().then(
                  function(response){
                      if(response.status == undefined){
                          that.businesses = response.businesses;
                      } else {
                          that.businesses = [];
                      }
                  }
              )
          };

           var getInspectionReasons = function(){
                 var that = $scope;
                 inspectionReasonsFactory.index().then(
                     function(response){

                         console.log('Reasons:  ' + JSON.stringify(response));

                         if(response.status == undefined){
                             that.reasons = response;
                         } else {
                             that.reasons = [];
                         }
                     }
                 )
             };

           var getEvaluationStatuses = function(){
                var that = $scope;
                evaluationStatusesFactory.index().then(
                    function(response){

                        console.log('Reasons:  ' + JSON.stringify(response));

                        if(response.status == undefined){
                            that.evaluationStatuses = response;
                        } else {
                            that.evaluationStatuses = [];
                        }
                    }
                )
            };

           var save = that.save = function(){

              var that = $scope;

              that.submitted = true;

              if (that.inspect.$valid){

                  var ni = that.inspection;

                  var newInspection = {
                      inspected_on: ni.inspected_on,
                      inspection_type_id: ni.inspection_type.id,
                      business_id: ni.business.id,
                      inspection_reason_id: ni.inspection_reason.id,
                      inspector_id: ni.inspector,
                      evaluation_status_id: ni.evaluation_status.id,
                      notes: ni.notes,
                      next_inspection_on: ni.next_inspection_on
                  };

                  //console.log("Current params:  " + JSON.stringify(that.inspection));

                  inspectionsFactory.create({inspection: newInspection});
                  gotoLocation('/inspections');

              }
          }

          init();

       }
       ]
   );
}());
// Controller

(function () {
  angular.module('lms').controller(
    'inspectionsController',
    ['$scope', '$rootScope', '$confirm', 'inspectionsFactory', 'filtersFactory', 'FileSaver', 'Blob', 'apiUrl', 'apiPort', function ($scope, $rootScope, $confirm, inspectionsFactory, filtersFactory, FileSaver, Blob, apiUrl, apiPort) {

      var that = $scope;

      var getInspections = that.getInspections = function () {
        var currentPage = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : that.currentPage;
        var itemsPerPage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : that.itemsPerPage;
        var search = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : that.inspectionsSearchFilter;
        var inspectionType = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : that.inspectionsInspectionTypeFilter;
        var businessType = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : that.inspectionsBusinessType;
        var cityFilter = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : that.inspectionsCityFilter;
        var sortColumn = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : that.inspectionsSortColumnz;
        var sortOrder = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : that.inspectionsSortOrderz;
        var status = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : that.inspectionsStatus;
        var inspectionOnBegin = arguments.length > 9 && arguments[9] !== undefined ? arguments[9] : that.inspectionsInspectionOnBegin;
        var inspectionOnEnd = arguments.length > 10 && arguments[10] !== undefined ? arguments[10] : that.inspectionsInspectionOnEnd;



        console.log('Arguments:' + JSON.stringify(arguments));


        var _status;

        if (status == true) {
          _status = 1;
        } else {
          _status = 0;
        }

        inspectionsFactory.index(currentPage, itemsPerPage, search, inspectionType, businessType, cityFilter, sortColumn, sortOrder, _status, inspectionOnBegin, inspectionOnEnd).then(function (response) {
          if (response.status == undefined) {
            that.inspections = response;
            that.totalInspections = response.size;
          } else {
            that.inspections = [];
            that.totalInspections = 0;
          }
        });
      };

      var populateBusinessTypes = that.populateBusinessTypes = function () {
        that = $scope;
        filtersFactory.businessTypes().then(
          function (response) {
            if (response.status == undefined) {
              for (var i = 0; i < response.length; i++) {
                that.businessTypes.push(response[i]);
              }
            }
          }
        );
      };

      var populateCities = that.populateCities = function () {
        that = $scope;
        filtersFactory.cities().then(
          function (response) {
            if (response.status == undefined) {
              for (var i = 0; i < response.length; i++) {
                that.cities.push(response[i]);
              }
            }
          }
        );
      };

      var populateInspectionTypes = that.populateInspectionTypes = function () {
        filtersFactory.inspectionTypes().then(
          function (response) {
            if (response.status == undefined) {
              for (var i = 0; i < response.length; i++) {
                that.inspectionTypes.push(response[i]);
              }
            }
          }
        );
      };

      that.setConditions = function (column, sortSwitch) {
        that = $scope;
        that.inspections = [];

        // if the column has changed then reset sortSwitch to 0
        if (that.inspectionsSortColumnz != column) {
          sortSwitch = 0;
        }

        that.sortSwitch = sortSwitch;
        that.sortSwitch += 1;
        if (that.sortSwitch > 2) {
          that.sortSwitch = 0;
        }

        console.log('New Sort Switch:  ' + that.sortSwitch);

        that.sortColumnz = column;

        switch(that.sortSwitch) {
          case 0:
            that.sortColumnz = null;
            that.sortOrderz = null;
            $rootScope.inspectionsSortColumnz = null;
            that.inspectionsSortColumnz = null;
            that.inspectionsSortOrderz = null;
            $rootScope.sortColumnz = null;
            break;
          case 1:
            console.log('Case 1 - Met');
            that.sortOrderz = 'asc';
            that.inspectionsSortOrderz = that.sortOrderz;
            $rootScope.inspectionsSortOrderz = that.sortOrderz;
            that.sortReverse = false;
            that.inspectionsSortColumnz = column;
            $rootScope.inspectionsSortColumnz = column;
            break;
          case 2:
            console.log('Case 2 - Met');
            that.sortOrderz = 'desc';
            that.inspectionsSortOrderz = that.sortOrderz;
            $rootScope.inspectionsSortOrderz = that.sortOrderz;
            that.sortReverse = true;
            that.inspectionsSortColumnz = column;
            $rootScope.inspectionsSortColumnz = column;
            break;
        }



        console.log('Sort Column:  ' + that.inspectionsSortColumnz);
        console.log('Sort Direction:  ' + that.inspectionsSortOrderz);

        that.lastPage = 0;
        that.currentPage = 1;

        getInspections(that.currentPage,
          that.itemsPerPage,
          that.inspectionsSearchFilter,
          that.inspectionsInspectionTypeFilter,
          that.inspectionsBusinessType,
          that.inspectionsCityFilter,
          that.inspectionsSortColumnz,
          that.inspectionsSortOrderz,
          that.inspectionsStatus,
          that.inspectionsInspectionOnBegin,
          that.inspectionsInspectionOnEnd,
          that.inspectionsInspectionTypeFilter,
          that.inspectionsBusinessType,
          that.inspectionsCityFilter,
          that.inspectionsSortColumnz,
          that.inspectionsSortOrderz,
          that.inspectionsStatus,
          that.inspectionsInspectionOnBegin,
          that.inspectionsInspectionOnEnd);
      };

      that.clearSearch = function() {
        that = $scope;
        that.inspectionsSearchFilter = null;
        getInspections();
      };

      that.setInspectionTypeFilter = function (obj) {

        //console.log('attempting to set inspection type filter');
        //console.log(obj);
        if (typeof (obj) != "undefined") {
          var that = $scope;
          that.itf = [];
          that.inspections = [];
          that.lastPage = 0;
          that.currentPage = 1;
          for (var i = 0; i < obj.length; i++) {
            that.itf.push({"id":obj[i].id,"name":obj[i].name});
          }
          $rootScope.inspectionsInspectionTypeFilter = that.inspectionsInspectionTypeFilter = that.itf;
        }
        return that;

      };

      that.setBusinessTypeFilter = function (obj) {

        //console.log('attempting to set business type filter');
        //console.log(obj);

        if (typeof(obj) != "undefined") {
          var that = $scope;
          that.btf = [];
          that.inspections = [];
          that.lastPage = 0;
          that.currentPage = 1;
          for (var i = 0; i < obj.length; i++) {
            that.btf.push({"id":obj[i].id, "name":obj[i].name});
          }
          $rootScope.inspectionsBusinessFilter = that.inspectionsBusinessType = that.btf;
        }
        return that;

      };

      that.resetPages = function () {
        var that = $scope;
        that.lastPage = 0;
        that.currentPage = 1;
        that.inspections = [];
      };

      that.setCityFilter = function (obj) {
        if (typeof (obj) != "undefined") {
          var that = $scope;
          that.cf = [];
          that.inspections = [];
          that.lastPage = 0;
          that.currentPage = 1;
          for (var i = 0; i < obj.length; i++) {
            that.cf.push({"id":obj[i].id, "name":obj[i].city});
          }
          $rootScope.inspectionsCityFilter = that.inspectionsCityFilter = that.cf;
        }
        return that;
      };

      that.removeInspection = function (item) {
        var that = $scope;

        //console.log('Attempting to remove:  ' + JSON.stringify(that.inspections));

        $confirm({
          text: 'Are you sure you want to remove this inspection?',
          title: 'Remove Inspection',
          ok: 'Yes',
          cancel: 'No'
        })
          .then(function () {
            inspectionsFactory.remove(that.inspections.inspections[item].id).then(
              function (response) {
                if (response.status == undefined) {
                  that.inspections.inspections.splice(item, 1);
                }
              }
            )
          });

      };

      that.exportInspections = function() {
        that = $scope;

        inspectionsFactory.export(
          that.inspectionsSearchFilter,
          that.inspectionsInspectionTypeFilter,
          that.inspectionsBusinessType,
          that.inspectionsCityFilter,
          that.inspectionsStatus,
          that.inspectionsInspectionOnBegin,
          that.inspectionsInspectionOnEnd,
          that.inspectionsSortColumnz,
          that.inspectionsSortOrderz).then(
          function (response) {
            if (response.status == undefined) {
              var data = new Blob([response], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'}, true);
              FileSaver.saveAs(data, 'inspections.xlsx');
            }
          }
        );
      }

      var init = function () {

        var that = $scope;

        that.currentPage = that.currentPage || 1;
        that.itemsPerPage = that.itemsPerPage || 65;
        that.inspectionsSearchFilter = that.inspectionsSearchFilter || [];
        that.inspectionsStatus = that.inspectionsStatus || true;
        that.inspectionsInspectionOnBegin = that.inspectionsInspectionOnBegin || null;
        that.inspectionsInspectionOnEnd = that.inspectionsInspectionOnEnd || null;
        that.inspectionsInspectionTypeFilter = that.inspectionsInspectionTypeFilter || [];
        that.inspectionsBusinessType = that.inspectionsBusinessType || [];
        that.inspectionsCityFilter = that.inspectionsCityFilter || [];

        that.businessTypes = [];
        that.cities = [];
        that.inspectionTypes = [];
        that.lastPage = 0;
        that.inspections = getInspections();
        that.sortSwitch = 0;
        
        $scope.apiUrl = apiUrl;
        $scope.apiPort = apiPort;
      };

      init();
      populateBusinessTypes();
      populateCities();
      populateInspectionTypes();

    }


    ]
  );
}());

// Controller

(function () {
    angular.module('lms').controller(
        'viewInspectionController',
        ['$scope', '$rootScope', 'inspectionTypesFactory', 'inspectionsFactory', 'businessesFactory', 'inspectionReasonsFactory', 'evaluationStatusesFactory', 'licenseOfficialsFactory','$location', '$stateParams',
            function ($scope, $rootScope, inspectionTypesFactory, inspectionsFactory, businessesFactory, inspectionReasonsFactory, evaluationStatusesFactory, licenseOfficialsFactory, $location, $stateParams) {

                var that = $scope;

                console.log('Editing Inspection!');

                var init = function () {
                    var that = $scope;
                    that.inspection = {};

                    getInspection();

                };

                var getInspection = that.getInspection = function () {
                    inspectionsFactory.get($stateParams.inspectionId).then(
                        function (response) {
                            if (response.status == undefined) {
                                that.inspection = response;
                            } else {
                                that.inspection = [];
                            }
                        }
                    )
                };

                init();

            }
        ]
    );
}());
// Controller

(function () {
    angular.module('lms').controller(
        'newInspectionsModalController',
        ['$scope', '$stateParams', 'inspectionTypesFactory', 'inspectionsFactory', 'inspectionReasonsFactory', 'licenseOfficialsFactory', 'evaluationStatusesFactory', 'modalFactory', '$location',
            function ($scope, $stateParams, inspectionTypesFactory, inspectionsFactory, inspectionReasonsFactory, licenseOfficialsFactory, evaluationStatusesFactory, modalFactory, $location) {

                var that = $scope;

                var init = function () {
                    var that = $scope;
                    that.inspection = {};

                    getInspectionTypes();
                    getInspectionReasons();
                    getEvaluationStatuses();
                    getLicenseOfficials();


                };

                var gotoLocation = function (path) {
                    $location.path(path);
                };

                var getInspectionTypes = function () {
                    var that = $scope;
                    inspectionTypesFactory.index().then(
                        function (response) {
                            if (response.status == undefined) {
                                that.inspectionTypes = response;
                            } else {
                                that.inspectionTypes = [];
                            }
                        }
                    )
                };

                var getInspectionReasons = function () {
                    var that = $scope;
                    inspectionReasonsFactory.index().then(
                        function (response) {

                            //console.log('Reasons:  ' + JSON.stringify(response));

                            if (response.status == undefined) {
                                that.reasons = response;
                            } else {
                                that.reasons = [];
                            }
                        }
                    )
                };

                var getEvaluationStatuses = function () {
                    var that = $scope;
                    evaluationStatusesFactory.index().then(
                        function (response) {
                            //console.log('Reasons:  ' + JSON.stringify(response));
                            if (response.status == undefined) {
                                that.evaluationStatuses = response;
                            } else {
                                that.evaluationStatuses = [];
                            }
                        }
                    )
                };

                var getLicenseOfficials = function () {
                    var that = $scope;
                    licenseOfficialsFactory.index().then(
                        function (response) {
                            if (response.status == undefined) {
                                that.licenseOfficials = response;
                            } else {
                                that.licenseOfficials = [];
                            }
                        }
                    )
                };

                var closeModal = that.closeModal = function () {
                    //console.log('closing...');
                    modalFactory.closeAll();
                };

                var save = that.save = function () {

                    var that = $scope;

                    that.submitted = true;

                    if (that.inspect.$valid) {

                        var ni = that.inspection;

                        var newInspection = {
                            inspected_on: ni.inspected_on,
                            inspection_type_id: ni.inspection_type.id,
                            business_id: $stateParams.businessId,
                            inspection_reason_id: ni.inspection_reason.id,
                            inspector_id: ni.inspector.id,
                            evaluation_status_id: ni.evaluation_status.id,
                            notes: ni.notes,
                            next_inspection_on: ni.next_inspection_on
                        };

                        //console.log("Current params:  " + JSON.stringify(that.inspection));

                        inspectionsFactory.create({
                            businessId: $stateParams.businessId,
                            inspection: newInspection
                        }).then(
                            function (response) {
                                if (response.status == undefined) {
                                    console.log('Passing data to parent....');
                                    that.$emit('addInspectionToList', response);
                                }
                            }
                        );
                        modalFactory.closeAll();

                        //gotoLocation('/inspections');

                    }
                    /*
                        Reload the page after saving an inspection. This fixes the bug of the wrong inspection being shown in the modal
                        that pops up if you edit or view an inspection right after adding a new one.
                    */
                    //location.reload();
                }

                init();

            }
        ]
    );
}());
// Controller

(function () {
    angular.module('lms').controller(
        'editInspectionsModalController',
        ['$scope', '$rootScope', '$stateParams', 'inspectionTypesFactory', 'inspectionsFactory', 'inspectionReasonsFactory', 'licenseOfficialsFactory', 'evaluationStatusesFactory', 'modalFactory', '$location',
            function ($scope, $rootScope, $stateParams, inspectionTypesFactory, inspectionsFactory, inspectionReasonsFactory, licenseOfficialsFactory, evaluationStatusesFactory, modalFactory, $location) {

                var that = $scope;

                var init = function () {
                    var that = $scope;
                    that.inspection = {};


                    getInspectionTypes();
                    getInspectionReasons();
                    getEvaluationStatuses();
                    getLicenseOfficials();
                    getInspection();


                };

                var getInspection = function() {
                    inspectionsFactory.get($rootScope.inspectionParams.inspectionId).then(
                        function(response) {
                            if (response.status == undefined) {
                                that.inspection = response;
                                that.inspection.inspected_on = new Date(response.inspected_on.replace(new RegExp("-", 'g'),"/"));
                                that.inspection.next_inspection_on = new Date(response.next_inspection_on.replace(new RegExp("-", 'g'),"/"));
                            } else {
                                that.inspection = [];
                            }
                        }
                    )
                };

                var getInspectionTypes = function () {
                    var that = $scope;
                    inspectionTypesFactory.index().then(
                        function (response) {
                            if (response.status == undefined) {
                                that.inspectionTypes = response;
                            } else {
                                that.inspectionTypes = [];
                            }
                        }
                    )
                };

                var getInspectionReasons = function () {
                    var that = $scope;
                    inspectionReasonsFactory.index().then(
                        function (response) {
                            if (response.status == undefined) {
                                that.reasons = response;
                            } else {
                                that.reasons = [];
                            }
                        }
                    )
                };

                var getEvaluationStatuses = function () {
                    var that = $scope;
                    evaluationStatusesFactory.index().then(
                        function (response) {
                            //console.log('Reasons:  ' + JSON.stringify(response));
                            if (response.status == undefined) {
                                that.evaluationStatuses = response;
                            } else {
                                that.evaluationStatuses = [];
                            }
                        }
                    )
                };

                var getLicenseOfficials = function () {
                    var that = $scope;
                    licenseOfficialsFactory.index().then(
                        function (response) {
                            if (response.status == undefined) {
                                that.licenseOfficials = response;
                            } else {
                                that.licenseOfficials = [];
                            }
                        }
                    )
                };

                var closeModal = that.closeModal = function () {
                    //console.log('closing...');
                    modalFactory.closeAll();
                };

                var save = that.save = function () {

                    var that = $scope;

                    that.submitted = true;

                    if (that.inspect.$valid) {

                        var ni = that.inspection;

                        var newInspection = {
                            id: ni.id,
                            inspected_on: ni.inspected_on,
                            inspection_type_id: ni.inspection_type.id,
                            business_id: $stateParams.businessId,
                            inspection_reason_id: ni.inspection_reason.id,
                            inspector_id: ni.inspector.id,
                            evaluation_status_id: ni.evaluation_status.id,
                            notes: ni.notes,
                            next_inspection_on: ni.next_inspection_on
                        };

                        console.log("Current params:  " + JSON.stringify(that.inspection));

                        inspectionsFactory.update({
                            id: ni.id,
                            businessId: $stateParams.businessId,
                            inspection:newInspection
                        }).then(
                            function (response) {
                                if (response.status == undefined) {
                                    //console.log('Passing data to parent....');
                                    that.$emit('updateInspectionInList', response);
                                }
                            }
                        );
                        modalFactory.closeAll();

                        //gotoLocation('/inspections');

                    }
                }

                init();

            }
        ]
    );
}());
// Controller

(function () {
    angular.module('lms').controller(
        'editInspectionsController',
        ['$scope', '$rootScope', 'inspectionTypesFactory', 'inspectionsFactory', 'businessesFactory', 'inspectionReasonsFactory', 'evaluationStatusesFactory', 'licenseOfficialsFactory','$location', '$stateParams',
            function ($scope, $rootScope, inspectionTypesFactory, inspectionsFactory, businessesFactory, inspectionReasonsFactory, evaluationStatusesFactory, licenseOfficialsFactory, $location, $stateParams) {

                var that = $scope;

                console.log('Editing Inspection!');

                var init = function () {
                    var that = $scope;
                    that.inspection = {};

                    getInspectionTypes();
                    getBusinesses();
                    getInspectionReasons();
                    getEvaluationStatuses();
                    getLicenseOfficials();
                    getInspection();


                };

                var gotoLocation = function (path) {
                    $location.path(path);
                };

                var getLicenseOfficials = function () {
                    var that = $scope;
                    licenseOfficialsFactory.index().then(
                        function (response) {

                           // console.log('Testing:  ' + JSON.stringify(response));

                            if (response.status == undefined) {
                                that.inspectors = response;
                            } else {
                                that.inspectors = [];
                            }
                        }
                    )
                };

                var getInspectionTypes = function () {
                    var that = $scope;
                    inspectionTypesFactory.index().then(
                        function (response) {
                            if (response.status == undefined) {
                                that.inspectionTypes = response;
                            } else {
                                that.inspectionTypes = [];
                            }
                        }
                    )
                };

                var getBusinesses = function () {
                    var that = $scope;
                    businessesFactory.index().then(
                        function (response) {

                            //console.log('Businesses:  ' + JSON.stringify(response));

                            if (response.status == undefined) {
                                that.businesses = response.businesses;
                            } else {
                                that.businesses = [];
                            }
                        }
                    )
                };

                var getInspectionReasons = function () {
                    var that = $scope;
                    inspectionReasonsFactory.index().then(
                        function (response) {

                            //console.log('Reasons:  ' + JSON.stringify(response));

                            if (response.status == undefined) {
                                that.reasons = response;
                            } else {
                                that.reasons = [];
                            }
                        }
                    )
                };

                var getEvaluationStatuses = function () {
                    var that = $scope;
                    evaluationStatusesFactory.index().then(
                        function (response) {

                            //console.log('Reasons:  ' + JSON.stringify(response));

                            if (response.status == undefined) {
                                that.evaluationStatuses = response;
                            } else {
                                that.evaluationStatuses = [];
                            }
                        }
                    )
                };

                var getInspection = that.getInspection = function () {
                    inspectionsFactory.get($stateParams.inspectionId).then(
                        function (response) {
                            if (response.status == undefined) {
                                that.inspection = response;
                                that.inspection.inspected_on = new Date(response.inspected_on.replace(new RegExp("-", 'g'), "/"));
                                that.inspection.next_inspection_on = new Date(response.next_inspection_on.replace(new RegExp("-", 'g'), "/"));
                                //console.log("Returned inspection record: " + JSON.stringify(that.inspection));
                            } else {
                                that.inspection = [];
                            }
                        }
                    )
                };

                var save = that.save = function () {

                    var that = $scope;

                    that.submitted = true;

                    if (that.inspect.$valid) {

                        var ni = that.inspection;

                        var newInspection = {
                            id: ni.id,
                            inspected_on: ni.inspected_on,
                            inspection_type_id: ni.inspection_type.id,
                            business_id: ni.business.id,
                            inspection_reason_id: ni.inspection_reason.id,
                            inspector_id: ni.inspector,
                            evaluation_status_id: ni.evaluation_status.id,
                            notes: ni.notes,
                            next_inspection_on: ni.next_inspection_on
                        };

                        console.log("Current params:  " + JSON.stringify(that.inspection));

                        inspectionsFactory.update({inspection: newInspection});
                        gotoLocation('/inspections');

                    }
                }

                init();

            }
        ]
    );
}());
;(function () {
    'use strict';

    var storageEngineFactory = function () {
        var items = {},

            getItem = function (name) {
                if (window.sessionStorage) {
                    var jsonString = sessionStorage.getItem(name);
                    return !! jsonString ? JSON.parse(jsonString) : null;
                } else {
                    return (name in items) ? items[name] : null;
                }
            },

            setItem = function (name, value) {
                console.log('Setting cookie!');
                if (window.sessionStorage) {
                    return sessionStorage.setItem(name, JSON.stringify(value));
                } else {
                    items[name] = value;
                }
            },

            removeItem = function (name) {
                console.log('Remove cookie!');
                if (window.sessionStorage) {
                    return sessionStorage.removeItem(name);
                } else {
                    delete items[name];
                }
            };
        return {
            getItem: getItem,
            setItem: setItem,
            removeItem: removeItem
        };
    };

    angular.module('lms').factory('storageEngine', storageEngineFactory);
}());
// Factory

(function(){

    'use strict';

    var statesFactory = function($q, api) {
        var that = {};

        var index = that.index = function () {
            return api.http({
                url: 'states',
                method: 'get'
            });
        };

        var get = that.get = function (stateId) {
            return api.http({
                url: 'states/' + stateId,
                method: 'get'
            });
        };

        var create = that.create = function (state) {
            var newState = Object.assign({}, state);
            return api.http({
                url: 'states',
                method: 'post',
                data: newState
            })
        };

        var update = that.update = function (state) {
            var newState = Object.assign({}, state);
            return api.http({
                url: 'state/' + state.id,
                method: 'patch',
                data: newState
            });
        };

        var remove = that.remove = function (stateId) {
            return api.http({
                url: 'states/' + stateId,
                method: 'delete'
            })
        }

        return that;
    };

    angular.module('lms').factory('statesFactory',['$q', 'api', statesFactory]);

}());
// Factory

(function(){

    'use strict';

    var pdfFactory = function($q, api) {
        var that = {};

        var create = that.create = function(item){

            //console.log('Item:  ' + item);

            return api.http({
                url: 'pdf/license/' + item,
                method: 'post'
            });
        };

        return that;
    };

    angular.module('lms').factory('pdfFactory',['$q', 'api', pdfFactory]);

}());
// Factory

(function(){

    'use strict';

    var modalFactory = function(vModal) {

        var that = {};
        var currentModal;

        var showModal = that.showModal = function(controller, template) {
            return currentModal = vModal({
                controller: controller,
                templateUrl: template
            });
        };

        var closeAll = that.closeAll = function(){
            if (currentModal && currentModal.deactivate){
                currentModal.deactivate();
                currentModal = null;
            };
        };

        return that;
    };

    angular.module('lms').factory('modalFactory', ['vModal', modalFactory]);

}());
"use strict";

// Factory
(function () {
  'use strict';

  var licensesFactory = function licensesFactory($q, api) {
    var that = {};

    that.index = function (page, perPage, q, status, cityFilter, licenseTypeFilter, licensePurposeFilter, sort_column, sort_order, unpaid, yearFilter) {
      var _cityFilter, _licenseTypeFilter, _licensePurposeFilter, _yearFilter; // change cityFilter object into array of values


      if (typeof cityFilter != "undefined") {
        _cityFilter = cityFilter.map(function (cf) {
          return cf.city;
        });
      } else {
        _cityFilter = '';
      } // change licenseTypeFilter into array of values


      if (typeof licenseTypeFilter != "undefined") {
        _licenseTypeFilter = licenseTypeFilter.map(function (ltf) {
          return ltf.name;
        });
      } else {
        _licenseTypeFilter = '';
      } // change licensePurposeFilter into array of values


      if (typeof licensePurposeFilter != "undefined") {
        _licensePurposeFilter = licensePurposeFilter.map(function (lpf) {
          return lpf.name;
        });
      } else {
        _licensePurposeFilter = '';
      } // change yearFilter into array of values


      if (typeof yearFilter != "undefined") {
        _yearFilter = yearFilter.map(function (yf) {
          return yf.license_year;
        });
      } else {
        _yearFilter = '';
      }

      return api.http({
        url: 'licenses',
        method: 'get',
        params: {
          'page': page,
          'per_page': perPage,
          'q': q,
          'active': status,
          'cities[]': _cityFilter,
          'license_types[]': _licenseTypeFilter,
          'license_purposes[]': _licensePurposeFilter,
          'sort_column': sort_column,
          'sort_order': sort_order,
          'unpaid': unpaid,
          'license_years[]': _yearFilter
        }
      });
    };

    that.get = function (licenseId) {
      return api.http({
        url: 'licenses/' + licenseId,
        method: 'get'
      });
    };

    that.getByBusiness = function (businessId, page, perPage) {
      return api.http({
        url: 'business/' + businessId + '/licenses',
        params: {
          page: page,
          perPage: perPage
        }
      });
    };

    that.edit = function (licenseId) {
      return api.http({
        url: 'license/' + licenseId,
        method: 'edit'
      });
    };

    that.create = function (license) {
      var newLicense = Object.assign({}, license);
      return api.http({
        url: 'licenses',
        method: 'post',
        data: newLicense
      });
    };

    that.update = function (license) {
      var updatedLicense = Object.assign({}, license); //console.log('FACTORY UPDATE: ' + JSON.stringify(updatedLicense));

      return api.http({
        url: 'licenses/' + updatedLicense.license.id,
        method: 'patch',
        data: updatedLicense
      });
    };

    that.remove = function (licenseId) {
      return api.http({
        url: 'licenses/' + licenseId,
        method: 'delete'
      });
    };

    that.newNumber = function (license) {
      Object.assign({}, license);
      return api.http({
        url: 'license_number',
        method: 'get'
      });
    };

    that.export = function (searchFilter, activeFilter, yearFilter, cityFilter, licenseTypeFilter, licensePurposeFilter, sortColumn, sortOrder) {
      return api.http({
        url: 'xls/licenses',
        method: 'post',
        responseType: 'arraybuffer',
        params: {
          search_filter: searchFilter,
          active_filter: activeFilter,
          year_filter: {
            yearFilter: yearFilter
          },
          city_filter: {
            cityFilter: cityFilter
          },
          license_type_filter: {
            licenseTypeFilter: licenseTypeFilter
          },
          license_purpose_filter: {
            licensePurposeFilter: licensePurposeFilter
          },
          sort_column: sortColumn,
          sort_order: sortOrder
        }
      });
    };

    return that;
  };

  angular.module('lms').factory('licensesFactory', ['$q', 'api', licensesFactory]);
})();

// Factory

(function(){

    'use strict';

    var licenseYearsFactory = function($q, api) {
        var that = {};

        var index = that.index = function () {

            console.log('license year factory running!');

            return api.http({
                url: 'license_years',
                method: 'get'
            });
        };

        var get = that.get = function (licenseYearId) {
            return api.http({
                url: 'license_years/' + licenseYearId,
                method: 'get'
            });
        };

        var create = that.create = function (licenseYear) {
            var newLicenseYear = Object.assign({}, licenseYear);
            return api.http({
                url: 'license_years',
                method: 'post',
                data: newLicenseYear
            })
        };

        var update = that.update = function (licenseYear) {
            var newLicenseYear = Object.assign({}, licenseYear);
            return api.http({
                url: 'license_years/' + licenseYear.id,
                method: 'patch',
                data: newLicenseYear
            });
        };

        var remove = that.remove = function (licenseYearId) {
            return api.http({
                url: 'license_years/' + licenseYearId,
                method: 'delete'
            })
        }

        return that;
    };

    angular.module('lms').factory('licenseYearsFactory',['$q', 'api', licenseYearsFactory]);

}());
// Factory

(function(){

    'use strict';

    var licenseTypesFactory = function($q, api) {
        var that = {};

        var index = that.index = function () {

            console.log('license type factory running!');

            return api.http({
                url: 'license_types',
                method: 'get'
            });
        };

        var get = that.get = function (licenseTypeId) {
            return api.http({
                url: 'license_types/' + licenseTypeId,
                method: 'get'
            });
        };

        var create = that.create = function (licenseType) {
            var newLicenseType = Object.assign({}, licenseType);
            return api.http({
                url: 'license_types',
                method: 'post',
                data: newLicenseType
            })
        };

        var update = that.update = function (licenseType) {
            var newLicenseType = Object.assign({}, licenseType);
            return api.http({
                url: 'license_types/' + licenseType.id,
                method: 'patch',
                data: newLicenseType
            });
        };

        var remove = that.remove = function (licenseTypeId) {
            return api.http({
                url: 'license_types/' + licenseTypeId,
                method: 'delete'
            })
        }

        return that;
    };

    angular.module('lms').factory('licenseTypesFactory',['$q', 'api', licenseTypesFactory]);

}());
// Factory

(function(){

    'use strict';

    var licenseSettingsFactory = function($q, api) {
        var that = {};

        var index = that.index = function () {

            console.log('license settings factory running!');

            return api.http({
                url: 'license_settings',
                method: 'get'
            });
        };

        var get = that.get = function (licenseSettingId) {
            return api.http({
                url: 'license_settings/' + licenseTypeId,
                method: 'get'
            });
        };

        var create = that.create = function (licenseSetting) {
            var newLicenseType = Object.assign({}, licenseSetting);
            return api.http({
                url: 'license_settings',
                method: 'post',
                data: newLicenseSetting
            })
        };

        var update = that.update = function (licenseSetting) {
            var newLicenseType = Object.assign({}, licenseSetting);
            return api.http({
                url: 'license_settings/' + licenseSetting.id,
                method: 'patch',
                data: licenseSetting
            });
        };

        var remove = that.remove = function (licenseSettingId) {
            return api.http({
                url: 'license_settings/' + licenseSettingId,
                method: 'delete'
            })
        }

        return that;
    };

    angular.module('lms').factory('licenseSettingsFactory',['$q', 'api', licenseSettingsFactory]);

}());
// Factory

(function(){

    'use strict';

    var licensePurposesFactory = function($q, api) {
        var that = {};

        var index = that.index = function () {

            console.log('license purpose factory running!');

            return api.http({
                url: 'license_purposes',
                method: 'get'
            });
        };

        var get = that.get = function (licensePurposeId) {
            return api.http({
                url: 'license_purposes/' + licensePurposeId,
                method: 'get'
            });
        };

        var create = that.create = function (licensePurpose) {
            var newLicensePurpose = Object.assign({}, licensePurpose);
            return api.http({
                url: 'license_purposes',
                method: 'post',
                data: newLicensePurpose
            })
        };

        var update = that.update = function (licensePurpose) {
            var newLicensePurpose = Object.assign({}, licensePurpose);
            return api.http({
                url: 'license_purposes/' + licensePurpose.id,
                method: 'patch',
                data: newLicensePurpose
            });
        };

        var remove = that.remove = function (licensePurposeId) {
            return api.http({
                url: 'license_purposes/' + licensePurposeId,
                method: 'delete'
            })
        }

        return that;
    };

    angular.module('lms').factory('licensePurposesFactory',['$q', 'api', licensePurposesFactory]);

}());
// Factory

(function(){

    'use strict';

    var licenseOfficialsFactory = function($q, api) {
        var that = {};

        var index = that.index = function () {

            //console.log('license officials factory running!');

            return api.http({
                url: 'license_officials',
                method: 'get'
            });
        };

        var get = that.get = function (licenseOfficialId) {
            return api.http({
                url: 'license_officials/' + licenseOfficialId,
                method: 'get'
            });
        };

        var create = that.create = function(licenseOfficial) {
            var newLicenseOfficial = Object.assign({}, licenseOfficial);
            return api.http({
                url: 'license_officials',
                method: 'post',
                data: newLicenseOfficial
            })
        };

        var update = that.update = function(licenseOfficial) {
            var newLicenseOfficial = Object.assign({}, licenseOfficial);
            return api.http({
                url: 'license_officials/' + licenseOfficial.id,
                method: 'patch',
                data: newLicenseOfficial
            });
        };

        var remove = that.remove = function (licenseOfficialId) {
            return api.http({
                url: 'license_officials/' + licenseOfficialId,
                method: 'delete'
            })
        }

        return that;
    };

    angular.module('lms').factory('licenseOfficialsFactory',['$q', 'api', licenseOfficialsFactory]);

}());
// Factory

(function(){

  'use strict';

  var inspectionsFactory = function($q, api) {
    var that = {};

    that.index = function(page, perPage, q, inspectionTypeFilter, businessTypeFilter, cityFilter, sort_column, sort_order, distinct, inspectionOnBegin, inspectionOnEnd) {

      //console.clear();
      // console.log('--------------------------------------------------------------');
      // console.log('INSPECTION FACTORY');
      // console.log('--------------------------------------------------------------');
      // console.log('page: ' + JSON.stringify(page));
      // console.log('perPage: ' + JSON.stringify(perPage));
      // console.log('inspectionTypeFilter: ' + JSON.stringify(inspectionTypeFilter));
      // console.log('businessTypeFilter: ' + JSON.stringify(businessTypeFilter));
      // console.log('CityFilter: ' + JSON.stringify(cityFilter));
      // console.log('sort_column: ' + JSON.stringify(sort_column));
      // console.log('sort_order: ' + JSON.stringify(sort_order));
      // console.log('distinct: ' + JSON.stringify(distinct));
      // console.log('inspectionOnBegin : ' + JSON.stringify(inspectionOnBegin));
      // console.log('inspectionOnEnd: ' + JSON.stringify(inspectionOnEnd));
      // console.log('--------------------------------------------------------------');
      // console.log('INSPECTION FACTORY');
      // console.log('--------------------------------------------------------------');

      var _inspectionTypeFilter, _businessTypeFilter, _cityFilter;

      if (typeof inspectionTypeFilter != "undefined") {
        _inspectionTypeFilter = inspectionTypeFilter.map(function (itf) {
          return itf.name;
        });
      } else {
        _inspectionTypeFilter = '';
      }

      if (typeof businessTypeFilter != "undefined") {
        _businessTypeFilter = businessTypeFilter.map(function (btf) {
          return btf.name;
        });
      } else {
        _businessTypeFilter = '';
      }

      if (typeof cityFilter != "undefined") {
        _cityFilter = cityFilter.map(function (cf) {
          return cf.name;
        });
      } else {
        _cityFilter = '';
      }

      return api.http({
        url: 'inspections',
        method: 'get',
        params: {'q': q,
          'inspectionTypeFilter[]': _inspectionTypeFilter,
          'businessTypeFilter[]': _businessTypeFilter,
          'cityFilter[]': _cityFilter,
          'page': page,
          'per_page': perPage,
          'sort_column': sort_column,
          'sort_order': sort_order,
          'distinct': distinct,
          'inspectionOnBegin': inspectionOnBegin,
          'inspectionOnEnd': inspectionOnEnd}
      });
    };

    that.get = function (inspectionId) {
      return api.http({
        url: 'inspections/' + inspectionId,
        method: 'get'
      });
    };

    that.edit = function (inspectionId) {
      return api.http({
        url: 'inspections/' + inspectionId,
        method: 'edit'
      });
    };

    that.create = function (inspection) {
      var newInspection = Object.assign({}, inspection);
      return api.http({
        url: 'inspections',
        method: 'post',
        data: newInspection
      })
    };

    that.update = function (inspection) {
      var updatedInspection = Object.assign({}, inspection);
      return api.http({
        url: 'inspections/' + updatedInspection.inspection.id,
        method: 'patch',
        data: updatedInspection
      });
    };

    that.remove = function (inspectionId) {
      return api.http({
        url: 'inspections/' + inspectionId,
        method: 'delete'
      })
    };

    that.getByBusiness = function(businessId, page, perPage) {
      //console.log('Getting business by business id: ' + businessId);
      return api.http({
        url: 'business/' + businessId + '/inspections',
        method: 'get',
        params: {page: page, per_page: perPage}
      })
    };

    that.export = function (searchFilter, inspectionTypeFilter, businessTypeFilter, cityFilter, inspectionStatus, inspectionOnBegin, inspectionOnEnd, sortColumn, sortOrder) {

      return api.http({
        url: 'xls/inspections',
        method: 'post',
        responseType: 'arraybuffer',
        params: {
          search_filter: searchFilter,
          inspection_type_filter: {
            inspectionTypeFilter: inspectionTypeFilter
          },
          business_type_filter: {
            businessTypeFilter: businessTypeFilter
          },
          city_filter: {
            cityFilter: cityFilter
          },
          inspection_status: inspectionStatus,
          inspection_start: inspectionOnBegin,
          inspection_end: inspectionOnEnd,
          sort_column: sortColumn,
          sort_order: sortOrder
        }
      });
    };

    return that;
  };

  angular.module('lms').factory('inspectionsFactory',['$q', 'api', inspectionsFactory]);

}());

// Factory

(function(){

    'use strict';

    var inspectionTypesFactory = function($q, api) {
        var that = {};

        var index = that.index = function () {

            console.log('inspection type factory running!');

            return api.http({
                url: 'inspection_types',
                method: 'get'
            });
        };

        var get = that.get = function (inspectionTypeId) {
            return api.http({
                url: 'inspection_types/' + inspectionTypeId,
                method: 'get'
            });
        };

        var create = that.create = function (inspectionType) {
            var newInspectionType = Object.assign({}, inspectionType);
            return api.http({
                url: 'inspection_types',
                method: 'post',
                data: newInspectionType
            })
        };

        var update = that.update = function (inspectionType) {
            var newInspectionType = Object.assign({}, inspectionType);
            return api.http({
                url: 'inspection_types/' + inspectionType.id,
                method: 'patch',
                data: newInspectionType
            });
        };

        var remove = that.remove = function (inspectionTypeId) {
            return api.http({
                url: 'inspection_types/' + inspectionTypeId,
                method: 'delete'
            })
        }

        return that;
    };

    angular.module('lms').factory('inspectionTypesFactory',['$q', 'api', inspectionTypesFactory]);

}());
// Factory

(function(){

    'use strict';

    var inspectionReasonsFactory = function($q, api) {
        var that = {};

        var index = that.index = function () {

            console.log('inspection type factory running!');

            return api.http({
                url: 'inspection_reasons',
                method: 'get'
            });
        };

        var get = that.get = function (inspectionReasonId) {
            return api.http({
                url: 'inspection_reasons/' + inspectionReasonId,
                method: 'get'
            });
        };

        var create = that.create = function (inspectionReason) {
            var newInspectionReason = Object.assign({}, inspectionReason);
            return api.http({
                url: 'inspection_reasons',
                method: 'post',
                data: newInspectionReason
            })
        };

        var update = that.update = function (inspectionReason) {
            var newInspectionReason = Object.assign({}, inspectionReason);
            return api.http({
                url: 'inspection_reasons/' + inspectionReason.id,
                method: 'patch',
                data: newInspectionReason
            });
        };

        var remove = that.remove = function (inspectionReasonId) {
            return api.http({
                url: 'inspection_reasons/' + inspectionReasonId,
                method: 'delete'
            })
        }

        return that;
    };

    angular.module('lms').factory('inspectionReasonsFactory',['$q', 'api', inspectionReasonsFactory]);

}());
// Factory

(function(){

  'use strict';

  var filtersFactory = function($q, api) {
    var that = {};

    that.inspectionTypes = function () {

      return api.http({
        url: 'inspection_types',
        method: 'get'
      });
    };

    that.businessTypes = function () {
      return api.http({
        url: 'business_types',
        method: 'get'
      });
    };

    that.licenseTypes = function() {
      return api.http({
        url: 'license_types',
        method: 'get'
      });
    };

    that.licensePurposes = function() {
      return api.http({
        url: 'license_purposes',
        method: 'get'
      });
    };

    that.cities = function() {
      return api.http({
        url: 'cities',
        method: 'get'
      });
    };

    that.years = function() {
      return api.http({
        url: 'license_years',
        method: 'get'
      });
    }

    return that;
  };

  angular.module('lms').factory('filtersFactory',['$q', 'api', filtersFactory]);

}());

// Factory

(function(){

    'use strict';

    var evaluationStatusesFactory = function($q, api) {
        var that = {};

        var index = that.index = function() {
            //console.log('evaluation statuses factory running!');
            return api.http({
                url: 'evaluation_statuses',
                method: 'get'
            });
        };

        var get = that.get = function (evaluationStatusId) {
            return api.http({
                url: 'evaluation_statuses/' + evaluationStatusId,
                method: 'get'
            });
        };

        var create = that.create = function (evaluationStatus) {
            var newEvaluationStatus = Object.assign({}, evaluationStatus);
            return api.http({
                url: 'evaluation_statuses',
                method: 'post',
                data: newEvaluationStatus
            })
        };

        var update = that.update = function (evaluationStatus) {
            var newEvaluationStatus = Object.assign({}, evaluationStatus);
            return api.http({
                url: 'evaluation_statuses/' + evaluationStatus.id,
                method: 'patch',
                data: newEvaluationStatus
            });
        };

        var remove = that.remove = function (evaluationStatusId) {
            return api.http({
                url: 'evaluation_statuses/' + evaluationStatusId,
                method: 'delete'
            })
        }

        return that;
    };

    angular.module('lms').factory('evaluationStatusesFactory',['$q', 'api', evaluationStatusesFactory]);

}());
// Factory

(function(){

    'use strict';

    //page, perPage, q, status, sort_column, sort_order

    var contractorsFactory = function($q, api) {
        var that = {};

        var index = that.index = function(page, perPage, sort_column, sort_order) {

            //console.log('contractors factory running!');

            return api.http({
                url: 'contractors',
                method: 'get',
                params: {'page': page, 'per_page': perPage, 'sort_column': sort_column, 'sort_order': sort_order}
            });
        };

        var getByBusiness = that.getByBusiness = function(businessId){
            return api.http({
                url: 'business/' + businessId + '/contractors',
                method: 'get'
            })
        };

        var get = that.get = function(contractorId) {
            return api.http({
                url: 'contractors/' + contractorId,
                method: 'get'
            });
        };

        var create = that.create = function(contractor) {
            var newContractor = Object.assign({}, contractor);
            return api.http({
                url: 'contractors',
                method: 'post',
                data: newContractor
            })
        };

        var update = that.update = function(contractor) {

            console.log(JSON.stringify(contractor));

            var newContractor = Object.assign({}, contractor);
            return api.http({
                url: 'contractors/' + contractor.contractor.id,
                method: 'patch',
                data: newContractor
            });
        };

        var remove = that.remove = function(contractorId) {
            return api.http({
                url: 'contractors/' + contractorId,
                method: 'delete'
            })
        };

        var removeBusinessContractor = that.removeBusinessContractor = function(businessId, contractorId) {
            return api.http({
                url: '/business/' + businessId + '/contractor/' + contractorId,
                method: 'delete'
            })
        };

        return that;
    };

    angular.module('lms').factory('contractorsFactory',['$q', 'api', contractorsFactory]);

}());
// Factory

(function(){

    'use strict';

    var contractorTypesFactory = function($q, api) {
        var that = {};

        var index = that.index = function () {

            console.log('contractor type factory running!');

            return api.http({
                url: 'contractor_types',
                method: 'get'
            });
        };

        var get = that.get = function (contractorTypeId) {
            return api.http({
                url: 'contractor_types/' + contractorTypeId,
                method: 'get'
            });
        };

        var create = that.create = function (contractorType) {
            var newContractorType = Object.assign({}, contractorType);
            return api.http({
                url: 'contractor_types',
                method: 'post',
                data: newContractorType
            })
        };

        var update = that.update = function (contractorType) {
            var newContractorType = Object.assign({}, contractorType);
            return api.http({
                url: 'contractor_types/' + contractorType.id,
                method: 'patch',
                data: newContractorType
            });
        };

        var remove = that.remove = function (contractorTypeId) {
            return api.http({
                url: 'contractor_types/' + contractorTypeId,
                method: 'delete'
            })
        }

        return that;
    };

    angular.module('lms').factory('contractorTypesFactory',['$q', 'api', contractorTypesFactory]);

}());
// Factory

(function(){

    'use strict';

    var contactsFactory = function($q, api) {
        var that = {};

        var index = that.index = function() {

            //console.log('contacts factory running!');

            return api.http({
                url: 'contacts',
                method: 'get'
            });
        };

        var getByBusiness = that.getByBusiness = function(businessId){
            return api.http({
                url: 'business/' + businessId + '/contacts',
                method: 'get'
            })
        };

        var get = that.get = function(contactId) {
            return api.http({
                url: 'contacts/' + contactId,
                method: 'get'
            });
        };

        var create = that.create = function(contact) {
            var newContact = Object.assign({}, contact);
            return api.http({
                url: 'contacts',
                method: 'post',
                data: newContact
            })
        };

        var update = that.update = function(contact) {
            var newContact = Object.assign({}, contact);
            return api.http({
                url: 'contacts/' + contact.id,
                method: 'patch',
                data: newContact
            });
        };

        var remove = that.remove = function(contactId) {
            return api.http({
                url: 'contacts/' + contactId,
                method: 'delete'
            })
        }

        return that;
    };

    angular.module('lms').factory('contactsFactory',['$q', 'api', contactsFactory]);

}());
// Factory

(function(){

    'use strict';

    var contactTypesFactory = function($q, api) {
        var that = {};

        var index = that.index = function () {

            //console.log('contact type factory running!');

            return api.http({
                url: 'contact_types',
                method: 'get'
            });
        };

        var get = that.get = function (contactTypeId) {
            return api.http({
                url: 'contact_types/' + contactTypeId,
                method: 'get'
            });
        };

        var create = that.create = function (contactType) {
            var newContactType = Object.assign({}, contactType);
            return api.http({
                url: 'contact_types',
                method: 'post',
                data: newContactType
            })
        };

        var update = that.update = function (contactType) {
            var newContactType = Object.assign({}, contactType);
            return api.http({
                url: 'contact_types/' + contactType.id,
                method: 'patch',
                data: newContactType
            });
        };

        var remove = that.remove = function (contactTypeId) {
            return api.http({
                url: 'contact_types/' + contactTypeId,
                method: 'delete'
            })
        }

        return that;
    };

    angular.module('lms').factory('contactTypesFactory',['$q', 'api', contactTypesFactory]);

}());
"use strict";

// Factory
(function () {
  'use strict';

  var businessesFactory = function businessesFactory($q, api) {
    var that = {};

    that.index = function (page, perPage, q, status, missingLicense, cityFilter, businessTypeFilter, sort_column, sort_order) {
      //console.log('CityFilter*: ' + JSON.stringify(cityFilter));

      var _cityFilter, _businessTypeFilter; // change cityFilter object into array of values


      if (typeof cityFilter != "undefined") {
        _cityFilter = cityFilter.map(function (cf) {
          return cf.city;
        });
      } else {
        _cityFilter = '';
      } //console.log("_cityFilter: " + _cityFilter);
      // change businessTypeFilter object into array of values


      if (typeof businessTypeFilter != "undefined") {
        _businessTypeFilter = businessTypeFilter.map(function (btf) {
          return btf.name;
        });
      } else {
        _businessTypeFilter = '';
      }

      return api.http({
        url: 'businesses',
        method: 'get',
        params: {
          'q': q,
          'active': status,
          'missingLicense': missingLicense,
          'cityFilter[]': _cityFilter,
          'businessTypeFilter[]': _businessTypeFilter,
          'page': page,
          'per_page': perPage,
          'sort_column': sort_column,
          'sort_order': sort_order
        }
      });
    };

    that.get = function (businessId) {
      return api.http({
        url: 'businesses/' + businessId,
        method: 'get'
      });
    };

    that.edit = function (businessId) {
      return api.http({
        url: 'business/' + businessId,
        method: 'edit'
      });
    };

    that.create = function (business) {
      var newBusinessType = Object.assign({}, business);
      return api.http({
        url: 'businesses',
        method: 'post',
        data: newBusinessType
      });
    };

    that.update = function (business) {
      var updatedBusiness = Object.assign({}, business);
      return api.http({
        url: 'businesses/' + updatedBusiness.business.id,
        method: 'patch',
        data: updatedBusiness
      });
    };

    that.remove = function (businessId) {
      return api.http({
        url: 'businesses/' + businessId,
        method: 'delete'
      });
    };

    that.addContractor = function (businessId, contractorId) {
      return api.http({
        url: 'business/' + businessId + '/contractor/' + contractorId,
        method: 'post'
      });
    };

    that.removeContractor = function (businessId, contractorId) {
      return api.http({
        url: 'business/' + businessId + '/contractor/' + contractorId,
        method: 'delete'
      });
    };

    that.mailing = function (searchFilter, activeFilter, missingLicense, cityFilter, businessTypeFilter, sortColumn, sortOrder) {
      return api.http({
        url: '/pdf/mailing',
        method: 'post',
        params: {
          search_filter: searchFilter,
          bactive: activeFilter,
          missing_license: missingLicense,
          business_type_filter: {
            businessTypeFilter: businessTypeFilter
          },
          city_filter: {
            cityFilter: cityFilter
          },
          sort_column: sortColumn,
          sort_order: sortOrder
        }
      });
    };

    that.export = function (searchFilter, activeFilter, missingLicense, cityFilter, businessTypeFilter, sortColumn, sortOrder) {
      return api.http({
        url: 'xls/businesses',
        method: 'post',
        responseType: 'arraybuffer',
        params: {
          search_filter: searchFilter,
          bactive: activeFilter,
          missing_license: missingLicense,
          business_type_filter: {
            businessTypeFilter: businessTypeFilter
          },
          city_filter: {
            cityFilter: cityFilter
          },
          sort_column: sortColumn,
          sort_order: sortOrder
        }
      });
    };

    return that;
  };

  angular.module('lms').factory('businessesFactory', ['$q', 'api', businessesFactory]);
})();

// Factory

(function(){

    'use strict';

    var businessTypesFactory = function($q, api) {
        var that = {};

        var index = that.index = function () {
            return api.http({
                url: 'business_types',
                method: 'get'
            });
        };

        var get = that.get = function (businessTypeId) {
            return api.http({
                url: 'business_types/' + businessTypeId,
                method: 'get'
            });
        };

        var create = that.create = function (businessType) {
            var newBusinessType = Object.assign({}, businessType);
            return api.http({
                url: 'business_types',
                method: 'post',
                data: newBusinessType
            })
        };

        var update = that.update = function (businessType) {
            var newBusinessType = Object.assign({}, businessType);
            return api.http({
                url: 'business_types/' + businessType.id,
                method: 'patch',
                data: newBusinessType
            });
        };

        var remove = that.remove = function (businessTypeId) {
            return api.http({
                url: 'business_types/' + businessTypeId,
                method: 'delete'
            })
        }

        return that;
    };

    angular.module('lms').factory('businessTypesFactory',['$q', 'api', businessTypesFactory]);

}());
;(function () {
    'use strict';

    angular.module('lms').factory('api', ['$http', '$q', '$location', 'apiUrl', 'apiPort', 'storageEngine', function ($http, $q, $location, apiUrl, apiPort, storageEngine) {
        var that = {};

        /* public */

        /**
         * @return Promise - on success, 'unwraps' the `data` property.
         */
        var http = that.http = function(options) {
            options = options || {};
            options.method = options.method || 'get';
            options.url = toFullEndPoint(options.url);
            options.headers = {
                Authorization: 'Bearer ' + getAuthenticationToken()
            };

            return $http(options).then(function(response) {
                return response.data;
            }, function(errorResponse) {
                if (($location.path() !== '/') && ($location.path() !== '/register') && (errorResponse.status === 401)) {
                    $location.path('/');
                } else {
                    return errorResponse;
                }
            });
        };

        var isLoggedIn = that.isLoggedIn = function () {
            return !! getCurrentUser();
        };

        var getCurrentUser = that.getCurrentUser = function () {
            return storageEngine.getItem('user');
        };

        var logIn = that.logIn = function (email, password, callback) {
            return $http({
                url: toFullEndPoint('sessions'),
                data: {email: email, password: password},
                method: 'post'
            }).then(
                function (response) {
                    var bearer = response ? response.headers('bearer') : null;
                    setAuthenticationToken(bearer);
                    setUser(response.data);
                    return response.data;
                },
                function (errorResponse) {
                    logOut();
                    authenticationError = true;
                    return $q.reject(errorResponse);
                }
            );
        };

        var logOut = that.logOut = function () {
            storageEngine.removeItem('user');
            storageEngine.removeItem('bearer');
            authenticationError = null;
        };

        var isAuthenticationError = that.isAuthenticationError = function() {
            return authenticationError;
        };

        var getAuthenticationToken = that.getAuthenticationToken = function () {
            return storageEngine.getItem('bearer');
        };

        var toFullEndPoint = that.toFullEndPoint = function(relativeEndpoint) {
            return apiUrl + ':' + apiPort + '/api/' + relativeEndpoint;
        };

        /* private */
        var authenticationError = false;

        var setAuthenticationToken = function (token) {
            storageEngine.setItem('bearer', token);
        };

        var setUser = function (user) {
            if (!user) {
                authenticationError = true;
            } else {
                storageEngine.setItem('user', user);
                authenticationError = false;
            }
        };

        return that;
    }]);
}());

// Controller

(function () {
    angular.module('lms').controller(
        'linkContractorModalController',
        ['$scope', '$rootScope', 'contractorsFactory', 'businessesFactory', 'modalFactory', '$stateParams',
            function ($scope, $rootScope, contractorsFactory, businessesFactory, modalFactory, $stateParams) {

                var that = $scope;

                var init = function () {
                    var that = $scope;
                    that.contractor = {};
                    getContractors();
                };

                var getContractors = function(){
                    var that = $scope;
                    contractorsFactory.index().then(
                        function(response){
                            if(response.status == undefined){
                                console.log(JSON.stringify(response.contractors));
                                that.contractors = response.contractors;
                            }else {
                                that.contractors = null;
                            }
                        }
                    )
                };



                var closeModal = that.closeModal = function () {
                    modalFactory.closeAll();
                };

                var save = that.save = function () {

                    var that = $scope;

                    that.submitted = true;

                    var lc = that.contractor;

                    if (that.contract.$valid) {

                        businessesFactory.addContractor($stateParams.businessId, lc.contractor_id).then(
                            function (response) {
                                if (response.status == undefined) {
                                    //console.log('Passing data to parent....');
                                    that.$emit('addContractorToBusiness', response);
                                }
                            }
                        );
                        modalFactory.closeAll();

                    }
                }

                init();

            }
        ]
    );
}());
// Controller

(function () {
    angular.module('lms').controller(
        'viewContractorsModalController',
        ['$scope', '$rootScope', 'contractorsFactory', 'modalFactory',
            function ($scope, $rootScope, contractorsFactory, modalFactory) {

                var that = $scope;

                var init = function () {
                    var that = $scope;
                    that.contractor = {};
                    getContractor();
                };

                //var gotoLocation = function (path) {
                //    $location.path(path);
                //};

                var getContractor = function(){
                    var that = $scope;
                    contractorsFactory.get($rootScope.contactractorParams.contractorId).then(
                        function(response){
                            if(response.status == undefined){

                                console.log(JSON.stringify(response));

                                that.contractor = response;
                            }else {
                                that.contractor = null;
                            }
                        }
                    )
                };

                var closeModal = that.closeModal = function () {
                    //console.log('closing...');
                    modalFactory.closeAll();
                };

                init();

            }
        ]
    );
}());
// Controller

(function () {
    angular.module('lms').controller(
        'newContractorsModalController',
        ['$scope', '$stateParams', 'contractorTypesFactory', 'contractorsFactory', 'modalFactory', 'statesFactory', '$location',
            function ($scope, $stateParams, contractorTypesFactory, contractorsFactory, modalFactory, statesFactory, $location) {

                var that = $scope;

                var init = function () {
                    var that = $scope;
                    that.addresses = [];
                    that.contractor = {addresses: [{'primary_street':'', 'secondary_street':'', 'city':'', 'state':'', 'zip':''}]};
                    getContractorTypes();
                    getStates();
                    console.log('New Contractor Modal Controller running!');
                };

                var gotoLocation = function (path) {
                    $location.path(path);
                };

                var getStates = function(){
                              var that = $scope;
                              statesFactory.index().then(
                                  function(response){
                                      if(response.status == undefined){
                                          that.states = response;
                                      } else {
                                          that.states = [];
                                      }
                                  }
                              )
                            };

                var getContractorTypes = function () {
                    var that = $scope;
                    contractorTypesFactory.index().then(
                        function (response) {
                            if (response.status == undefined) {
                                that.contractorTypes = response;
                            } else {
                                that.contractorTypes = [];
                            }
                        }
                    )
                };

                var closeModal = that.closeModal = function () {
                    //console.log('closing...');
                    modalFactory.closeAll();
                };

                var save = that.save = function () {

                    var that = $scope;

                    that.submitted = true;

                    if (that.contract.$valid) {

                        var nc = that.contractor;

                        var newContractor = {
                            name: nc.name,
                            contractor_type_id: nc.contractor_type,
                            phone: nc.phone,
                            fax: nc.fax,
                            email: nc.email,
                            addresses: nc.addresses

                        };

                        //console.log("Current params:  " + JSON.stringify(that.inspection));

                        contractorsFactory.create({
                            contractor: newContractor
                        }).then(
                            function (response) {
                                if (response.status == undefined) {
                                    console.log('Passing data to parent....');
                                    that.$emit('addContractorToList', response);
                                }
                            }
                        );
                        modalFactory.closeAll();

                    }
                }

                init();

            }
        ]
    );
}());
// Controller

(function () {
    angular.module('lms').controller(
        'editContractorsModalController',
        ['$scope', '$rootScope', 'contractorTypesFactory', 'contractorsFactory', 'modalFactory', 'statesFactory', '$location',
            function ($scope, $rootScope, contractorTypesFactory, contractorsFactory, modalFactory, statesFactory, $location) {

                var that = $scope;

                var init = function () {

                    console.log('Editing Contractor : Modal View');

                    var that = $scope;
                    that.addresses = [];
                    getContractor();
                    getContractorTypes();
                    getStates();
                };

                //var gotoLocation = function (path) {
                //    $location.path(path);
                //};

                var getContractor = function(){
                    var that = $scope;
                    contractorsFactory.get($rootScope.contractor_id).then(
                        function(response){
                            if(response.status == undefined){

                                console.log(JSON.stringify(response));

                                that.contractor = response;
                            }else {
                                that.contractor = null;
                            }
                        }
                    )
                };

                var getStates = function(){
                              var that = $scope;
                              statesFactory.index().then(
                                  function(response){
                                      if(response.status == undefined){
                                          that.states = response;
                                      } else {
                                          that.states = [];
                                      }
                                  }
                              )
                            };

                var getContractorTypes = function () {
                    var that = $scope;
                    contractorTypesFactory.index().then(
                        function (response) {
                            if (response.status == undefined) {
                                that.contractorTypes = response;
                            } else {
                                that.contractorTypes = [];
                            }
                        }
                    )
                };

                var closeModal = that.closeModal = function () {
                    //console.log('closing...');
                    modalFactory.closeAll();
                };

                var save = that.save = function () {

                    var that = $scope;

                    that.submitted = true;

                    if (that.contract.$valid) {

                        var nc = that.contractor;

                        var newContractor = {
                            id: nc.id,
                            name: nc.name,
                            contractor_type_id: nc.contractor_type,
                            phone: nc.phone,
                            fax: nc.fax,
                            email: nc.email,
                            addresses: nc.addresses

                        };

                        contractorsFactory.update({
                            contractor: newContractor
                        }).then(
                            function (response) {
                                if (response.status == undefined) {
                                    console.log('Passing data to parent....');
                                    that.$emit('updateContractorInList', response);
                                }
                            }
                        );
                        modalFactory.closeAll();

                    }
                }

                init();

            }
        ]
    );
}());
// Controller

(function () {
    angular.module('lms').controller(
        'editContactsController',
        ['$scope', '$rootScope', 'contactTypesFactory', 'modalFactory', 'contactsFactory', '$location', '$stateParams', function ($scope, $rootScope, contactTypesFactory, modalFactory, contactsFactory, $location, $stateParams) {

            var that = $scope;


            var init = function () {
                that.contact = {};
                getContactTypes();
                getContact();
            };

            var isFoodCertified = that.isFoodCertified = function () {
                console.log('Checking for Food Certification');
                var target_object = _.find(that.contactTypes, function (o) {
                    return o.name.toUpperCase() == 'FOOD CERTIFIED'
                });

                //console.log('Target Index: ' + target_object.id);
                //console.log('Selected Id: ' + $scope.contact.contact_type_id);
                if (target_object) {
                    if ($scope.contact.contact_type_id == target_object.id) {
                        return true
                    } else {
                        return false
                    }
                }
                ;
            };


            var getContactTypes = function () {
                contactTypesFactory.index().then(
                    function (response) {
                        if (response.status == undefined) {
                            that.contactTypes = response;
                        } else {
                            that.contactTypes = [];
                        }
                    }
                );
            };

            var getContact = function () {
                contactsFactory.get($rootScope.contactParams.contactId).then(
                    function (response) {
                        if (response.status == undefined) {
                            that.contact = response;
                            that.contact.contact_type_id = that.contact.contact_type.id;


                            console.log(JSON.stringify(response));

                            var ed = new Date(that.contact.exp_date);
                            var userTimezoneOffset = new Date().getTimezoneOffset() * 60000;


                            that.contact.exp_date = new Date(ed.getTime() + userTimezoneOffset);

                            //console.log("Returned contact record: " + JSON.stringify(that.contact));
                        } else {
                            that.contact = [];
                        }
                    }
                )
            }

            var closeModal = that.closeModal = function () {
                //console.log('closing...');
                modalFactory.closeAll();
            };

            var save = that.save = function (item) {
                that = $scope;

                that.submitted = true;

                if (that.cont.$valid) {
                    var nc = that.contact;
                    var newContact = {
                        contact: {
                            id: nc.id,
                            contact_type_id: nc.contact_type_id,
                            first_name: nc.first_name,
                            last_name: nc.last_name,
                            phone: nc.phone,
                            email: nc.email,
                            fax: nc.fax,
                            exp_date: nc.exp_date
                        }
                    };

                    contactsFactory.update(newContact).then(
                        function (response) {
                            if (response.status == undefined) {
                                console.log('Passing data to parent....');
                                that.$emit('editContactInList', response);
                            }
                        }
                    );
                    modalFactory.closeAll();

                }
            }

            init();

        }
        ]
    );
}());
// Controller

(function () {
    angular.module('lms').controller(
        'addContactsController',
        ['$scope', '$rootScope', 'contactTypesFactory', 'modalFactory', 'contactsFactory', '$location', '$stateParams', function ($scope, $rootScope, contactTypesFactory, modalFactory, contactsFactory, $location, $stateParams) {

            var that = $scope;


            var init = function () {

                that.contact = {};
                getContactTypes();

            };

            var isFoodCertified = that.isFoodCertified = function () {
                console.log('Checking for Food Certification');
                var target_object = _.find(that.contactTypes, function (o) {
                    return o.name.toUpperCase() == 'FOOD CERTIFIED'
                });

                //console.log('Target Index: ' + target_object.id);
                //console.log('Selected Id: ' + $scope.contact.contact_type_id);
                if (target_object) {
                    if ($scope.contact.contact_type_id == target_object.id) {
                        return true
                    } else {
                        return false
                    }
                };
            };

            var getContactTypes = function () {
                contactTypesFactory.index().then(
                    function (response) {
                        if (response.status == undefined) {
                            that.contactTypes = response;
                        } else {
                            that.contactTypes = [];
                        }
                    }
                );
            };

            var closeModal = that.closeModal = function () {
                //console.log('closing...');
                modalFactory.closeAll();
            };

            var save = that.save = function () {
                that = $scope;

                that.submitted = true;

                if (that.cont.$valid) {
                    var nc = that.contact;
                    var newContact = {
                        contact_type_id: nc.contact_type_id,
                        first_name: nc.first_name,
                        last_name: nc.last_name,
                        phone: nc.phone,
                        email: nc.email,
                        fax: nc.fax,
                        exp_date: nc.exp_date
                    };

                    contactsFactory.create({businessId: $stateParams.businessId, contact: newContact}).then(
                        function (response) {
                            if (response.status == undefined) {
                                console.log('Passing data to parent....');
                                that.$emit('addContactToList', response);
                            }
                        }
                    );
                    modalFactory.closeAll();

                }
            }

            init();

        }
        ]
    );
}());
(function () {

    'use strict';

    angular.module('lms').controller(
        'settingsController', ['$scope', 'api', function ($scope, api) {

            $scope.configNavigation = [
                           {url: '.business_types', caption: 'Business Types', pageSignature: 'business_types'},
                           {url: '.contact_types', caption: 'Contact Types', pageSignature: 'contact_types'},
                           {url: '.contractor_types', caption: 'Contractor Types', pageSignature: 'contractor_types'},
                           {url: '.contractors', caption: 'Contractors', pageSignature: 'contractors'},
                           {url: '.evaluation_statuses', caption: 'Evaluation Statuses', pageSignature: 'evaluation_statuses'},
                           {url: '.inspection_reasons', caption: 'Inspection Reasons', pageSignature: 'inspection_reasons'},
                           {url: '.inspection_types', caption: 'Inspection Types', pageSignature: 'inspection_types'},
                           {url: '.license_officials', caption: 'License Officials', pageSignature: 'license_officials'},
                           {url: '.license_purposes', caption: 'License Purposes', pageSignature: 'license_purposes'},
                           {url: '.license_types', caption: 'License Types', pageSignature: 'license_types'},
                           {url: '.license_settings', caption: 'License Settings', pageSignature: 'license_settings'},
                           {url: '.states', caption: 'States', pageSignature: 'states'}
                       ];

            $scope.api = api;

            $scope.subNav = function(page){
                return page
            };


        }]
    );
}());

// Controller

(function() {
   angular.module('lms').controller(
       'newBusinessesController',
       ['$scope', 'businessTypesFactory', 'statesFactory', 'businessesFactory', '$location', function($scope, businessTypesFactory, statesFactory, businessesFactory, $location)
       {

           var that = $scope;

           var init = function() {
               var that = $scope;
               that.addresses = [];
               that.business = {addresses: [{'primary_street':'', 'secondary_street':'', 'city':'', 'state':'', 'zip':''}]};
               getBusinessTypes();
               getStates();
               //addAddress();
               that.categories = ['Main','Mailing','Owner']
           };

           var gotoLocation = function(path){
               $location.path(path);
           };

           var getBusinessTypes = function(){
               var that = $scope;
               businessTypesFactory.index().then(
                   function(response){
                       if(response.status == undefined){
                           that.businessTypes = response;
                       } else {
                           that.businessTypes = [];
                       }
                   }
               )
           };

           var getStates = function(){
              var that = $scope;
              statesFactory.index().then(
                  function(response){
                      if(response.status == undefined){
                          that.states = response;
                          console.log(JSON.stringify(response));
                      } else {
                          that.states = [];
                      }
                  }
              )
            };

           var addAddress = that.addAddress = function(){
               var that = $scope;
               that.business.addresses.push({primary_street: '', secondary_street: '', city: '', state: '', zip: ''});
           };

           var removeAddress = that.removeAddress = function(index, business){
               var address = business.addresses[index];
               if(address.id){
                   address._destroy = true;
               }else{
                   business.addresses.splice(index,1);
               }
           };

           var save = that.save = function(){

              var that = $scope;

              that.submitted = true;

              if (that.biz.$valid){

                  var nb = that.business;

                  //console.log(JSON.stringify(nb));

                  var newBusiness = {
                      id: nb.id,
                      name: nb.name,
                      business_type_id: nb.business_type,
                      phone: nb.phone,
                      fax: nb.fax,
                      url: nb.url,
                      email: nb.email,
                      notes: nb.notes,
                      addresses: nb.addresses,
                      sq_footage: nb.sq_footage,
                      num_seats: nb.num_seats
                  };

                  //console.log("Current params:  " + JSON.stringify(that.newBusiness));

                  businessesFactory.create({business: newBusiness});
                  gotoLocation('/businesses');

              }
          }

          init();

       }
       ]
   );
}());
// Controller

(function () {
    angular.module('lms').controller(
        'editBusinessController',
        ['$scope', '$rootScope', 'businessTypesFactory', 'statesFactory', 'businessesFactory', '$location', '$stateParams', function ($scope, $rootScope, businessTypesFactory, statesFactory, businessesFactory, $location, $stateParams) {

            var that = $scope;

            var init = function () {
                //var that = $scope;
                //that.addresses = [];
                //that.business = {addresses: [{'primary_street':'', 'secondary_street':'', 'city':'', 'state':'', 'zip':''}]};
                getBusinessTypes();
                getStates();
                getBusiness();
                //addAddress();
                that.categories = ['Main','Mailing','Owner']
            };

            var gotoLocation = function (path) {
                $location.path(path);
            };

            var getBusinessTypes = function () {
                var that = $scope;
                businessTypesFactory.index().then(
                    function (response) {
                        if (response.status == undefined) {
                            that.businessTypes = response;
                        } else {
                            that.businessTypes = [];
                        }
                    }
                )
            };

            var getStates = function () {
                var that = $scope;
                statesFactory.index().then(
                    function (response) {
                        if (response.status == undefined) {
                            that.states = response;
                        } else {
                            that.states = [];
                        }
                    }
                )
            };

            var getBusiness = function () {
                businessesFactory.get($stateParams.businessId).then(
                    function (response) {
                        if (response.status == undefined) {
                            that.business = response;
                            if (that.business.active == 1) {
                                that.business.active = true
                            } else {
                                that.business.active = false
                            }
                            ;
                            console.log("Returned business record: " + JSON.stringify(that.business));
                            //that.business.business_type_id = response.business_type.id;

                        } else {
                            that.business = [];
                        }
                    }
                );
            };

            var addAddress = that.addAddress = function () {
                var that = $scope;
                that.business.addresses.push({primary_street: '', secondary_street: '', city: '', state: '', zip: ''});
            };

            var removeAddress = that.removeAddress = function (index, business) {
                var address = business.addresses[index];
                if (address.id) {
                    address._destroy = true;
                } else {
                    business.addresses.splice(index, 1);
                }
            };

            var save = that.save = function () {

                console.log('********** Trying to save! **********');

                var that = $scope;

                that.submitted = true;

                if (that.biz.$valid) {

                    var nb = that.business;

                    if (nb.active == true) {
                        nb.active = 1
                    } else {
                        nb.active = 0
                    }
                    ;

                    var editBusiness = {
                        id: nb.id,
                        name: nb.name,
                        business_type_id: nb.business_type.id,
                        phone: nb.phone,
                        fax: nb.fax,
                        url: nb.url,
                        email: nb.email,
                        sq_footage: nb.sq_footage,
                        num_seats: nb.num_seats,
                        notes: nb.notes,
                        addresses: nb.addresses,
                        active: nb.active
                    };

                    //console.log('********' + JSON.stringify(editBusiness));

                    console.log('Target:  ' + $scope.returnTarget);

                    businessesFactory.update({business: editBusiness});
                    if ($rootScope.returnTarget == 'business') {
                        $location.path('/business/' + $stateParams.businessId);
                    } else {
                        gotoLocation('/businesses');
                    };

                } else {
                    console.log('Validation issue!');
                    console.log(that.biz.$error);
                }
            }

            init();

        }
        ]
    );
}());
// Controller

(function () {
  //angular.module('infinite-scroll').value('THROTTLE_MILLISECONDS', 250);
  angular.module('lms').controller(
    'businessesController',
    ['$scope', '$rootScope', '$confirm', 'businessesFactory', 'filtersFactory', 'FileSaver', 'Blob', function ($scope, $rootScope, $confirm, businessesFactory, filtersFactory, FileSaver, Blob) {

      var that = $scope;

      var getBusinesses = that.getBusinesses = function () {


        //console.log('Arguments: ' + JSON.stringify(arguments));

        var currentPage = arguments.length > 0 && arguments[0] !== angular.isUndefined ? arguments[0] : that.currentPage;
        var itemsPerPage = arguments.length > 1 && arguments[1] !== angular.isUndefined ? arguments[1] : that.itemsPerPage;
        var search = arguments.length > 2 && arguments[2] !== angular.isUndefined ? arguments[2] : that.businessesSearch;
        var status = arguments.length > 3 && arguments[3] !== angular.isUndefined ? arguments[3] : that.businessesStatus;
        var missingLicense = arguments.length > 4 & arguments[4] !== angular.isUndefined ? arguments[4] : that.businessesMissingLicense;
        var cityFilter = arguments.length > 5 && arguments[5] !== angular.isUndefined ? arguments[5] : that.businessesCityFilter;
        var businessTypeFilter = arguments.length > 6 && arguments[6] !== angular.isUndefined ? arguments[6] : that.businessesBusinessTypeFilter;
        var sortColumn = arguments.length > 7 && arguments[7] !== angular.isUndefined ? arguments[7] : that.businessesSortColumnz;
        var sortOrder = arguments.length > 8 && arguments[8] !== angular.isUndefined ? arguments[8] : that.businessesSortOrderz;

        var _status;

        if (status == true) {
          _status = 1;
        } else {
          _status = 0;
        }

        businessesFactory.index(currentPage, itemsPerPage, search, _status, missingLicense, cityFilter, businessTypeFilter, sortColumn, sortOrder).then(function (response) {
          if (response.status == undefined) {
            that.businesses = response;
            that.totalBusinesses = response.size;
          } else {
            that.businesses = [];
            that.totalBusinesses = 0;
          }
        });
      };

      that.setCityFilter = function (obj) {
        if (typeof (obj) != "undefined") {
          var that = $scope;
          that.cf = [];
          that.lastPage = 0;
          that.currentPage = 1;
          for (var i = 0; i < obj.length; i++) {
            that.cf.push({"id": obj[i].id, "city": obj[i].city});
          }
          $rootScope.businessesCityFilter = that.businessesCityFilter = that.cf;   // Pass the selected city back for the query
        }
        return that;
      };

      that.setBusinessTypeFilter = function (obj) {
        var that = $scope;
        if (typeof (obj) != "undefined") {
          that.btf = [];
          that.lastPage = 0;
          that.currentPage = 1;
          for (var i = 0; i < obj.length; i++) {
            that.btf.push({"id": obj[i].id, "name": obj[i].name});
          }
          $rootScope.businessesBusinessTypeFilter = that.businessesBusinessTypeFilter = that.btf;
        }
        return that;
      };


      that.setConditions = function (column, sortSwitch) {
        that = $scope;
        that.businesses = [];

        // if the column has changed then reset sortSwitch to 0
        if (that.businessesSortColumnz != column) {
          sortSwitch = 0;
        }

        that.sortSwitch = sortSwitch;
        that.sortSwitch += 1;
        if (that.sortSwitch > 2) {
          that.sortSwitch = 0;
        }


        console.log('New Sort Switch:  ' + that.sortSwitch);

        that.sortColumnz = column;

        switch(that.sortSwitch) {
          case 0:
            that.sortColumnz = null;
            that.sortOrderz = null;
            $rootScope.businessesSortColumnz = null;
            that.businessesSortColumnz = null;
            that.businessesSortOrderz = null;
            $rootScope.sortColumnz = null;
            break;
          case 1:
            console.log('Case 1 - Met');
            that.sortOrderz = 'asc';
            that.businessesSortOrderz = that.sortOrderz;
            $rootScope.businessesSortOrderz = that.sortOrderz;
            that.sortReverse = false;
            that.businessesSortColumnz = column;
            $rootScope.businessesSortColumnz = column;
            break;
          case 2:
            console.log('Case 2 - Met');
            that.sortOrderz = 'desc';
            that.businessesSortOrderz = that.sortOrderz;
            $rootScope.businessesSortOrderz = that.sortOrderz;
            that.sortReverse = true;
            that.businessesSortColumnz = column;
            $rootScope.businessesSortColumnz = column;
            break;
        }

        that.lastPage = 0;
        that.currentPage = 1;


        getBusinesses(
          that.currentPage,
          that.perPage,
          that.businessesSearch,
          that.businessesStatus,
          that.businessesMissingLicense,
          that.businessesCityFilter,
          that.businessesBusinessTypeFilter,
          that.sortColumnz,
          that.sortOrderz);
      };


      that.clearSearch = function () {
        that = $scope;
        that.businessesSearch = null;
        getBusinesses();
      };

      that.removeBusiness = function (item) {
        var that = $scope;

        $confirm({
          text: 'Are you sure you want to delete this business?',
          title: 'Delete Business',
          ok: 'Yes',
          cancel: 'No'
        })
          .then(function () {
            businessesFactory.remove(that.businesses.businesses[item].id).then(
              function (response) {
                if (response.status == undefined) {
                  that.businesses.businesses.splice(item, 1);
                }
              }
            )
          });

      };

      var populateCities = that.populateCities = function () {
        that = $scope;
        filtersFactory.cities().then(
          function (response) {
            if (response.status == undefined) {
              for (var i = 0; i < response.length; i++) {
                that.cities.push(response[i]);
              }
            }
          }
        );
      };

      var populateBusinessTypes = that.populateBusinessTypes = function () {
        that = $scope;
        filtersFactory.businessTypes().then(
          function (response) {
            if (response.status == undefined) {
              for (var i = 0; i < response.length; i++) {
                that.businessTypes.push(response[i]);
              }
            }
          }
        );
      };

      that.exportBusinesses = function () {
        that = $scope;

        businessesFactory.export(that.businessesSearch, that.businessesStatus, that.businessesMissingLicense, that.businessesCityFilter, that.businessesBusinessTypeFilter, that.businessesSortColumnz, that.businessesSortOrderz).then(
          function (response) {
            if (response.status == undefined) {
              var data = new Blob([response], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'}, true);
              FileSaver.saveAs(data, 'businesses.xlsx');
            }
          }
        );
      }

      that.mailing = function () {
        businessesFactory.mailing(that.businessesSearch, that.businessesStatus, that.businessesMissingLicense, that.businessesCityFilter, that.businessesBusinessTypeFilter, that.businessesSortColumnz, that.businessesSortOrderz).then(
          function (result)
          {
            console.log(result);
            var data = new Blob([result], {type: 'pdf'}, true);
            FileSaver.saveAs(data, 'mailing.pdf');
          }
        );
  
      }




      var init = function () {
        var that = $scope;
        that.currentPage = that.currentPage || 1;
        that.itemsPerPage = that.itemsPerPage || 65;
        that.businessesSearch = that.businessesSearch || [];
        that.businessesStatus = that.businessesStatus || true;
        that.businessesMissingLicense = that.businessesMissingLicense || false;
        that.businessesCityFilter = that.businessesCityFilter || [];
        that.businessesBusinessTypeFilter = that.businessesBusinessTypeFilter || [];
        that.sortColumnz = that.businessesSortColumnz = that.businessesSortColumnz || 'business_name';
        that.sortOrderz = that.businessesSortOrderz = that.businessesSortOrderz || 'asc';
        that.cities = [];
        that.businesses = [];
        that.businessTypes = [];
        that.lastPage = 0;
        that.sortSwitch = 0;
        that.businesses = getBusinesses();
      };

      init();
      populateCities();
      populateBusinessTypes();

    }


    ]
  );
}());

// Controller

(function () {
    angular.module('lms').controller(
        'viewBusinessController',
        ['$scope', '$confirm', '$rootScope', 'businessesFactory', 'contactsFactory', 'contractorsFactory', 'inspectionsFactory', 'licensesFactory', 'pdfFactory', 'modalFactory', '$location', '$stateParams', 'FileSaver', 'Blob',
            function ($scope, $confirm, $rootScope, businessesFactory, contactsFactory, contractorsFactory, inspectionsFactory, licensesFactory, pdfFactory, modalFactory, $location, $stateParams, FileSaver, Blob) {

            var that = $scope;

            var init = function () {

                that.currentPage = 1;
                that.itemsPerPage = 5;

                that.licenseCurrentPage = 1;
                that.licenseItemsPerPage = 5;
                $rootScope.returnTarget = 'businesses';

                getBusiness();
                getContacts();
                getContractors();
                getInspections($stateParams.businessId, that.currentPage, that.itemsPerPage);
                getLicenses($stateParams.businessId, that.licenseCurrentPage, that.licenseItemsPerPage);

                that.topTab = 'contacts';
                that.bottomTab = 'licenses';

                $rootScope.$on('addContactToList', function (event, data) {
                    that.contacts.push(data);
                });

                $rootScope.$on('editContactInList', function (event, data) {
                    that.contacts[findWithAttr(that.contacts, 'id', data.id)] = data;
                });

                $rootScope.$on('addInspectionToList', function (event, data) {
                    that.inspections.inspections.push(data);
                    that.totalInspections += 1;
                });

                $rootScope.$on('editInspectionInList', function (event, data) {
                    that.inspections.inspections[findWithAttr(that.inspections.inspections, 'id', data.id)] = data;
                });

                $rootScope.$on('updateInspectionInList', function(event,data){
                    that.inspections.inspections[findWithAttr(that.inspections.inspections, 'id', data.id)] = data;
                })

                $rootScope.$on('editLicenseInList', function (event, data) {
                    that.licenses.licenses[findWithAttr(that.licenses.licenses, 'id', data.id)] = data;
                });

                $rootScope.$on('addLicenseToList', function (event, data) {
                    that.licenses.licenses.push(data);
                    that.totalLicenses += 1;
                });

                $rootScope.$on('updateLicenseInList', function (event, data) {
                    that.licenses.licenses[findWithAttr(that.licenses.licenses, 'id', data.id)] = data;
                });

                $rootScope.$on('addContractorToBusiness', function (event, data) {
                    that.contractors.push(data);
                });


            };

            var findWithAttr = function (array, attr, value) {
                for (var i = 0; i < array.length; i += 1) {
                    if (array[i][attr] === value) {
                        return i;
                    }
                }
            };

            var setTopTab = that.setTopTab = function (tabName) {
                console.log('Setting tab to: ' + tabName);
                that.topTab = tabName;
            };

            var isTopSet = that.isTopSet = function (tabName) {
                return that.topTab === tabName;
            };

            var setBottomTab = that.setBottomTab = function (tabName) {
                console.log('Setting tab to: ' + tabName);
                that.bottomTab = tabName;
            };

            var isBottomSet = that.isBottomSet = function (tabName) {
                return that.bottomTab === tabName;
            };


            var gotoLocation = function (path) {
                $location.path(path);
            };

            var editLocation = that.editLocation = function() {
                $rootScope.returnTarget = 'business';
                $location.path('/business/' + $stateParams.businessId + '/edit');
            };

            var getBusiness = function () {
                businessesFactory.get($stateParams.businessId).then(
                    function (response) {
                        if (response.status == undefined) {
                            that.business = response;
                        } else {
                            that.business = [];
                        }
                    }
                );
            };

            var pageChanged = that.pageChanged = function (newPage) {

                that = $scope;

                getInspections($stateParams.businessId, newPage, that.itemsPerPage);
            };

            var licensePageChanged = that.licensePageChanged = function (newPage) {

                that = $scope;
                getLicenses($stateParams.businessId, newPage, that.licenseItemsPerPage);
            };

            var getInspections = function (businessId, page, perPage) {

                var that = $scope;

                inspectionsFactory.getByBusiness(businessId, page, perPage).then(
                    function (response) {

                        if (response.status == undefined) {
                            that.inspections = response;
                            that.totalInspections = response.size;
                        } else {
                            that.inspections = [];
                            that.totalInspections = 0;
                        }

                    }
                );
            };

            var getLicenses = function (businessId, page, perPage) {

                var that = $scope
                licensesFactory.getByBusiness(businessId, page, perPage).then(
                    function (response) {
                        if (response.status == undefined) {
                            that.licenses = response;
                            that.totalLicenses = response.size;
                        } else {
                            that.licenses = [];
                            that.totalLicenses = 0;
                        }
                    }
                );
            };


            var getContacts = function () {
                contactsFactory.getByBusiness($stateParams.businessId).then(
                    function (response) {
                        if (response.status == undefined) {
                            that.contacts = response;
                        } else {
                            that.contacts = [];
                        }
                    }
                );
            };

            var getContractors = function () {
                contractorsFactory.getByBusiness($stateParams.businessId).then(
                    function (response) {
                        if (response.status == undefined) {
                            that.contractors = response;
                        } else {
                            that.contractors = [];
                        }
                    }
                );
            };

            var showInspectionModal = that.showInspectionModal = function () {
                var modal = modalFactory.showModal('newInspectionsModalController', 'app/inspections/inspection_new_modal.html');
                modal.activate();
            }

            var showLicenseModal = that.showLicenseModal = function() {
                var modal = modalFactory.showModal('newLicenseModalController', 'app/licenses/licenses_new_modal.html');
                modal.activate();
            };

            var showContactModal = that.showContactModal = function () {
                var modal = modalFactory.showModal('addContactsController', 'app/contacts/add_contact.html');
                modal.activate();
            }

            var showEditContactModal = that.showEditContactModal = function (item) {
                var modal = modalFactory.showModal('editContactsController', 'app/contacts/edit_contact.html');
                modal.activate();
            };

            var showContractorLinkModal = that.showContractorModal = function () {
                var modal = modalFactory.showModal('linkContractorModalController', 'app/contractors/link_contractor_to_business_modal.html');
                modal.activate();
            };

            var linkContractor = that.linkContractor = function () {
                showContractorLinkModal();
            };

            var showViewContractorModal = that.showViewContractorModal = function (item) {
                var modal = modalFactory.showModal('viewContractorsModalController', 'app/contractors/view_contractor_modal.html');
                modal.activate();
            }

            var showInspectionEditModal = that.showInspectionEditModal = function (item) {
                var modal = modalFactory.showModal('editInspectionsModalController', 'app/inspections/inspection_edit_modal.html');
                modal.activate();
            };

            var showLicenseEditModal = that.showLicenseEditModal = function (item) {
                var modal = modalFactory.showModal('editLicenseModalController', 'app/licenses/license_edit_modal.html');
                modal.activate();
            }

            var addInspection = that.addInspection = function () {
                showInspectionModal();
            };

            var addLicense = that.addLicense = function() {
                showLicenseModal();
            };

            var addContact = that.addContact = function () {
                showContactModal();
            };

            var viewContractor = that.viewContractor = function (item) {
                var that = $scope;
                $rootScope.contactractorParams = {
                    businessId: $stateParams.businessId,
                    contractorId: that.contractors[item].id
                };
                showViewContractorModal();
            };


            var editContact = that.editContact = function (item) {
                var that = $scope;
                $rootScope.contactParams = {businessId: $stateParams.businessId, contactId: that.contacts[item].id};
                showEditContactModal();
            };

            var editInspection = that.editInspection = function (item) {
                var that = $scope;
                $rootScope.inspectionParams = {
                    businessId: $stateParams.businessId,
                    inspectionId: item.id//inspectionId: that.inspections.inspections[item].id
                };
                showInspectionEditModal();
            };

            var editLicense = that.editLicense = function (item) {

                console.log('Test: ' + JSON.stringify(item));

                var that = $scope;
                $rootScope.licenseParams = {
                    businessId: $stateParams.businessId,
                    licenseId: item.id
                };
                showLicenseEditModal();
            };


            var removeContact = that.removeContact = function (item) {
                var that = $scope;

                $confirm({
                    text: 'Are you sure you want to remove this contact?',
                    title: 'Remove Contact',
                    ok: 'Yes',
                    cancel: 'No'
                })
                    .then(function () {
                        contactsFactory.remove(that.contacts[item].id).then(
                            function (response) {
                                if (response.status == undefined) {
                                    that.contacts.splice(item, 1);
                                }
                            }
                        )
                    });
            };

            var removeContractor = that.removeContractor = function (item) {
                var that = $scope;

                $confirm({
                    text: 'Are you sure you want to remove this contractor?',
                    title: 'Remove Contractor',
                    ok: 'Yes',
                    cancel: 'No'
                }).then(function () {
                    contractorsFactory.removeBusinessContractor($stateParams.businessId, that.contractors[item].id).then(
                        function (response) {
                            if (response.status == undefined) {
                                that.contractors.splice(item)
                            }
                        }
                    )
                })
            };

            var removeInspection = that.removeInspection = function (item) {
                var that = $scope;

                $confirm({
                    text: 'Are you sure you want to remove this inspection?',
                    title: 'Remove Inspection',
                    ok: 'Yes',
                    cancel: 'No'
                }).then(function () {
                    inspectionsFactory.remove(item.id).then(
                        function (response) {
                            if (response.status == undefined) {
                                that.inspections.inspections.splice(item, 1);
                                that.totalInspections -= 1;

                            }
                        }
                    )
                });

            };

            var removeLicense = that.removeLicense = function(item) {
                var that = $scope;

                $confirm({
                    text: 'Are you sure you wnat to remove this license?',
                    title: 'Remove License',
                    ok: 'Yes',
                    cancel: 'No'
                }).then(function() {
                    licensesFactory.remove(item.id).then(
                        function(response) {
                            if (response.status == undefined) {
                                that.licenses.licenses.splice(item, 1);
                                that.totalLicenses -= 1;
                            }
                        }
                    )
                })
            };

            var createLicensePDF = that.createLicensePDF = function (item) {

                pdfFactory.create(item.id).then(
                    function (response) {
                        if (response.status == undefined) {
                            var file = new Blob([response], {type: 'application/pdf'});
                            FileSaver.saveAs(file, 'license.pdf');
                        }
                    }
                )


            };

            init();

        }
        ]
    );
}());
(function() {
  'use strict';

  angular
    .module('lms')
    .run(runBlock);

  /** @ngInject */
  function runBlock($log) {

    $log.debug('runBlock end');
  }

})();

(function () {
    angular.module('lms').config(
        ['$stateProvider', '$urlRouterProvider', '$authProvider', 'componentPathPrefix', function ($stateProvider, $urlRouterProvider, $authProvider, componentPathPrefix) {

            //$authProvider.configure({
            //    apiUrl: '',
            //    authProviderPaths: {
            //      facebook: '/auth/facebook'
            //    }
            //});

            $stateProvider

                .state("main", {
                    url: "/",
                    templateUrl: "app/signin/login.html"
                    //controller: "SignInController"
                })
                .state("configure", {
                    url: '/configure',
                    templateUrl: 'app/config_settings/settings.html',
                    controller: 'settingsController'
                })
                .state('configure.business_types', {
                    //url: '/business_types',
                    templateUrl: 'app/config_settings/business_types/business_types.html',
                    controller: 'businessTypesController' //,
                    //controllerAs: 'businessType'
                })
                .state('configure.contractors', {
                    templateUrl: 'app/config_settings/contractors/contractors.html',
                    controller: 'contractorsController'
                })
                .state('configure.contact_types', {
                    //url: '/contact_types',
                    templateUrl: 'app/config_settings/contact_types/contact_types.html',
                    controller: 'contactTypesController' //,
                    //controllerAs: 'contactType'
                })
                .state('configure.license_types', {
                    //url: '/license_types',
                    templateUrl: 'app/config_settings/license_types/license_types.html',
                    controller: 'licenseTypesController' //,
                    //controllerAs: 'businessType'
                })
                .state('configure.license_settings', {
                    //url: '/license_types',
                    templateUrl: 'app/config_settings/license_settings/license_settings.html',
                    controller: 'licenseSettingsController' //,
                    //controllerAs: 'businessType'
                })
                .state('configure.license_purposes', {
                    //url: '/license_purposes',
                    templateUrl: 'app/config_settings/license_purposes/license_purposes.html',
                    controller: 'licensePurposesController' //,
                    //controllerAs: 'businessType'
                })
                .state('configure.license_officials', {
                    templateUrl: 'app/config_settings/license_officials/license_officials.html',
                    controller: 'licenseOfficialsController'
                })
                .state('configure.contractor_types', {
                    //url: '/contractor_types',
                    templateUrl: 'app/config_settings/contractor_types/contractor_types.html',
                    controller: 'contractorTypesController' //,
                    //controllerAs: 'businessType'
                })
                .state('configure.inspection_types', {
                    //url: '/inspection_types',
                    templateUrl: 'app/config_settings/inspection_types/inspection_types.html',
                    controller: 'inspectionTypesController' //,
                    //controllerAs: 'businessType'
                })
                .state('configure.states',
                    {
                        //url: '/states',
                        templateUrl: 'app/config_settings/states/states.html',
                        controller: 'statesController' //,
                        //controllerAs: 'state'
                    }
                )
                .state('configure.inspection_reasons', {
                    //url: '/inspection_reasons',
                    templateUrl: 'app/config_settings/inspection_reasons/inspection_reasons.html',
                    controller: 'inspectionReasonsController' //,
                })
                .state('configure.evaluation_statuses', {
                    //url: '/evaluation_statuses',
                    templateUrl: 'app/config_settings/evaluation_statuses/evaluation_statuses.html',
                    controller: 'evaluationStatusesController',
                })
                .state('list_licenses',
                    {
                        url: '/licenses',
                        templateUrl: 'app/licenses/licenses_index.html',
                        controller: 'licensesController',
                        controllerAs: 'lic'
                    }
                )
                .state('new_license',
                    {
                        url: '/licenses/new',
                        templateUrl: 'app/licenses/licenses_new.html',
                        controller: 'newLicensesController' //,
                        //controllerAs: 'newLicense'
                    }
                )
                .state('edit_license',
                    {
                        url: '/license/:licenseId/edit',
                        templateUrl: 'app/licenses/licenses_edit.html',
                        controller: 'editLicensesController' //,
                        //controllerAs: 'newLicense'
                    }
                )
                .state('list_businesses',
                    {
                        url: '/businesses',
                        templateUrl: 'app/businesses/businesses_index.html',
                        controller: 'businessesController',
                        controllerAs: 'biz'
                    }
                )
                .state('new_business',
                    {
                        url: '/businesses/new',
                        templateUrl: 'app/businesses/businesses_new.html',
                        controller: 'newBusinessesController' //,
                        //controllerAs: 'newBusiness'
                    }
                )
                .state('edit_business',
                    {
                        url: '/business/:businessId/edit',
                        templateUrl: 'app/businesses/business_edit.html',
                        controller: 'editBusinessController'
                    }
                )
                .state('view_business',
                    {
                        url: '/business/:businessId',
                        templateUrl: 'app/businesses/business_view.html',
                        controller: 'viewBusinessController'
                    }
                )
                .state('list_inspections',
                    {
                        url: '/inspections',
                        templateUrl: 'app/inspections/inspections_index.html',
                        controller: 'inspectionsController',
                        controllerAs: 'inspection'
                    })
                .state('edit_inspection',
                    {
                        url: '/inspection/:inspectionId/edit',
                        templateUrl: 'app/inspections/inspection_edit.html',
                        controller: 'editInspectionsController'
                    })
                .state('new_inspection',
                    {
                        url: '/inspections/new',
                        templateUrl: 'app/inspections/inspections_new.html',
                        controller: 'newInspectionsController' //,
                    }
                )
                .state('view_inspection',
                    {
                        url: '/inspection/:inspectionId',
                        templateUrl: 'app/inspections/inspection_view.html',
                        controller: 'viewInspectionController',
                    }
                )



                //.state("register", {
                //    url: "/register",
                //    templateUrl: "app/register/landing.html"
                //})
                //.state("main.password_reset", {
                //    url: "users/password_reset",
                //    templateUrl: "app/users/password_reset.html",
                //    controller: "PasswordsCtrl"
                //})
                //.state("main.password_update", {
                //    url: "users/password_update",
                //    templateUrl: "app/users/password_update.html",
                //    controller: "UsersCtrl"
                //})
                //.state("main.register", {
                //    url: "users/register",
                //    templateUrl: "app/users/register.html",
                //    controller: "UsersCtrl"
                //})
                //.state("main.log_in", {
                //  url: "users/log_in",
                //  templateUrl: "app/users/log_in.html",
                //  controller: "UsersCtrl"
                //})

                .state('logout', {
                    url: '/logout',
                    templateUrl: 'app/logout/logout.html',
                    controller: 'LogoutController'
                })

            $urlRouterProvider.otherwise('/');
        }]);
}());


(function () {
    'use strict';

    angular
        .module('lms')
        .filter('tel', function () {
            return function (tel) {
                if (!tel) {
                    return '';
                }

                var value = tel.toString().trim().replace(/^\+/, '');

                if (value.match(/[^0-9]/)) {
                    return tel;
                }

                var country, city, number;

                switch (value.length) {
                    case 10: // +1PPP####### -> C (PPP) ###-####
                        country = 1;
                        city = value.slice(0, 3);
                        number = value.slice(3);
                        break;

                    case 11: // +CPPP####### -> CCC (PP) ###-####
                        country = value[0];
                        city = value.slice(1, 4);
                        number = value.slice(4);
                        break;

                    case 12: // +CCCPP####### -> CCC (PP) ###-####
                        country = value.slice(0, 3);
                        city = value.slice(3, 5);
                        number = value.slice(5);
                        break;

                    default:
                        return tel;
                }

                if (country == 1) {
                    country = "";
                }

                number = number.slice(0, 3) + '-' + number.slice(3);

                return (country + " (" + city + ") " + number).trim();
            };
        }).filter('customAddressOrder', function(){
        function customOrder(item) {
            switch(item) {
                case 'Main':
                    return 1;
                case 'Mailing':
                    return 2;
                case 'Owner':
                    return 3;
            }
        }
        return function(items, field){
            var filtered = [];
            angular.forEach(items, function(item){
                filtered.push(item);
            });
            filtered.sort(function(a,b) {
                return (customOrder(a.category) > customOrder(b.category) ? 1 : -1);
            });
            return filtered;
        };
    });

    function Ctrl($scope) {
        $scope.phoneNumber = 4085265552;

    }

})();
/* global malarkey:false, moment:false */
(function() {
  'use strict';

  angular
    .module('lms')
    .constant('componentPathPrefix','/assets/components/')
    .constant('malarkey', malarkey)
    .constant('moment', moment)
    .constant('apiUrl', '//lms.formyula.com')
    .constant('apiPort', 3000)

})();

(function() {
  'use strict';

  angular
    .module('lms')
    .config(config);

  /** @ngInject */
  function config($logProvider, toastrConfig) {
    // Enable log
    $logProvider.debugEnabled(true);

    // Set options third-party lib
    toastrConfig.allowHtml = true;
    toastrConfig.timeOut = 3000;
    toastrConfig.positionClass = 'toast-top-right';
    toastrConfig.preventDuplicates = true;
    toastrConfig.progressBar = true;
  }

})();

angular.module("lms").run(["$templateCache", function($templateCache) {$templateCache.put("app/businesses/_form.html","<div class=form-group><label for=name class=col-sm-2>Business Name</label><div class=col-sm-10><input type=name class=form-control id=name name=name ng-model=business.name placeholder=\"Enter text\" required></div></div><div class=form-group><label for=businessType class=col-sm-2>Business Type</label><div class=col-sm-10><select name=businessType id=businessType ng-model=business.business_type_id placeholder=\"Please choose\" required><option ng-repeat=\"option in businessTypes\" value={{option.id}}>{{option.name | uppercase}}</option></select></div></div><div class=form-group><label for=phone class=col-sm-2>Phone</label><div class=col-sm-10><input type=tel class=form-control id=phone name=phone ng-model=business.phone ui-mask=\"(999) 999-9999\" required></div></div><div class=form-group><label for=fax class=col-sm-2>Fax</label><div class=col-sm-10><input type=tel class=form-control id=fax name=fax ng-model=business.fax ui-mask=\"(999) 999-9999\"></div></div><div class=form-group><label for=url class=col-sm-2>Website address</label><div class=col-sm-10><input type=url class=form-control name=url id=url ng-model=business.url placeholder=\"Enter main email address\"></div></div><div ng-repeat=\"address in business.addresses\"><hr><div ng-hide=address._destroy><div class=form-group><div class=col-sm-offset-10><a ng-click=\"removeAddress($index, business)\" class=\"btn btn-xs btn-danger\">X Remove Address</a></div></div><div class=form-group><label for=primary_street class=col-sm-2>Primary Street</label><div class=col-sm-10><input type=name class=form-control id=primary_street ng-model=address.primary_street name=primary_street placeholder=\"Enter text\" required></div></div><div class=form-group><label for=secondary_street class=col-sm-2>Secondary Street</label><div class=col-sm-10><input type=name class=form-control id=secondary_street ng-model=address.secondary_street name=secondary_street placeholder=\"Enter text\"></div></div><div class=form-group><label for=city class=col-sm-2>City</label><div class=col-sm-10><input type=name class=form-control id=city name=city ng-model=address.city placeholder=\"Enter text\" required></div></div><div class=form-group><label for=state class=col-sm-2>State</label><div class=col-sm-10><select name=state id=state ng-model=address.state placeholder=\"Please choose\" required><option ng-repeat=\"option in states | orderBy:\'name\'\" value={{option.name}}>{{option.name | uppercase}}</option></select></div></div><div class=form-group><label for=zip class=col-sm-2>Zip Code</label><div class=col-sm-10><input type=zip class=form-control id=zip name=zip ng-model=address.zip placeholder=\"Enter text\" required></div></div></div></div><div class=\"form-group container\"><div><a ng-click=addAddress() class=\"btn btn-xs btn-success\">+ Add Address</a></div></div><div class=\"form-group container\"><div class=pull-left><a class=\"btn btn-xs btn-default\" href=/#/businesses>Cancel</a> <button type=submit class=\"btn btn-xs btn-primary\" ng-click=\"submitted=true\">Save</button></div></div>");
$templateCache.put("app/businesses/business_edit.html","<div class=container><h2>Edit Business</h2><form class=\"form-horizontal css-form\" name=biz ng-submit=save() novalidate><div class=form-group><label for=name class=col-sm-2>Business Name</label><div class=col-sm-10><input type=name class=form-control id=name name=name ng-model=business.name placeholder=\"Enter text\" required></div></div><div class=form-group><label class=col-sm-2>Business Type</label><div class=col-sm-10><ui-select ng-model=business.business_type theme=bootstrap title=\"Choose an business type\\\"><ui-select-match placeholder=\"Select or search...\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"item in businessTypes | filter: $select.search\"><div ng-bind-html=\"item.name | highlight: $select.search\"></div></ui-select-choices></ui-select></div></div><div class=form-group><label class=col-sm-2>Active</label><div class=col-sm-10><input type=checkbox class=form-control name=active id=active ng-model=business.active></div></div><div class=form-group><label for=phone class=col-sm-2>Phone</label><div class=col-sm-10><input type=tel class=form-control id=phone name=phone ng-model=business.phone ui-mask=\"(999) 999-9999\" required></div></div><div class=form-group><label for=fax class=col-sm-2>Fax</label><div class=col-sm-10><input type=tel class=form-control id=fax name=fax ng-model=business.fax ui-mask=\"(999) 999-9999\" ui-mask-use-viewvalue=true></div></div><div class=form-group><label for=email class=col-sm-2>Email address</label><div class=col-sm-10><input type=email class=form-control name=email id=email ng-model=business.email placeholder=\"Enter main email address\"></div></div><div class=form-group><label for=url class=col-sm-2>Website address</label><div class=col-sm-10><input type=url class=form-control name=url id=url ng-model=business.url placeholder=\"Enter main website address\"></div></div><div class=form-group><label for=sq-foot class=col-sm-2>Square Footage</label><div class=col-sm-10><input type=number class=form-control id=sq-foot name=sq-foot ng-model=business.sq_footage placeholder=\"Enter number\"></div></div><div class=form-group><label for=num-seats class=col-sm-2>Number of Seats</label><div class=col-sm-10><input type=number class=form-control id=num-seats name=sq-foot ng-model=business.num_seats placeholder=\"Enter number\" min=1></div></div><div class=form-group><label for=num-seats class=col-sm-2>Notes</label><div class=col-sm-10><textarea class=form-control id=notes name=sq-foot ng-model=business.notes col=5 placeholder=\"Enter notes\"></textarea></div></div><div ng-repeat=\"address in business.addresses\"><hr><div ng-hide=address._destroy><div class=form-group><div class=col-sm-offset-10><a ng-click=\"removeAddress($index, business)\" class=\"btn btn-xs btn-danger\">X Remove Address</a></div></div><div class=form-group><label class=col-sm-2>Category</label><div class=col-sm-10><ui-select ng-model=address.category theme=bootstrap title=\"Choose a category\\\" required><ui-select-match placeholder=\"Select or search...\">{{$select.selected}}</ui-select-match><ui-select-choices repeat=\"item in categories | filter: $select.search\"><div ng-bind-html=\"item | highlight: $select.search\"></div></ui-select-choices></ui-select></div></div><div class=form-group><label for=primary_street class=col-sm-2>Primary Street</label><div class=col-sm-10><input type=name class=form-control id=primary_street ng-model=address.primary_street name=primary_street placeholder=\"Enter text\" required></div></div><div class=form-group><label for=secondary_street class=col-sm-2>Secondary Street</label><div class=col-sm-10><input type=name class=form-control id=secondary_street ng-model=address.secondary_street name=secondary_street placeholder=\"Enter text\"></div></div><div class=form-group><label for=city class=col-sm-2>City</label><div class=col-sm-10><input type=name class=form-control id=city name=city ng-model=address.city placeholder=\"Enter text\" required></div></div><div class=form-group><label class=col-sm-2>State</label><div class=col-sm-10><ui-select ng-model=address.state theme=bootstrap title=\"Choose an state\\\" required><ui-select-match placeholder=\"Select or search...\">{{$select.selected.abbreviation}}</ui-select-match><ui-select-choices repeat=\"item.abbreviation as item in states | filter: $select.search\"><div ng-bind-html=\"item.abbreviation | highlight: $select.search\"></div></ui-select-choices></ui-select></div></div><div class=form-group><label for=zip class=col-sm-2>Zip Code</label><div class=col-sm-10><input type=zip class=form-control id=zip name=zip ng-model=address.zip placeholder=\"Enter text\" required></div></div></div></div><div class=\"form-group container\"><div><a ng-click=addAddress() class=\"btn btn-success\">+ Add Address</a></div></div><div class=\"form-group container\"><div class=pull-left><a class=\"btn btn-xs btn-default\" href=/#/businesses>Cancel</a> <button type=submit class=\"btn btn-xs btn-primary\" ng-click=\"submitted=true\" ng-disabled=$scope.biz.$invalid>Save</button></div></div><div ng-messages=biz.$error style=color:maroon role=alert><div ng-message=required>You did not enter a field</div><div ng-message=minlength>Your field is too short</div><div ng-message=maxlength>Your field is too long</div></div><div ng-messages=biz.$error.email>{{!!biz.$error.email}}</div></form></div><style type=text/css>.css-form input.ng-invalid, .css-form select.ng-invalid {\n    background-color: lightyellow;\n    color: black;\n  }\n\n  .css-form input.ng-invalid.ng-touched {\n    background-color: indianred;\n  }\n\n  .css-form input.ng-valid.ng-touched {\n    background-color: palegreen;\n  }</style>");
$templateCache.put("app/businesses/business_view.html","<div class=container><h2><input type=button class=\"btn btn-xs btn-info\" style=float:right ng-click=\"$scope.returnTarget=\'business\';editLocation();\" value=Edit>{{business.name}}</h2><h4>{{business.business_type.name}}</h4><table style=\"margin-bottom: 10px\"><tr><td style=\"text-align: right;font-weight: 700\">phone:</td><td style=\"padding-left:10px;text-align: left\">{{business.phone | tel}}</td><td style=\"padding-left:20px;text-align: right;font-weight: 700\">web address:</td><td style=\"padding-left:10px;text-align: left\">{{business.url || \'none\'}}</td><td style=\"padding-left:20px;text-align: right;font-weight: 700\">notes:</td><td rowspan=3 style=\"max-width:350px;padding-left:10px;text-align: left;vertical-align:top\">{{business.notes || \'none\'}}</td></tr><tr><td style=\"text-align: right;font-weight: 700\">fax:</td><td style=\"padding-left:10px;text-align: left\">{{business.fax | tel}}</td><td style=\"padding-left:20px;text-align: right;font-weight: 700\">sq footage:</td><td style=\"padding-left:10px;text-align: left\">{{business.sq_footage || \'none\'}}</td></tr><tr><td style=\"text-align: right;font-weight: 700\">email:</td><td style=\"padding-left:10px;text-align: left\">{{business.email || \'none\'}}</td><td style=\"padding-left:20px;text-align: right;font-weight: 700\">number of seats:</td><td style=\"padding-left:10px;text-align: left\">{{business.num_seats || \'none\'}}</td></tr></table><address><div ng-repeat=\"address in business.addresses | customAddressOrder:\'category\'\" class=\"col-md-4 well\" style=margin-right:20px;line-height:10px><p class=address_category><strong>{{address.category}}</strong></p><p class=address_address1>{{address.primary_street}}</p><p class=address_address2 ng-show-if=\"{{address.secondary_street.size > 0}}\">{{address.secondary_street}}</p><p class=address_city>{{address.city}}</p><p class=address_state>{{address.state}}<span>, </span>{{address.zip}}</p></div></address></div><div class=container><ul class=\"nav nav-tabs\"><li role=presentation ng-class=\"{active:isTopSet(\'contacts\')}\"><a href ng-click=\"setTopTab(\'contacts\')\">Contacts</a></li><li role=presentation ng-class=\"{active:isTopSet(\'contractors\')}\"><a href ng-click=\"setTopTab(\'contractors\')\">Contractors</a></li></ul><div class=tab-content><div ng-show=\"isTopSet(\'contacts\')\"><table ng-show=\"contacts.length > 0\" class=\"table table-striped\" style=margin-top:20px><tr><th>Name</th><th>Contact Type</th><th>Phone</th><th>Email</th><th>Fax</th><th>Actions</th></tr><tr ng-repeat=\"contact in contacts\"><td>{{contact.first_name}} {{contact.last_name}}</td><td>{{contact.contact_type.name}} <span ng-show=\"contact.contact_type.name.toUpperCase() == \'FOOD CERTIFIED\'\">(Exp: {{contact.exp_date}})</span></td><td>{{contact.phone | tel}}</td><td>{{contact.email || \'none\'}}</td><td>{{(contact.fax | tel) || \'none\'}}</td><td><button class=\"btn btn-xs btn-info\" ng-click=editContact($index);>Edit</button> &nbsp; <button class=\"btn btn-xs btn-danger\" ng-click=removeContact($index);>Remove</button></td></tr></table><span class=col-sm-12 ng-show=\"contacts.length == 0\" style=margin-top:20px>There are no contacts for this business.</span> <button class=\"btn btn-xs btn-primary\" style=margin-top:20px ng-click=addContact();>Add Contact</button></div><div ng-show=\"isTopSet(\'contractors\')\"><table ng-show=\"contractors.length >0\" class=\"table table-striped\" style=margin-top:20px><tr><th>Name</th><th>Contractor Type</th><th>Phone</th><th>Email</th><th>Actions</th></tr><tr ng-repeat=\"contractor in contractors\"><td>{{contractor.name}}</td><td>{{contractor.contractor_type.name}}</td><td>{{contractor.phone | tel}}</td><td>{{contractor.email}}</td><td><button class=\"btn btn-xs btn-primary\" ng-click=viewContractor($index);>View</button> &nbsp; <button class=\"btn btn-xs btn-danger\" ng-click=removeContractor($index);>Remove</button></td></tr></table><span class=col-sm-12 ng-show=\"contractors.length == 0\" style=margin-top:20px>There are no contractors for this business.</span> <button class=\"btn btn-xs btn-primary\" style=margin-top:20px ng-click=linkContractor();>Add Contractor</button></div></div></div><div class=container><hr><ul class=\"nav nav-tabs\"><li role=presentation ng-class=\"{active:isBottomSet(\'licenses\')}\"><a href ng-click=\"setBottomTab(\'licenses\')\">Licenses</a></li><li role=presentation ng-class=\"{active:isBottomSet(\'inspections\')}\"><a href ng-click=\"setBottomTab(\'inspections\')\">Inspections</a></li></ul><div class=tab-content><div ng-show=\"isBottomSet(\'inspections\')\"><h3>Inspections</h3><table class=\"table table-striped\" ng-show=\"inspections.inspections.length > 0\"><thead><tr><th>Inspection Date</th><th>Type</th><th>Reason</th><th>Evaluation</th><th>Inspector</th><th>Actions</th></tr></thead><tbody><tr dir-paginate=\"inspection in inspections.inspections | orderBy:\'-inspected_on\' | itemsPerPage: itemsPerPage\" total-items=totalInspections current-page=currentInspectionPage pagination-id=inspections><td>{{inspection.inspected_on | date : \'M/d/yyyy\' : \'UTC\'}}</td><td>{{inspection.inspection_type.name}}</td><td>{{inspection.inspection_reason.name}}</td><td>{{inspection.evaluation_status.name}}</td><td>{{inspection.inspector.name}}</td><td><a class=\"btn btn-xs btn-info\" ng-click=editInspection(inspection)>Edit</a> <a class=\"btn btn-xs btn-danger\" ng-click=removeInspection(inspection)>Remove</a></td></tr></tbody></table><button class=\"btn btn-xs btn-primary\" ng-click=addInspection();>Add Inspection</button><dir-pagination-controls class=pull-right on-page-change=pageChanged(newPageNumber) pagination-id=inspections></dir-pagination-controls><span class=col-sm-12 ng-show=\"inspections.inspections.length == 0\" style=margin-top:20px>There are no inspections for this business.</span></div></div><div ng-show=\"isBottomSet(\'licenses\')\"><h3>Licenses</h3><table class=\"table table-striped\" ng-show=\"licenses.licenses.length > 0\"><thead><tr><th>Expires On</th><th>License No.</th><th>Type</th><th>Purpose</th><th>Actions</th></tr></thead><tbody><tr dir-paginate=\"item in licenses.licenses | orderBy:\'-end_date\' | itemsPerPage: itemsPerPage\" total-items=totalLicenses current-page=currentPage pagination-id=licenses><td>{{item.end_date | date : \'M/d/yyyy\' : \'UTC\'}}</td><td>{{item.license_number}}</td><td>{{item.license_type.name}}</td><td>{{item.license_purpose.name}}</td><td><a class=\"btn btn-xs btn-info\" ng-click=createLicensePDF(item)>Print</a> <a class=\"btn btn-xs btn-primary\" ng-click=editLicense(item)>Edit</a> <a class=\"btn btn-xs btn-danger\" ng-click=removeLicense(item)>Remove</a></td></tr></tbody></table><button class=\"btn btn-xs btn-primary\" ng-click=addLicense();>Add License</button><dir-pagination-controls class=pull-right on-page-change=licensePageChanged(newPageNumber) pagination-id=licenses></dir-pagination-controls></div><span class=col-sm-12 ng-show=\"license.licenses.length == 0\" style=margin-top:20px>There are no licenses for this business.</span></div>");
$templateCache.put("app/businesses/businesses_index.html","<div class=container-fluid><div class=col-md-12><h2>Businesses</h2></div><div class=col-md-12><form class=form-inline><div class=input-group><span class=input-group-addon><i class=\"glyphicon glyphicon-search\"></i></span> <input ng-model=businessesSearch id=search class=form-control placeholder=Search ng-change=setConditions() ng-model-options=\"{debounce: 750}\" autocomple=off> <span class=input-group-addon>Active&nbsp;&nbsp;<input type=checkbox ng-model=businessesStatus ng-change=getBusinesses()></span><span class=input-group-addon>Not Licensed For Current Year&nbsp;&nbsp;<input type=checkbox ng-model=businessesMissingLicense ng-change=getBusinesses()></span><span class=input-group-addon><i class=\"glyphicon glyphicon-remove\" ng-click=clearSearch()></i></span></div><br><br><div class=input-group><ui-select multiple ng-model=businessesCityFilter theme=bootstrap sortable close-on-select=false style=\"width: 350px\" ng-change=setCityFilter(businessesCityFilter);getBusinesses();><ui-select-match placeholder=\"Filter by City\">{{$item.city}}</ui-select-match><ui-select-choices repeat=\"item in cities\"><div ng-bind-html=\"item.city | highlight: $select.search\"></div></ui-select-choices></ui-select></div><div class=input-group><ui-select multiple ng-model=businessesBusinessTypeFilter theme=bootstrap sortable close-on-select=false style=\"width: 350px\" ng-change=setBusinessTypeFilter(businessesBusinessTypeFilter);getBusinesses();><ui-select-match placeholder=\"Filter by Type\">{{$item.name}}</ui-select-match><ui-select-choices repeat=\"item in businessTypes\"><div ng-bind-html=\"item.name | highlight: $select.search\"></div></ui-select-choices></ui-select></div></form><br><div total-items=totalBusinesses>{{totalBusinesses}} Businesses Found</div><div><a ng-href=#/businesses/new class=\"btn btn-xs btn-primary\" type=button style=margin-top:20px>Add Business</a> <a class=\"btn btn-xs btn-info btn-xs\" style=margin-top:20px ng-click=\"exportBusinesses() \">Export</a> <a class=\"btn btn-xs btn-info btn-xs\" style=margin-top:20px ng-click=\"mailing() \">Create Mailing Labels</a></div></div><!--<div >--><!--<img ng-repeat=\'image in images\' ng-src=\'http://placehold.it/225x250&text={{image}}\'>--><!--</div>--><div class=col-md-12><dir-pagination-controls class=pull-right on-page-change=getBusinesses() pagination-id=businesses></dir-pagination-controls><table class=\"table table-striped\" ng-show=\"businesses.businesses.length > 0\"><thead><tr><th><a href=\"\" ng-click=\"setConditions(\'business_name\',sortSwitch);\">Business Name<span ng-show=\"sortReverse && sortColumnz==\'business_name\'\" class=\"glyphicon glyphicon-chevron-down\"></span> <span ng-show=\"!sortReverse && sortColumnz==\'business_name\'\" class=\"glyphicon glyphicon-chevron-up\"></span></a></th><th><a href=\"\" ng-click=\"setConditions(\'business_type\',sortSwitch);\">Type<span ng-show=\"sortReverse && sortColumnz==\'business_type\'\" class=\"glyphicon glyphicon-chevron-down\"></span> <span ng-show=\"!sortReverse && sortColumnz==\'business_type\'\" class=\"glyphicon glyphicon-chevron-up\"></span></a></th><th><a href=\"\" ng-click=\"setConditions(\'street\',sortSwitch);\">Street<span ng-show=\"sortReverse && sortColumnz==\'street\'\" class=\"glyphicon glyphicon-chevron-down\"></span> <span ng-show=\"!sortReverse && sortColumnz==\'street\'\" class=\"glyphicon glyphicon-chevron-up\"></span> </a></th><th><a href=\"\" ng-click=\"setConditions(\'city\',sortSwitch);\">City<span ng-show=\"sortReverse && sortColumnz==\'city\'\" class=\"glyphicon glyphicon-chevron-down\"></span> <span ng-show=\"!sortReverse && sortColumnz==\'city\'\" class=\"glyphicon glyphicon-chevron-up\"></span> </a></th><th><a href=\"\" ng-click=\"setConditions(\'phone\',sortSwitch);\">Phone<span ng-show=\"sortReverse && sortColumnz==\'phone\'\" class=\"glyphicon glyphicon-chevron-down\"></span> <span ng-show=\"!sortReverse && sortColumnz==\'phone\'\" class=\"glyphicon glyphicon-chevron-up\"></span> </a></th><th>Actions</th></tr></thead><tbody><tr dir-paginate=\"item in businesses.businesses | itemsPerPage: itemsPerPage\" total-items=totalBusinesses current-page=currentPage pagination-id=businesses><td ng-class=\"{inactive: (item.active==false)}\">{{item.name}}</td><td ng-class=\"{inactive: (item.active==false)}\">{{item.business_type.name}}</td><td ng-class=\"{inactive: (item.active==false)}\">{{item.addresses[0].primary_street}}</td><td ng-class=\"{inactive: (item.active==false)}\">{{item.addresses[0].city}}</td><td ng-class=\"{inactive: (item.active==false)}\">{{item.phone | tel}}</td><td><a class=\"btn btn-xs btn-primary btn-xs\" ng-href=/#/business/{{item.id}}>View</a> <a class=\"btn btn-xs btn-info btn-xs\" ng-href=/#/business/{{item.id}}/edit>Edit</a> <a class=\"btn btn-xs btn-danger btn-xs\" ng-click=removeBusiness($index)>Remove</a></td></tr></tbody><div style=\"clear: both\"></div></table><dir-pagination-controls class=pull-right on-page-change=getBusinesses(); pagination-id=businesses></dir-pagination-controls><span class=col-sm-12 ng-show=\"businesses.length == 0\" style=margin-top:20px>No businesses found.</span></div></div>");
$templateCache.put("app/businesses/businesses_new.html","<div class=container><h2>New Business</h2><form class=\"form-horizontal css-form\" name=biz ng-submit=save() novalidate><div class=form-group><label for=name class=col-sm-2>Business Name</label><div class=col-sm-10><input type=name class=form-control id=name name=name ng-model=business.name placeholder=\"Enter text\" required></div></div><div class=form-group><label class=col-sm-2>Business Type</label><div class=col-sm-10 ng-class=\"{\'ui-valid\':business.to.length > 0}\"><ui-select ng-model=business.business_type theme=bootstrap title=\"Choose an business type\\\"><ui-select-match placeholder=\"Select or search...\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"item.id as item in businessTypes | filter: $select.search\"><div ng-bind-html=\"item.name | highlight: $select.search\"></div></ui-select-choices></ui-select></div></div><div class=form-group><label for=phone class=col-sm-2>Phone</label><div class=col-sm-10><input type=tel class=form-control id=phone name=phone ng-model=business.phone ui-mask=\"(999) 999-9999\" required></div></div><div class=form-group><label for=fax class=col-sm-2>Fax</label><div class=col-sm-10><input type=tel class=form-control id=fax name=fax ng-model=business.fax ui-mask=\"(999) 999-9999\" ui-mask-use-viewvalue=true></div></div><div class=form-group><label for=url class=col-sm-2>Email address</label><div class=col-sm-10><input type=email class=form-control name=email id=email ng-model=business.email placeholder=\"Enter main email address\"></div></div><div class=form-group><label for=url class=col-sm-2>Website address</label><div class=col-sm-10><input type=url class=form-control name=url id=url ng-model=business.url placeholder=\"Enter main website address\"></div></div><div class=form-group><label for=sq-foot class=col-sm-2>Square Footage</label><div class=col-sm-10><input type=number class=form-control id=sq-foot name=sq-foot ng-model=business.sq_footage placeholder=\"Enter number\"></div></div><div class=form-group><label for=num-seats class=col-sm-2>Number of Seats</label><div class=col-sm-10><input type=number class=form-control id=num-seats name=sq-foot ng-model=business.num_seats placeholder=\"Enter number\"></div></div><div class=form-group><label for=num-seats class=col-sm-2>Notes</label><div class=col-sm-10><textarea class=form-control id=notes name=sq-foot ng-model=business.notes col=5 placeholder=\"Enter notes\"></textarea></div></div><div ng-repeat=\"address in business.addresses\"><hr><div ng-hide=address._destroy><div class=form-group><div class=col-sm-offset-10><a ng-click=\"removeAddress($index, business)\" class=\"btn btn-danger\">X Remove Address</a></div></div><div class=form-group><label class=col-sm-2>Category</label><div class=col-sm-10><ui-select ng-model=address.category theme=bootstrap title=\"Choose a category\\\" required><ui-select-match placeholder=\"Select or search...\">{{$select.selected}}</ui-select-match><ui-select-choices repeat=\"item in categories | filter: $select.search\"><div ng-bind-html=\"item | highlight: $select.search\"></div></ui-select-choices></ui-select></div></div><div class=form-group><label for=primary_street class=col-sm-2>Primary Street</label><div class=col-sm-10><input type=name class=form-control id=primary_street ng-model=address.primary_street name=primary_street placeholder=\"Enter text\" required></div></div><div class=form-group><label for=secondary_street class=col-sm-2>Secondary Street</label><div class=col-sm-10><input type=name class=form-control id=secondary_street ng-model=address.secondary_street name=secondary_street placeholder=\"Enter text\"></div></div><div class=form-group><label for=city class=col-sm-2>City</label><div class=col-sm-10><input type=name class=form-control id=city name=city ng-model=address.city placeholder=\"Enter text\" required></div></div><div class=form-group><label class=col-sm-2>State</label><div class=col-sm-10><ui-select ng-model=address.state theme=bootstrap title=\"Choose a state\\\"><ui-select-match placeholder=\"Select or search...\">{{$select.selected.abbreviation}}</ui-select-match><ui-select-choices repeat=\"item.abbreviation as item in states | filter: $select.search\"><div ng-bind-html=\"item.abbreviation | highlight: $select.search\"></div></ui-select-choices></ui-select></div></div><div class=form-group><label for=zip class=col-sm-2>Zip Code</label><div class=col-sm-10><input type=zip class=form-control id=zip name=zip ng-model=address.zip placeholder=\"Enter text\" required></div></div></div></div><div class=\"form-group container\"><div><a ng-click=addAddress() class=\"btn btn-success\">+ Add Address</a></div></div><div class=\"form-group container\"><div class=pull-left><a class=\"btn btn-xs btn-default\" href=/#/businesses>Cancel</a> <button type=submit class=\"btn btn-xs btn-primary\" ng-click=\"submitted=true\">Save</button></div></div></form></div>");
$templateCache.put("app/config_settings/settings.html","<div class=col-md-2><h4>Configuration Menu</h4><ul id=subnav><li ng-repeat=\"item in configNavigation\" style=list-style-type:none><a ui-sref={{item.url}}>{{item.caption}}</a></li></ul></div><div class=col-md-10><div ui-view><h4 style=margin-top:200px>Choose a category in the left menu</h4></div></div>");
$templateCache.put("app/confirm/confirm.html","<div class=modal-header><h1 class=modal-title>{{data.title}}</h1></div><div class=modal-body><p class=confirm-body>{{data.text}}</p></div><div class=modal-footer><button type=button class=\"button button__fill--secondary\" ng-click=ok()>{{data.ok}}</button> <button type=button class=\"button button_fill--primary\" ng-click=cancel()>{{data.cancel}}</button></div>");
$templateCache.put("app/contacts/add_contact.html","<v-modal class=\"vModal--default view-data-modal\"><v-dialog heading=\"Add Contact\" medium left><div style=margin-bottom:20px><h1>Add Contact</h1><v-close label=Close ng-click=closeModal();></v-close></div><form class=\"form-horizontal css-form\" name=cont ng-submit=save() novalidate><div class=form-group><label class=col-sm-2>Contact Type</label><div class=col-sm-10><ui-select ng-model=contact.contact_type_id theme=bootstrap title=\"Choose a contact type\" id=contact_type ng-change=isFoodCertified(); required><ui-select-match placeholder=\"Select or search...\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"item.id as item in contactTypes | filter: $select.search\"><div ng-bind-html=\"item.name | highlight: $select.search\"></div></ui-select-choices></ui-select></div></div><div class=form-group ng-show=isFoodCertified();><label class=col-sm-2>Expiration Date</label><dif class=col-sm-10><input type=date class=form-control id=exp_date name=exp_date ng-model=contact.exp_date placeholder=\"Enter date\" ng-required=isFoodCertified();></dif></div><div class=form-group><label for=first_name class=col-sm-2>First Name</label><div class=col-sm-10><input type=name class=form-control id=first_name name=first_name ng-model=contact.first_name placeholder=\"Enter text\" required></div></div><div class=form-group><label for=last_name class=col-sm-2>Last Name</label><div class=col-sm-10><input type=name class=form-control id=last_name name=last_name ng-model=contact.last_name placeholder=\"Enter text\"></div></div><div class=form-group><label for=phone class=col-sm-2>Phone</label><div class=col-sm-10><input type=tel class=form-control id=phone name=phone ng-model=contact.phone ui-mask=\"(999) 999-9999\" ui-mask-use-viewvalue=true></div></div><div class=form-group><label for=email class=col-sm-2>Email</label><div class=col-sm-10><input type=email class=form-control id=email name=email ng-model=contact.email placeholder=\"Enter contact email address\"></div></div><div class=form-group><label for=fax class=col-sm-2>Fax</label><div class=col-sm-10><input type=tel class=form-control id=fax name=fax ng-model=contact.fax ui-mask=\"(999) 999-9999\" ui-mask-use-viewvalue=true></div></div><div class=\"form-group container\"><div class=pull-left><a class=\"btn btn-xs btn-default\" ng-click=closeModal();>Cancel</a> <button type=submit class=\"btn btn-xs btn-primary\" ng-click=\"submitted=true\">Save</button></div></div></form></v-dialog></v-modal>");
$templateCache.put("app/contacts/edit_contact.html","<v-modal class=\"vModal--default view-data-modal\"><v-dialog heading=\"Add Contact\" medium left><div style=margin-bottom:20px><h1>Edit Contact</h1><v-close label=Close ng-click=closeModal();></v-close></div><form class=\"form-horizontal css-form\" name=cont ng-submit=save() novalidate><div class=form-group><label class=col-sm-2>Contact Type</label><div class=col-sm-10><ui-select ng-model=contact.contact_type_id theme=bootstrap title=\"Choose a contact type\" required><ui-select-match placeholder=\"Select or search...\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"item.id as item in contactTypes | filter: $select.search\"><div ng-bind-html=\"item.name | highlight: $select.search\"></div></ui-select-choices></ui-select></div></div><div class=form-group ng-show=isFoodCertified();><label class=col-sm-2>Expiration Date</label><dif class=col-sm-10><input type=date class=form-control id=exp_date name=exp_date ng-model=contact.exp_date placeholder=\"Enter date\" ng-required=isFoodCertified();></dif></div><div class=form-group><label for=first_name class=col-sm-2>First Name</label><div class=col-sm-10><input type=name class=form-control id=first_name name=first_name ng-model=contact.first_name placeholder=\"Enter text\" required></div></div><div class=form-group><label for=last_name class=col-sm-2>Last Name</label><div class=col-sm-10><input type=name class=form-control id=last_name name=last_name ng-model=contact.last_name placeholder=\"Enter text\"></div></div><div class=form-group><label for=phone class=col-sm-2>Phone</label><div class=col-sm-10><input type=tel class=form-control id=phone name=phone ng-model=contact.phone ui-mask=\"(999) 999-9999\" ui-mask-use-viewvalue=true></div></div><div class=form-group><label for=email class=col-sm-2>Email</label><div class=col-sm-10><input type=email class=form-control id=email name=email ng-model=contact.email placeholder=\"Enter contact email\"></div></div><div class=form-group><label for=fax class=col-sm-2>Fax</label><div class=col-sm-10><input type=tel class=form-control id=fax name=fax ng-model=contact.fax ui-mask=\"(999) 999-9999\" ui-mask-use-viewvalue=true></div></div><div class=\"form-group container\"><div class=pull-left><a class=\"btn btn-xs btn-default\" ng-click=closeModal();>Cancel</a> <button type=submit class=\"btn btn-xs btn-primary\" ng-click=\"submitted=true\">Save</button></div></div></form></v-dialog></v-modal>");
$templateCache.put("app/contractors/add_contractor.html","<v-modal class=\"vModal--default view-data-modal\"><v-dialog heading=\"Add Contact\" large left><div style=margin-bottom:20px><h1>Add Contractor</h1><v-close label=Close ng-click=closeModal();></v-close></div><form class=\"form-horizontal css-form\" name=contract ng-submit=save() novalidate><div class=form-group><label for=name class=col-sm-2>Contractor Name</label><div class=col-sm-10><input type=name class=form-control id=name name=name ng-model=contractor.name placeholder=\"Enter text\" required></div></div><div class=form-group><label class=col-sm-2>Contractor Type</label><div class=col-sm-10 ng-class=\"{\'ui-valid\':contractor.to.length > 0}\"><ui-select ng-model=contractor.contractor_type theme=bootstrap title=\"Choose a contractor type\\\"><ui-select-match placeholder=\"Select or search...\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"item.id as item in contractorTypes | filter: $select.search\"><div ng-bind-html=\"item.name | highlight: $select.search\"></div></ui-select-choices></ui-select></div></div><div class=form-group><label for=phone class=col-sm-2>Phone</label><div class=col-sm-10><input type=tel class=form-control id=phone name=phone ng-model=contractor.phone ui-mask=\"(999) 999-9999\" ui-mask-use-viewvalue=true required></div></div><div class=form-group><label for=fax class=col-sm-2>Fax</label><div class=col-sm-10><input type=tel class=form-control id=fax name=fax ng-model=contractor.fax ui-mask=\"(999) 999-9999\" ui-mask-use-viewvalue=true></div></div><div class=form-group><label for=url class=col-sm-2>Email address</label><div class=col-sm-10><input type=email class=form-control name=email id=email ng-model=contractor.email placeholder=\"Enter main email address\"></div></div><div class=form-group><label for=url class=col-sm-2>Website address</label><div class=col-sm-10><input type=url class=form-control name=url id=url ng-model=business.url placeholder=\"Enter main website address\"></div></div><div ng-repeat=\"address in contractor.addresses\"><hr><div ng-hide=address._destroy><div class=form-group><label for=primary_street class=col-sm-2>Primary Street</label><div class=col-sm-10><input type=name class=form-control id=primary_street ng-model=address.primary_street name=primary_street placeholder=\"Enter text\" required></div></div><div class=form-group><label for=secondary_street class=col-sm-2>Secondary Street</label><div class=col-sm-10><input type=name class=form-control id=secondary_street ng-model=address.secondary_street name=secondary_street placeholder=\"Enter text\"></div></div><div class=form-group><label for=city class=col-sm-2>City</label><div class=col-sm-10><input type=name class=form-control id=city name=city ng-model=address.city placeholder=\"Enter text\" required></div></div><div class=form-group><label class=col-sm-2>State</label><div class=col-sm-10><ui-select ng-model=address.state theme=bootstrap title=\"Choose a state\\\"><ui-select-match placeholder=\"Select or search...\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"item in states | filter: $select.search\"><div ng-bind-html=\"item.name | highlight: $select.search\"></div></ui-select-choices></ui-select></div></div><div class=form-group><label for=zip class=col-sm-2>Zip Code</label><div class=col-sm-10><input type=zip class=form-control id=zip name=zip ng-model=address.zip placeholder=\"Enter text\" required></div></div></div></div><div class=\"form-group container\"><div class=pull-left><a class=\"btn btn-xs btn-default\" href=/#/businesses>Cancel</a> <button type=submit class=\"btn btn-xs btn-primary\" ng-click=\"submitted=true\">Save</button></div></div></form></v-dialog></v-modal>");
$templateCache.put("app/contractors/edit_contractor.html","<v-modal class=\"vModal--default view-data-modal\"><v-dialog heading=\"Add Contact\" large left><div style=margin-bottom:20px><h1>Edit Contractor</h1><v-close label=Close ng-click=closeModal();></v-close></div><form class=\"form-horizontal css-form\" name=contract ng-submit=save() novalidate><div class=form-group><label for=name class=col-sm-2>Contractor Name</label><div class=col-sm-10><input type=name class=form-control id=name name=name ng-model=contractor.name placeholder=\"Enter text\" required></div></div><div class=form-group><label class=col-sm-2>Contractor Type</label><div class=col-sm-10 ng-class=\"{\'ui-valid\':contractor.to.length > 0}\"><ui-select ng-model=contractor.contractor_type theme=bootstrap title=\"Choose a contractor type\\\"><ui-select-match placeholder=\"Select or search...\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"item.id as item in contractorTypes | filter: $select.search\"><div ng-bind-html=\"item.name | highlight: $select.search\"></div></ui-select-choices></ui-select></div></div><div class=form-group><label for=phone class=col-sm-2>Phone</label><div class=col-sm-10><input type=tel class=form-control id=phone name=phone ng-model=contractor.phone ui-mask=\"(999) 999-9999\" ui-mask-use-viewvalue=true required></div></div><div class=form-group><label for=fax class=col-sm-2>Fax</label><div class=col-sm-10><input type=tel class=form-control id=fax name=fax ng-model=contractor.fax ui-mask=\"(999) 999-9999\" ui-mask-use-viewvalue=true></div></div><div class=form-group><label for=url class=col-sm-2>Email address</label><div class=col-sm-10><input type=email class=form-control name=email id=email ng-model=contractor.email placeholder=\"Enter main email address\"></div></div><div class=form-group><label for=url class=col-sm-2>Website address</label><div class=col-sm-10><input type=url class=form-control name=url id=url ng-model=business.url placeholder=\"Enter main website address\"></div></div><div ng-repeat=\"address in contractor.addresses\"><hr><div ng-hide=address._destroy><div class=form-group><label for=primary_street class=col-sm-2>Primary Street</label><div class=col-sm-10><input type=name class=form-control id=primary_street ng-model=address.primary_street name=primary_street placeholder=\"Enter text\" required></div></div><div class=form-group><label for=secondary_street class=col-sm-2>Secondary Street</label><div class=col-sm-10><input type=name class=form-control id=secondary_street ng-model=address.secondary_street name=secondary_street placeholder=\"Enter text\"></div></div><div class=form-group><label for=city class=col-sm-2>City</label><div class=col-sm-10><input type=name class=form-control id=city name=city ng-model=address.city placeholder=\"Enter text\" required></div></div><div class=form-group><label class=col-sm-2>State</label><div class=col-sm-10><ui-select ng-model=address.state theme=bootstrap title=\"Choose an state\\\"><ui-select-match placeholder=\"Select or search...\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"item.name as item in states | filter: $select.search\"><div ng-bind-html=\"item.name | highlight: $select.search\"></div></ui-select-choices></ui-select></div></div><div class=form-group><label for=zip class=col-sm-2>Zip Code</label><div class=col-sm-10><input type=zip class=form-control id=zip name=zip ng-model=address.zip placeholder=\"Enter text\" required></div></div></div></div><div class=\"form-group container\"><div class=pull-left><a class=\"btn btn-xs btn-default\" ng-click=closeModal();>Cancel</a> <button type=submit class=\"btn btn-xs btn-primary\" ng-click=\"submitted=true\">Save</button></div></div></form></v-dialog></v-modal>");
$templateCache.put("app/contractors/link_contractor_to_business_modal.html","<v-modal class=\"vModal--default view-data-modal\"><v-dialog heading=\"Add Contractor\" medium left><div style=margin-bottom:20px><h1>Add Contractor</h1><v-close label=Close ng-click=closeModal();></v-close></div><form class=\"form-horizontal css-form\" name=contract ng-submit=save() novalidate><div class=form-group><label class=col-sm-2>Contractors</label><div class=col-sm-10 ng-class=\"{\'ui-valid\':contractor.to.length > 0}\"><ui-select ng-model=contractor.contractor_id theme=bootstrap title=\"Choose a contractor\\\"><ui-select-match placeholder=\"Select or search...\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"item.id as item in contractors | filter: $select.search\"><div ng-bind-html=\"item.name | highlight: $select.search\"></div><small ng-show={{item.addresses[0].primary_street}}>{{item.addresses[0].primary_street}}<br>{{item.addresses[0].city}}, {{item.addresses[0].state}}&nbsp;&nbsp;{{item.addresses[0].zip}}</small></ui-select-choices></ui-select></div></div><hr><div class=\"form-group container\"><div class=pull-left><a class=\"btn btn-default\" ng-click=closeModal()>Cancel</a> <button type=submit class=\"btn btn-primary\" ng-click=\"submitted=true\">Save</button></div></div></form></v-dialog></v-modal>");
$templateCache.put("app/contractors/view_contractor_modal.html","<v-modal class=\"vModal--default view-data-modal\"><v-dialog heading={{contractor.name}} medium left><div style=margin-bottom:20px><h1>{{contractor.name}}</h1><v-close label=Close ng-click=closeModal();></v-close></div><div>{{contractor.contractor_type.name}}</div><div>{{contractor.phone | tel}}</div><div ng-show={{contractor.fax}}>{{contractor.fax | tel}}</div><div ng-show={{contractor.email}}>{{contractor.email}}</div><br><br><div ng-repeat=\"address in contractor.addresses\"><div>{{address.primary_street}}</div><div>{{address.secondary_street}}</div><div>{{address.city}}<span ng-show={{address.state}}>, {{address.state}}</span></div><div ng-show={{address.zip}}>{{address.zip}}</div></div><br><br><div class=form-group><div class=pull-left><a class=\"btn btn-xs btn-default\" ng-click=closeModal()>Cancel</a></div></div></v-dialog></v-modal>");
$templateCache.put("app/inspections/inspection_edit.html","<div class=container><h2>Edit Inspection</h2><form class=\"form-horizontal css-form\" name=inspect ng-submit=save() novalidate><div class=form-group><label for=inspected_on class=col-sm-2>Inspection Date</label><div class=col-sm-10><input type=date class=form-control id=inspected_on name=inspected_on ng-model=inspection.inspected_on placeholder=\"Enter Date\" required></div></div><div class=form-group><label class=col-sm-2>Inspection Type</label><div class=col-sm-10><ui-select ng-model=inspection.inspection_type theme=bootstrap title=\"Choose an inspection type\\\"><ui-select-match placeholder=\"Select or search...\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"item in inspectionTypes | filter: $select.search\"><div ng-bind-html=\"item.name | highlight: $select.search\"></div></ui-select-choices></ui-select></div></div><div class=form-group><label class=col-sm-2>Business</label><div class=col-sm-10><ui-select ng-model=inspection.business theme=bootstrap title=\"Choose a business\"><ui-select-match placeholder=\"Select or search...\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"item in businesses | filter: $select.search\"><div ng-bind-html=\"item.name | highlight: $select.search\"></div></ui-select-choices></ui-select></div></div><div class=form-group><label class=col-sm-2>Inspection Reason</label><div class=col-sm-10><ui-select ng-model=inspection.inspection_reason theme=bootstrap title=\"Choose a reason\"><ui-select-match placeholder=\"Select or search...\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"item in reasons | filter: $select.search\"><div ng-bind-html=\"item.name | highlight: $select.search\"></div></ui-select-choices></ui-select></div></div><div class=form-group><label class=col-sm-2>Evaluation Status</label><div class=col-sm-10><ui-select ng-model=inspection.evaluation_status theme=bootstrap title=\"Choose an evaluation status\"><ui-select-match placeholder=\"Select or search...\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"item in evaluationStatuses | filter: $select.search\"><div ng-bind-html=\"item.name | highlight: $select.search\"></div></ui-select-choices></ui-select></div></div><div class=form-group><label class=col-sm-2>Inspector</label><div class=col-sm-10><ui-select ng-model=inspection.inspector theme=bootstrap title=\"Choose an Inpsector\"><ui-select-match placeholder=\"Select or search...\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"item.id as item in inspectors | filter: $select.search\"><div ng-bind-html=\"item.name | highlight: $select.search\"></div></ui-select-choices></ui-select></div></div><div class=form-group><label class=col-sm-2>Notes</label><div class=col-sm-10><textarea type=text class=form-control id=notes name=notes ng-model=inspection.notes placeholder=\"Enter text\"></textarea></div></div><div class=form-group><label for=next_inspection_on class=col-sm-2>Next Inspection Date</label><div class=col-sm-10><input type=date class=form-control id=next_inspection_on name=next_inspection_on ng-model=inspection.next_inspection_on placeholder=\"Enter Date\"></div></div><div class=\"form-group container\"><div class=pull-left><a class=\"btn btn-xs btn-default\" href=/#/inspections>Cancel</a> <button type=submit class=\"btn btn-xs btn-primary\" ng-click=\"submitted=true\">Save</button></div></div></form></div>");
$templateCache.put("app/inspections/inspection_edit_modal.html","<v-modal class=\"vModal--default view-data-modal\"><v-dialog heading=\"Add Contact\" medium left><div style=margin-bottom:20px><h1>Edit Inspection</h1><v-close label=Close ng-click=closeModal();></v-close></div><form class=\"form-horizontal css-form\" name=inspect ng-submit=save() novalidate><div class=form-group><label for=inspected_on class=col-sm-2>Inspection Date</label><div class=col-sm-10><input type=date class=form-control id=inspected_on name=inspected_on ng-model=inspection.inspected_on placeholder=\"Enter Date\" required></div></div><div class=form-group><label class=col-sm-2>Inspection Type</label><div class=col-sm-10><ui-select ng-model=inspection.inspection_type theme=bootstrap title=\"Choose an inspection type\\\"><ui-select-match placeholder=\"Select or search...\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"item in inspectionTypes | filter: $select.search\"><div ng-bind-html=\"item.name | highlight: $select.search\"></div></ui-select-choices></ui-select></div></div><div class=form-group><label class=col-sm-2>Inspection Reason</label><div class=col-sm-10><ui-select ng-model=inspection.inspection_reason theme=bootstrap title=\"Choose a reason\"><ui-select-match placeholder=\"Select or search...\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"item in reasons | filter: $select.search\"><div ng-bind-html=\"item.name | highlight: $select.search\"></div></ui-select-choices></ui-select></div></div><div class=form-group><label class=col-sm-2>Evaluation Status</label><div class=col-sm-10><ui-select ng-model=inspection.evaluation_status theme=bootstrap title=\"Choose an evaluation status\"><ui-select-match placeholder=\"Select or search...\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"item in evaluationStatuses | filter: $select.search\"><div ng-bind-html=\"item.name | highlight: $select.search\"></div></ui-select-choices></ui-select></div></div><div class=form-group><label class=col-sm-2>Inspector</label><div class=col-sm-10><ui-select ng-model=inspection.inspector theme=bootstrap title=\"Choose an Inspector\"><ui-select-match placeholder=\"Select or search...\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"item in licenseOfficials | filter: $select.search\"><div ng-bind-html=\"item.name | highlight: $select.search\"></div></ui-select-choices></ui-select></div></div><div class=form-group><label class=col-sm-2>Notes</label><div class=col-sm-10><textarea type=text class=form-control id=notes name=notes ng-model=inspection.notes placeholder=\"Enter text\"></textarea></div></div><div class=form-group><label for=next_inspection_on class=col-sm-2>Next Inspection Date</label><div class=col-sm-10><input type=date class=form-control id=next_inspection_on name=next_inspection_on ng-model=inspection.next_inspection_on placeholder=\"Enter Date\"></div></div><div class=\"form-group container\"><div class=pull-left><a class=\"btn btn-xs btn-default\" ng-click=closeModal();>Cancel</a> <button type=submit class=\"btn btn-xs btn-primary\" ng-click=\"submitted=true\">Save</button></div></div></form></v-dialog></v-modal>");
$templateCache.put("app/inspections/inspection_new_modal.html","<v-modal class=\"vModal--default view-data-modal\"><v-dialog heading=\"Add Contact\" medium left><div style=margin-bottom:20px><h1>New Inspection</h1><v-close label=Close ng-click=closeModal();></v-close></div><form class=\"form-horizontal css-form\" name=inspect ng-submit=save() novalidate><div class=form-group><label for=inspected_on class=col-sm-2>Inspection Date</label><div class=col-sm-10><input type=date class=form-control id=inspected_on name=inspected_on ng-model=inspection.inspected_on placeholder=\"Enter Date\" required></div></div><div class=form-group><label class=col-sm-2>Inspection Type</label><div class=col-sm-10><ui-select ng-model=inspection.inspection_type theme=bootstrap title=\"Choose an inspection type\\\"><ui-select-match placeholder=\"Select or search...\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"item in inspectionTypes | filter: $select.search\"><div ng-bind-html=\"item.name | highlight: $select.search\"></div></ui-select-choices></ui-select></div></div><div class=form-group><label class=col-sm-2>Inspection Reason</label><div class=col-sm-10><ui-select ng-model=inspection.inspection_reason theme=bootstrap title=\"Choose a reason\"><ui-select-match placeholder=\"Select or search...\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"item in reasons | filter: $select.search\"><div ng-bind-html=\"item.name | highlight: $select.search\"></div></ui-select-choices></ui-select></div></div><div class=form-group><label class=col-sm-2>Evaluation Status</label><div class=col-sm-10><ui-select ng-model=inspection.evaluation_status theme=bootstrap title=\"Choose an evaluation status\"><ui-select-match placeholder=\"Select or search...\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"item in evaluationStatuses | filter: $select.search\"><div ng-bind-html=\"item.name | highlight: $select.search\"></div></ui-select-choices></ui-select></div></div><div class=form-group><label class=col-sm-2>Inspector</label><div class=col-sm-10><ui-select ng-model=inspection.inspector theme=bootstrap title=\"Choose an Inspector\"><ui-select-match placeholder=\"Select or search...\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"item in licenseOfficials | filter: $select.search\"><div ng-bind-html=\"item.name | highlight: $select.search\"></div></ui-select-choices></ui-select></div></div><div class=form-group><label class=col-sm-2>Notes</label><div class=col-sm-10><textarea type=text class=form-control id=notes name=notes ng-model=inspection.notes placeholder=\"Enter text\"></textarea></div></div><div class=form-group><label for=inspected_on class=col-sm-2>Next Inspection Date</label><div class=col-sm-10><input type=date class=form-control id=next_inspection_on name=next_inspection_on ng-model=inspection.next_inspection_on placeholder=\"Enter Date\"></div></div><div class=\"form-group container\"><div class=pull-left><a class=\"btn btn-xs btn-default\" ng-click=closeModal();>Cancel</a> <button type=submit class=\"btn btn-xs btn-primary\" ng-click=\"submitted=true\">Save</button></div></div></form></v-dialog></v-modal>");
$templateCache.put("app/inspections/inspection_view.html","<div class=container><h2>{{inspection.business.name}}</h2><h4>{{inspection.business.business_type.name}}</h4><table style=\"margin-bottom: 10px\"><tr><td style=\"text-align: right;font-weight: 700\">phone:</td><td style=\"padding-left:10px;text-align: left\">{{(inspection.business.phone | tel)|| \'none\'}}</td><td style=\"padding-left:20px;text-align: right;font-weight: 700\">web address:</td><td style=\"padding-left:10px;text-align: left\">{{inspection.business.url || \'none\'}}</td><td style=\"padding-left:20px;text-align: right;font-weight: 700\">notes:</td><td rowspan=3 style=\"max-width:350px;padding-left:10px;text-align: left;vertical-align:top\">{{inspection.business.notes || \'none\'}}</td></tr><tr><td style=\"text-align: right;font-weight: 700\">fax:</td><td style=\"padding-left:10px;text-align: left\">{{(inspection.business.fax | tel)|| \'none\'}}</td><td style=\"padding-left:20px;text-align: right;font-weight: 700\">sq footage:</td><td style=\"padding-left:10px;text-align: left\">{{inspection.business.sq_footage || \'none\'}}</td></tr><tr><td style=\"text-align: right;font-weight: 700\">email:</td><td style=\"padding-left:10px;text-align: left\">{{inspection.business.email || \'none\'}}</td><td style=\"padding-left:20px;text-align: right;font-weight: 700\">number of seats:</td><td style=\"padding-left:10px;text-align: left\">{{inspection.business.num_seats || \'none\'}}</td></tr></table><address><div ng-repeat=\"address in inspection.business.addresses | customAddressOrder:\'category\'\" class=\"col-md-4 well\" style=margin-right:20px;line-height:10px><p class=address_category><strong>{{address.category}}</strong></p><p class=address_address1>{{address.primary_street}}</p><p class=address_address2 ng-show-if=\"{{address.secondary_street.size > 0}}\">{{address.secondary_street}}</p><p class=address_city>{{address.city}}</p><p class=address_state>{{address.state}}<span>, </span>{{address.zip}}</p></div></address></div><div class=container><h3>Business Type</h3><table class=\"table table-striped\" style=margin-top:20px><tr><th>Name</th><th>Annual License Required</th></tr><tr><td>{{inspection.business_type.name || \'none\'}}</td><td>{{inspection.business_type.annual_license_required || \'none\'}}</td></tr></table></div><div class=container><h3>Inspection Details</h3><table class=\"table table-striped\" style=margin-top:20px><tr><th>Inspection Reason</th><th>Inspection Type</th><th>Inspector Name</th><th>Inspector Title</th><th>Inspected On</th><th>Next Inspection On</th><th>Evaluation Status</th></tr><tr><td>{{ inspection.inspection_reason.name || \'none\' }}</td><td>{{ inspection.inspection_type.name || \'none\' }}</td><td>{{ inspection.inspector.name || \'none\' }}</td><td>{{ inspection.inspector.title || \'none\' }}</td><td>{{ inspection.inspected_on | date : \'M/d/yyyy\' : \'UTC\' }}</td><td>{{ inspection.next_inspection_on | date : \'M/d/yyyy\' : \'UTC\' }}</td><td>{{ inspection.evaluation_status.name }}</td></tr></table><div class=pull-left><a class=\"btn btn-xs btn-default\" href=/#/inspections>Back</a></div></div>");
$templateCache.put("app/inspections/inspections_index.html","<div class=container-fluid><div class=col-md-12><h2>Inspections</h2></div><div class=col-md-12><form class=form-inline><div class=input-group><span class=input-group-addon><i class=\"glyphicon glyphicon-search\"></i></span> <input ng-model=inspectionsSearchFilter id=search class=form-control placeholder=Search ng-change=setConditions() ng-model-options=\"{debounce: 750}\" autocomple=off> <span class=input-group-addon><i class=\"glyphicon glyphicon-remove\" ng-click=clearSearch()></i></span></div><div class=row><div class=col-md-8>Most recent inspections only&nbsp;&nbsp;<input type=checkbox ng-model=inspectionsStatus ng-change=setConditions()></div></div><br><div class=row><div class=col-md-8><div class=\"panel panel-default\"><div class=panel-heading><h3 class=panel-title>Inspection Filter</h3></div><div class=panel-body><div class=form-group><label for=inspection_on_begin class=col-sm-2>From</label><div class=col-sm-10><input type=date class=form-control id=inspection_on_begin name=inspection_on_begin ng-model=inspectionsInspectionOnBegin placeholder=\"Enter Date\" ng-change=resetPages();getInspections() ng-model-options=\"{debounce: 750}\"></div></div>&nbsp;<div class=form-group><label for=inspection_on_end class=col-sm-2>To</label><div class=col-sm-10><input type=date class=form-control id=inspection_on_end name=inspection_on_end ng-model=inspectionsInspectionOnEnd placeholder=\"Enter Date\" ng-change=resetPages();getInspections() ng-model-options=\"{debounce: 750}\"></div></div></div></div></div></div><div class=input-group><ui-select multiple ng-model=inspectionsInspectionTypeFilter theme=bootstrap sortable close-on-select=false style=width:350px ng-change=setInspectionTypeFilter(inspectionsInspectionTypeFilter);getInspections();><ui-select-match placeholder=\"Filter by Inspection Type\">{{$item.name}}</ui-select-match><ui-select-choices repeat=\"item in inspectionTypes\"><div ng-bind-html=\"item.name | highlight: $select.search\"></div></ui-select-choices></ui-select></div><div class=input-group><ui-select multiple ng-model=inspectionsBusinessTypeFilter theme=bootstrap sortable close-on-select=false style=\"width: 350px\" ng-change=setBusinessTypeFilter(inspectionsBusinessTypeFilter);getInspections();><ui-select-match placeholder=\"Filter by Business Type\">{{$item.name}}</ui-select-match><ui-select-choices repeat=\"item in businessTypes\"><div ng-bind-html=\"item.name | highlight: $select.search\"></div></ui-select-choices></ui-select></div><div class=input-group><ui-select multiple ng-model=inspectionsCityFilter theme=bootstrap sortable close-on-select=false style=\"width: 350px\" ng-change=setCityFilter(inspectionsCityFilter);getInspections();><ui-select-match placeholder=\"Filter by City\">{{$item.city}}</ui-select-match><ui-select-choices repeat=\"item in cities\"><div ng-bind-html=\"item.city | highlight: $select.search\"></div></ui-select-choices></ui-select></div></form><br><div total-items=totalInspections>{{totalInspections}} Inspections Found</div><div><a ng-href=#/inspections/new class=\"btn btn-xs btn-primary\" type=button style=margin-top:20px>Add Inspection</a> <a class=\"btn btn-xs btn-info btn-xs\" style=margin-top:20px ng-click=\"exportInspections() \">Export</a></div></div><div class=col-md-12><dir-pagination-controls class=pull-right on-page-change=getInspections() pagination-id=inspectMe></dir-pagination-controls><table class=\"table table-striped\"><thead><tr><th><a href=\"\" ng-click=\"setConditions(\'inspections.inspected_on\',sortSwitch);\">Inspection Date<span ng-show=\"sortReverse && sortColumnz==\'inspections.inspected_on\'\" class=\"glyphicon glyphicon-chevron-down\"></span> <span ng-show=\"!sortReverse && sortColumnz==\'inspections.inspected_on\'\" class=\"glyphicon glyphicon-chevron-up\"></span></a></th><th><a href=\"\" ng-click=\"setConditions(\'inspection_type\',sortSwitch);\">Type<span ng-show=\"sortReverse && sortColumnz==\'inspection_type\'\" class=\"glyphicon glyphicon-chevron-down\"></span> <span ng-show=\"!sortReverse && sortColumnz==\'inspection_type\'\" class=\"glyphicon glyphicon-chevron-up\"></span></a></th><th><a href=\"\" ng-click=\"setConditions(\'business_name\',sortSwitch);\">Business<span ng-show=\"sortReverse && sortColumnz==\'business_name\'\" class=\"glyphicon glyphicon-chevron-down\"></span> <span ng-show=\"!sortReverse && sortColumnz==\'business_name\'\" class=\"glyphicon glyphicon-chevron-up\"></span></a></th><th><a href=\"\" ng-click=\"setConditions(\'business_type\',sortSwitch);\">Bus. Type<span ng-show=\"sortReverse && sortColumnz==\'business_type\'\" class=\"glyphicon glyphicon-chevron-down\"></span> <span ng-show=\"!sortReverse && sortColumnz==\'business_type\'\" class=\"glyphicon glyphicon-chevron-up\"></span></a></th><th><a href=\"\" ng-click=\"setConditions(\'city\',sortSwitch);\">City<span ng-show=\"sortReverse && sortColumnz==\'city\'\" class=\"glyphicon glyphicon-chevron-down\"></span> <span ng-show=\"!sortReverse && sortColumnz==\'city\'\" class=\"glyphicon glyphicon-chevron-up\"></span></a></th><th><a href=\"\" ng-click=\"setConditions(\'evaluation\',sortSwitch);\">Evaluation<span ng-show=\"sortReverse && sortColumnz==\'evaluation\'\" class=\"glyphicon glyphicon-chevron-down\"></span> <span ng-show=\"!sortReverse && sortColumnz==\'evaluation\'\" class=\"glyphicon glyphicon-chevron-up\"></span> </a></th><th>Actions</th></tr></thead><tbody><!--<div dir-paginate=\"item in Items | itemsPerPage: pageSize\" current-page=\"currentPage\">--><tr dir-paginate=\"item in inspections.inspections | itemsPerPage: itemsPerPage\" total-items=totalInspections current-page=currentPage pagination-id=inspectMe><td ng-class=\"{inactive: (item.business.active==false)}\">{{item.inspected_on | date : \'M/d/yyyy\' : \'UTC\'}}</td><td ng-class=\"{inactive: (item.business.active==false)}\">{{item.inspection_type.name}}</td><td ng-class=\"{inactive: (item.business.active==false)}\">{{item.business.name}}</td><td ng-class=\"{inactive: (item.business.active==false)}\">{{item.business_type.name}}</td><td ng-class=\"{inactive: (item.business.active==false)}\">{{item.city[0].city}}</td><td ng-class=\"{inactive: (item.business.active==false)}\">{{item.evaluation_status.name}}</td><td><a class=\"btn btn-xs btn-primary btn-xs\" ng-href=/#/inspection/{{item.id}}>View</a> <a class=\"btn btn-xs btn-info\" href={{apiUrl}}:{{apiPort}}/api/inspections/{{item.id}}/pdf ng-disabled=!item.inspection_pdf>Print</a> <a class=\"btn btn-xs btn-primary\" ng-href=/#/inspection/{{item.id}}/edit>Edit</a> <a class=\"btn btn-xs btn-danger\" ng-click=removeInspection($index)>Remove</a></td></tr></tbody></table><dir-pagination-controls class=pull-right on-page-change=getInspections(); pagination-id=inspectMe></dir-pagination-controls></div></div>");
$templateCache.put("app/inspections/inspections_new.html","<div class=container><h2>New Inspection</h2><form class=\"form-horizontal css-form\" name=inspect ng-submit=save() novalidate><div class=form-group><label for=inspected_on class=col-sm-2>Inspection Date</label><div class=col-sm-10><input type=date class=form-control id=inspected_on name=inspected_on ng-model=inspection.inspected_on placeholder=\"Enter Date\" required></div></div><div class=form-group><label class=col-sm-2>Inspection Type</label><div class=col-sm-10><ui-select ng-model=inspection.inspection_type theme=bootstrap title=\"Choose an inspection type\\\"><ui-select-match placeholder=\"Select or search...\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"item in inspectionTypes | filter: $select.search\"><div ng-bind-html=\"item.name | highlight: $select.search\"></div></ui-select-choices></ui-select></div></div><div class=form-group><label class=col-sm-2>Business</label><div class=col-sm-10><ui-select ng-model=inspection.business theme=bootstrap title=\"Choose a business\"><ui-select-match placeholder=\"Select or search...\"><strong>{{$select.selected.name}}</strong></ui-select-match><ui-select-choices repeat=\"item in businesses | filter: $select.search\"><div ng-bind-html=\"item.name | highlight: $select.search\"></div><small><i>{{item.addresses[0].city}}</i>&nbsp;&nbsp;&nbsp;{{item.addresses[0].primary_street}}</small></ui-select-choices></ui-select></div></div><div class=form-group><label class=col-sm-2>Inspection Reason</label><div class=col-sm-10><ui-select ng-model=inspection.inspection_reason theme=bootstrap title=\"Choose a reason\"><ui-select-match placeholder=\"Select or search...\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"item in reasons | filter: $select.search\"><div ng-bind-html=\"item.name | highlight: $select.search\"></div></ui-select-choices></ui-select></div></div><div class=form-group><label class=col-sm-2>Evaluation Status</label><div class=col-sm-10><ui-select ng-model=inspection.evaluation_status theme=bootstrap title=\"Choose an evaluation status\"><ui-select-match placeholder=\"Select or search...\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"item in evaluationStatuses | filter: $select.search\"><div ng-bind-html=\"item.name | highlight: $select.search\"></div></ui-select-choices></ui-select></div></div><div class=form-group><label class=col-sm-2>Inspector</label><div class=col-sm-10><ui-select ng-model=inspection.inspector theme=bootstrap title=\"Choose an Inspector\"><ui-select-match placeholder=\"Select or search...\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"item.id as item in inspectors | filter: $select.search\"><div ng-bind-html=\"item.name | highlight: $select.search\"></div></ui-select-choices></ui-select></div></div><div class=form-group><label class=col-sm-2>Notes</label><div class=col-sm-10><textarea type=text class=form-control id=notes name=notes ng-model=inspection.notes placeholder=\"Enter text\"></textarea></div></div><div class=form-group><label for=next_inspection_on class=col-sm-2>Next Inspection Date</label><div class=col-sm-10><input type=date class=form-control id=next_inspection_on name=next_inspection_on ng-model=inspection.next_inspection_on placeholder=\"Enter Date\"></div></div><div class=\"form-group container\"><div class=pull-left><a class=\"btn btn-xs btn-default\" href=/#/inspections>Cancel</a> <button type=submit class=\"btn btn-xs btn-primary\" ng-click=\"submitted=true\">Save</button></div></div></form></div>");
$templateCache.put("app/licenses/license_edit_modal.html","<v-modal class=\"vModal--default view-data-modal\"><v-dialog heading=\"Edit License\" medium left><div style=margin-bottom:20px><h1>Edit License</h1><v-close label=Close ng-click=closeModal();></v-close></div><form class=\"form-horizontal css-form\" name=lick ng-submit=save() novalidate><div class=form-group><label for=license_number class=col-sm-2>License No.</label><div class=col-sm-10><input type=name class=form-control id=license_number name=license_number ng-model=license.license_number placeholder=\"Enter text\" required></div></div><div class=form-group><label class=col-sm-2>License Type</label><div class=col-sm-10><ui-select ng-model=license.license_type theme=bootstrap title=\"Choose an license type\\\"><ui-select-match placeholder=\"Select or search...\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"item in licenseTypes | filter: $select.search\"><div ng-bind-html=\"item.name | highlight: $select.search\"></div></ui-select-choices></ui-select></div></div><div class=form-group><label class=col-sm-2>License Purpose</label><div class=col-sm-10><ui-select ng-model=license.license_purpose theme=bootstrap title=\"Choose an license purpose\\\"><ui-select-match placeholder=\"Select or search...\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"item in licensePurposes | filter: $select.search\"><div ng-bind-html=\"item.name | highlight: $select.search\"></div></ui-select-choices></ui-select></div></div><div class=form-group><label class=col-sm-2>License Official</label><div class=col-sm-10><ui-select ng-model=license.license_official theme=bootstrap title=\"Choose an license official\\\"><ui-select-match placeholder=\"Select or search...\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"item in licenseOfficials | filter: $select.search\"><div ng-bind-html=\"item.name | highlight: $select.search\"></div></ui-select-choices></ui-select></div></div><div class=form-group><label class=col-sm-2>Begin Date</label><div class=col-sm-10><input type=date class=form-control id=begin_date name=license.begin_date ng-model=license.begin_date ng-change=setDates() placeholder=\"Enter Date\" required></div></div><div class=form-group><label for=end_date class=col-sm-2>End Date</label><div class=col-sm-10><input type=date class=form-control id=end_date name=license.end_date ng-model=license.end_date placeholder=\"Enter Date\" required></div></div><div class=form-group><label for=license_year class=col-sm-2>License Year</label><div class=col-sm-10><input type=text class=form-control id=license_year name=license_year ng-model=license.license_year placeholder=\"Enter License Year\" required></div></div><div class=form-group><label for=license_amount class=col-sm-2>Amount</label><div class=col-sm-10><div class=input-group><span class=input-group-addon>$</span> <input type=decimal class=form-control id=license_amount name=license_number ng-model=license.amount placeholder=\"Enter amount\"></div></div></div><!-- Finish implementing this !--><!--<div class=\"form-group\">--><!--<label for=\"license_amount_paid\" class=\"col-sm-2\">Amount Paid</label>--><!--<div class=\"col-sm-10\">--><!--<div class=\"input-group\">--><!--<span class=\"input-group-addon\">$</span>--><!--<input type=\"decimal\" class=\"form-control\" id=\"license_amount_paid\" name=\"license_amount_paid\"--><!--ng-model=\"license.amount_paid\" placeholder=\"Enter amount\"/>--><!--</div>--><!--</div>--><!--</div>--><!--\n      <div class=\"form-group\">\n        <label class=\"col-sm-2\">Paid</label>\n        <div class=\"col-sm-10\">\n          <input type=\"checkbox\" ng-model=\"license.paid\">\n        </div>\n      </div>\n      --><div class=form-group><label class=col-sm-2>Notes</label><div class=col-sm-10><textarea type=text class=form-control id=license_notes name=license_notes ng-model=license.notes placeholder=\"Enter text\"></textarea></div></div><div class=form-group><label class=col-sm-2>Active</label><div class=col-sm-10><input type=checkbox ng-model=license.active></div></div><div class=\"form-group container\"><div class=pull-left><a class=\"btn btn-xs btn-default\" ng-click=closeModal();>Cancel</a> <button type=submit class=\"btn btn-xs btn-primary\" ng-click=\"submitted=true\">Save</button></div></div></form></v-dialog></v-modal>");
$templateCache.put("app/licenses/licenses_edit.html","<div class=container><h2>Edit License</h2><form class=\"form-horizontal css-form\" name=lic ng-submit=save() novalidate><div class=form-group><label for=license_number class=col-sm-2>License No.</label><div class=col-sm-10><input type=name class=form-control id=license_number name=license_number ng-model=license.license_number placeholder=\"Enter text\" readonly></div></div><div class=form-group><label class=col-sm-2>Business</label><div class=col-sm-10><input class=form-control type=name ng-model=license.business.name readonly></div></div><div class=form-group><label class=col-sm-2>License Type</label><div class=col-sm-10><ui-select ng-model=license.license_type theme=bootstrap title=\"Choose an inspection type\\\"><ui-select-match placeholder=\"Select or search...\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"item.id as item in licenseTypes | filter: $select.search\"><div ng-bind-html=\"item.name | highlight: $select.search\"></div></ui-select-choices></ui-select></div></div><div class=form-group><label class=col-sm-2>License Purpose</label><div class=col-sm-10><ui-select ng-model=license.license_purpose theme=bootstrap title=\"Choose a purpose\\\"><ui-select-match placeholder=\"Select or search...\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"item.id as item in licensePurposes | filter: $select.search\"><div ng-bind-html=\"item.name | highlight: $select.search\"></div></ui-select-choices></ui-select></div></div><div class=form-group><label class=col-sm-2>Licensing Official</label><div class=col-sm-10><ui-select ng-model=license.license_official theme=bootstrap title=\"Choose a business\"><ui-select-match placeholder=\"Select or search...\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"item.id as item in licenseOfficials | filter: $select.search\"><div ng-bind-html=\"item.name | highlight: $select.search\"></div></ui-select-choices></ui-select></div></div><div class=form-group><label for=begin_date class=col-sm-2>Begin Date</label><div class=col-sm-10><input type=date class=form-control id=begin_date name=license.begin_date ng-model=license.begin_date ng-change=setDates() placeholder=\"Enter Date\" required></div></div><div class=form-group><label for=end_date class=col-sm-2>End Date</label><div class=col-sm-10><input type=date class=form-control id=end_date name=license.end_date ng-model=license.end_date placeholder=\"Enter Date\" required></div></div><div class=form-group><label for=license_year class=col-sm-2>License Year</label><div class=col-sm-10><input type=text class=form-control id=license_year name=license_year ng-model=license.license_year placeholder=\"Enter License Year\" required></div></div><div class=form-group><label for=license_amount class=col-sm-2>Amount</label><div class=col-sm-10><div class=input-group><span class=input-group-addon>$</span> <input type=decimal class=form-control id=license_amount name=license_number ng-model=license.amount placeholder=\"Enter amount\"></div></div></div><!-- Finish implementing this !--><!--<div class=\"form-group\">--><!--<label for=\"license_amount_paid\" class=\"col-sm-2\">Amount Paid</label>--><!--<div class=\"col-sm-10\">--><!--<div class=\"input-group\">--><!--<span class=\"input-group-addon\">$</span>--><!--<input type=\"decimal\" class=\"form-control\" id=\"license_amount_paid\" name=\"license_amount_paid\"--><!--ng-model=\"license.amount_paid\" placeholder=\"Enter amount\"/>--><!--</div>--><!--</div>--><!--</div>--><!--\n    <div class=\"form-group\">\n      <label class=\"col-sm-2\">Paid</label>\n      <div class=\"col-sm-10\">\n        <input type=\"checkbox\" ng-model=\"license.paid\">\n      </div>\n    </div>\n    --><div class=form-group><label class=col-sm-2>Notes</label><div class=col-sm-10><textarea type=text class=form-control id=license_notes name=license_notes ng-model=license.notes placeholder=\"Enter text\"></textarea></div></div><div class=form-group><label class=col-sm-2>Active</label><div class=col-sm-10><input type=checkbox ng-model=license.active></div></div><div class=\"form-group container\"><div class=pull-left><a class=\"btn btn-xs btn-default\" href=/#/licenses>Cancel</a> <button type=submit class=\"btn btn-xs btn-primary\" ng-click=\"submitted=true\">Save</button></div></div></form></div>");
$templateCache.put("app/licenses/licenses_index.html","<div class=container-fluid><div class=col-md-12><h2>Licenses</h2></div><div class=col-md-12><form class=form-inline><div class=input-group><span class=input-group-addon><i class=\"glyphicon glyphicon-search\"></i></span> <input ng-model=licensesSearch id=search class=form-control placeholder=Search ng-change=setConditions() ng-model-options=\"{debounce: 750}\" autocomple=off> <span class=input-group-addon>Active&nbsp;&nbsp;<input type=checkbox ng-model=licensesStatus ng-change=setConditions()></span><!--<span class=\"input-group-addon\">Unpaid Only&nbsp;&nbsp;<input type=\"checkbox\" ng-model=\"lunpaid\" ng-change=\"setConditions()\"></span>--> <span class=input-group-addon><i class=\"glyphicon glyphicon-remove\" ng-click=clearSearch()></i></span></div><br><br><div class=input-group><ui-select multiple ng-model=licensesYearFilter theme=bootstrap sortable close-on-select=false style=width:350px ng-change=setYearFilter(licensesYearFilter);getMoreResults();><ui-select-match placeholder=\"Filter by Year\">{{$item.license_year}}</ui-select-match><!-- year displayed in gray \'selected\' box --><ui-select-choices repeat=\"item in years\"><div ng-bind-html=\"item.license_year | highlight: $select.search\"></div><!-- year displayed in pick list --></ui-select-choices></ui-select></div><div class=input-group><ui-select multiple ng-model=licensesCityFilter theme=bootstrap sortable close-on-select=false style=width:350px ng-change=setCityFilter(licensesCityFilter);getMoreResults();><ui-select-match placeholder=\"Filter by City\">{{$item.city}}</ui-select-match><ui-select-choices repeat=\"item in cities\"><div ng-bind-html=\"item.city | highlight: $select.search\"></div></ui-select-choices></ui-select></div><div class=input-group><ui-select multiple ng-model=licensesLicenseTypeFilter theme=bootstrap sortable close-on-select=false style=width:350px ng-change=setLicenseTypeFilter(licensesLicenseTypeFilter);getMoreResults();><ui-select-match placeholder=\"Filter by License Type\">{{$item.name}}</ui-select-match><ui-select-choices repeat=\"item in licenseTypes\"><div ng-bind-html=\"item.name | highlight: $select.search\"></div></ui-select-choices></ui-select></div><div class=input-group><ui-select multiple ng-model=licensesLicensePurposeFilter theme=bootstrap sortable close-on-select=false style=width:350px ng-change=setLicensePurposeFilter(licensesLicensePurposeFilter);getMoreResults();><ui-select-match placeholder=\"Filter by License Purpose\">{{$item.name}}</ui-select-match><ui-select-choices repeat=\"item in licensePurposes\"><div ng-bind-html=\"item.name | highlight: $select.search\"></div></ui-select-choices></ui-select></div></form><br><div total-items=totalLicenses>{{totalLicenses}} Licenses Found</div><div><a ng-href=#/licenses/new class=\"btn btn-xs btn-primary\" type=button style=margin-top:20px>Add License</a> <a class=\"btn btn-xs btn-info btn-xs\" style=margin-top:20px ng-click=\"exportLicenses() \">Export</a></div></div><div class=col-md-12><dir-pagination-controls class=pull-right on-page-change=getMoreResults(); pagination-id=licenseMe></dir-pagination-controls><table class=\"table table-striped\"><thead><tr><th><a href=\"\" ng-click=\"setConditions(\'license_year\',sortSwitch);\">License Year <span ng-show=\"sortReverse && sortColumnz==\'license_year\'\" class=\"glyphicon glyphicon-chevron-down\"></span> <span ng-show=\"!sortReverse && sortColumnz==\'license_year\'\" class=\"glyphicon glyphicon-chevron-up\"></span></a></th><th><a href=\"\" ng-click=\"setConditions(\'end_date\',sortSwitch);\">Expiration Date <span ng-show=\"sortReverse && sortColumnz==\'end_date\'\" class=\"glyphicon glyphicon-chevron-down\"></span> <span ng-show=\"!sortReverse && sortColumnz==\'end_date\'\" class=\"glyphicon glyphicon-chevron-up\"></span></a></th><th><a href=\"\" ng-click=\"setConditions(\'business_name\',sortSwitch);\">Business Name <span ng-show=\"sortReverse && sortColumnz==\'business_name\'\" class=\"glyphicon glyphicon-chevron-down\"></span> <span ng-show=\"!sortReverse && sortColumnz==\'business_name\'\" class=\"glyphicon glyphicon-chevron-up\"></span></a></th><th><a href=\"\" ng-click=\"setConditions(\'city\',sortSwitch);\">City <span ng-show=\"sortReverse && sortColumnz==\'city\'\" class=\"glyphicon glyphicon-chevron-down\"></span> <span ng-show=\"!sortReverse && sortColumnz==\'city\'\" class=\"glyphicon glyphicon-chevron-up\"></span></a></th><th><a href=\"\" ng-click=\"setConditions(\'license_no\',sortSwitch);\">License No. <span ng-show=\"sortReverse && sortColumnz==\'license_no\'\" class=\"glyphicon glyphicon-chevron-down\"></span> <span ng-show=\"!sortReverse && sortColumnz==\'license_no\'\" class=\"glyphicon glyphicon-chevron-up\"></span></a></th><th><a href=\"\" ng-click=\"setConditions(\'license_type\',sortSwitch);\">License Type <span ng-show=\"sortReverse && sortColumnz==\'license_type\'\" class=\"glyphicon glyphicon-chevron-down\"></span> <span ng-show=\"!sortReverse && sortColumnz==\'license_type\'\" class=\"glyphicon glyphicon-chevron-up\"></span></a></th><th><a href=\"\" ng-click=\"setConditions(\'license_purpose\',sortSwitch);\">Licensing Purpose <span ng-show=\"sortReverse && sortColumnz==\'license_purpose\'\" class=\"glyphicon glyphicon-chevron-down\"></span> <span ng-show=\"!sortReverse && sortColumnz==\'license_purpose\'\" class=\"glyphicon glyphicon-chevron-up\"></span></a></th><!-- Finish implementing this ! --><!--<th><a href=\"\" ng-click=\"setConditions(\'amount_paid\',sortReverse);sortReverse=!sortReverse;\">Amount Paid--><!--<span ng-show=\"sortReverse && sortColumnz==\'amount_paid\'\" class=\"glyphicon glyphicon-chevron-down\"></span>--><!--<span ng-show=\"!sortReverse && sortColumnz==\'amount_paid\'\" class=\"glyphicon glyphicon-chevron-up\"></span></a>--><!--</th>--><th>Actions</th></tr></thead><tbody><tr dir-paginate=\"item in licenses.licenses | itemsPerPage: itemsPerPage\" total-items=totalLicenses current-page=currentPage pagination-id=licenseMe><td>{{item.license_year}}</td><td>{{item.end_date | date : \'M/d/yyyy\' : \'UTC\'}}</td><td>{{item.business.name}}</td><td>{{item.city[0].city}}</td><td>{{item.license_number}}</td><td>{{item.license_type.name}}</td><td>{{item.license_purpose.name}}</td><!--<td>{{item.amount_paid}}</td>--><td><a class=\"btn btn-xs btn-info\" ng-click=createLicensePDF($index)>Print</a> <a class=\"btn btn-xs btn-primary\" ng-href=/#/license/{{item.id}}/edit>Edit</a> <a class=\"btn btn-xs btn-danger\" ng-click=removeLicense($index)>Remove</a></td></tr></tbody><div style=\"clear: both\"></div></table><dir-pagination-controls class=pull-right on-page-change=getMoreResults(); pagination-id=licenseMe></dir-pagination-controls></div></div>");
$templateCache.put("app/licenses/licenses_new.html","<div class=container><h2>New License</h2><form class=\"form-horizontal css-form\" name=lic ng-submit=save() novalidate><div class=form-group><label for=license_number class=col-sm-2>License No.</label><div class=col-sm-10><input type=name class=form-control id=license_number name=license_number ng-model=license_number placeholder=\"Enter text\"></div></div><div class=form-group><label class=col-sm-2>Business</label><div class=col-sm-10><ui-select ng-model=license.business theme=bootstrap title=\"Choose an business\\\" required><ui-select-match placeholder=\"Select or search...\"><strong>{{$select.selected.name}}</strong></ui-select-match><ui-select-choices repeat=\"item.id as item in businesses | filter: $select.search\"><div ng-bind-html=\"item.name | highlight: $select.search\"></div><small><i>{{item.addresses[0].city}}</i>&nbsp;&nbsp;&nbsp;{{item.addresses[0].primary_street}}</small></ui-select-choices></ui-select></div></div><div class=form-group><label class=col-sm-2>License Type</label><div class=col-sm-10><ui-select ng-model=license.license_type theme=bootstrap title=\"Choose an inspection type\\\" required><ui-select-match placeholder=\"Select or search...\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"item.id as item in licenseTypes | filter: $select.search\"><div ng-bind-html=\"item.name | highlight: $select.search\"></div></ui-select-choices></ui-select></div></div><div class=form-group><label class=col-sm-2>License Purpose</label><div class=col-sm-10><ui-select ng-model=license.license_purpose theme=bootstrap title=\"Choose a purpose\\\" required><ui-select-match placeholder=\"Select or search...\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"item.id as item in licensePurposes | filter: $select.search\"><div ng-bind-html=\"item.name | highlight: $select.search\"></div></ui-select-choices></ui-select></div></div><div class=form-group><label class=col-sm-2>Licensing Official</label><div class=col-sm-10><ui-select ng-model=license.license_official theme=bootstrap title=\"Choose an official\" required><ui-select-match placeholder=\"Select or search...\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"item.id as item in licenseOfficials | filter: $select.search\"><div ng-bind-html=\"item.name | highlight: $select.search\"></div></ui-select-choices></ui-select></div></div><div class=form-group><label for=begin_date class=col-sm-2>Begin Date</label><div class=col-sm-10><input type=date class=form-control id=begin_date name=license.begin_date ng-model=begin_date ng-change=setDates() placeholder=\"Enter Date\" required></div></div><div class=form-group><label for=end_date class=col-sm-2>End Date</label><div class=col-sm-10><input type=date class=form-control id=end_date name=license.end_date ng-model=end_date placeholder=\"Enter Date\" required></div></div><div class=form-group><label for=license_year class=col-sm-2>License Year</label><div class=col-sm-10><input type=text class=form-control id=license_year name=license_year ng-model=license_year placeholder=\"Enter License Year\" required></div></div><div class=form-group><label for=license_amount class=col-sm-2>Amount</label><div class=col-sm-10><div class=input-group><span class=input-group-addon>$</span> <input type=number class=form-control id=license_amount name=license_amount ng-model=amount placeholder=\"Enter amount\" required></div></div></div><div class=form-group><label class=col-sm-2>Notes</label><div class=col-sm-10><textarea type=text class=form-control id=notes name=notes ng-model=license.notes placeholder=\"Enter text\"></textarea></div></div><div class=\"form-group container\"><div class=pull-left><a class=\"btn btn-xs btn-default\" href=/#/licenses>Cancel</a> <button type=submit class=\"btn btn-xs btn-primary\" ng-click=\"submitted=true\">Save</button></div></div></form></div>");
$templateCache.put("app/licenses/licenses_new_modal.html","<v-modal class=\"vModal--default view-data-modal\"><v-dialog heading=\"Add License\" medium left><div style=margin-bottom:20px><h1>Add License</h1><v-close label=Close ng-click=closeModal();></v-close></div><form class=\"form-horizontal css-form\" name=lick ng-submit=save(); novalidate><div class=form-group><label for=license_number class=col-sm-2>License No.</label><div class=col-sm-10><input type=name class=form-control id=license_number name=license_number ng-model=license_number placeholder=\"Enter text\" required></div></div><div class=form-group><label class=col-sm-2>License Type</label><div class=col-sm-10><ui-select ng-model=license.license_type theme=bootstrap title=\"Choose an license type\\\" required><ui-select-match placeholder=\"Select or search...\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"item in licenseTypes | filter: $select.search\"><div ng-bind-html=\"item.name | highlight: $select.search\"></div></ui-select-choices></ui-select></div></div><div class=form-group><label class=col-sm-2>License Purpose</label><div class=col-sm-10><ui-select ng-model=license.license_purpose theme=bootstrap title=\"Choose an license purpose\\\" required><ui-select-match placeholder=\"Select or search...\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"item in licensePurposes | filter: $select.search\"><div ng-bind-html=\"item.name | highlight: $select.search\"></div></ui-select-choices></ui-select></div></div><div class=form-group><label class=col-sm-2>License Official</label><div class=col-sm-10><ui-select ng-model=license.license_official theme=bootstrap title=\"Choose an license official\\\" required><ui-select-match placeholder=\"Select or search...\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"item in licenseOfficials | filter: $select.search\"><div ng-bind-html=\"item.name | highlight: $select.search\"></div></ui-select-choices></ui-select></div></div><div class=form-group><label class=col-sm-2>Begin Date</label><div class=col-sm-10><input type=date class=form-control id=begin_date name=license.begin_date ng-model=license.begin_date ng-change=setDates() placeholder=\"Enter Date\" required></div></div><div class=form-group><label for=end_date class=col-sm-2>End Date</label><div class=col-sm-10><input type=date class=form-control id=end_date name=license.end_date ng-model=license.end_date placeholder=\"Enter Date\" required></div></div><div class=form-group><label for=license_year class=col-sm-2>License Year</label><div class=col-sm-10><input type=text class=form-control id=license_year name=license_year ng-model=license.license_year placeholder=\"Enter License Year\" required></div></div><div class=form-group><label for=license_amount class=col-sm-2>Amount</label><div class=col-sm-10><div class=input-group><span class=input-group-addon>$</span> <input type=decimal class=form-control id=license_amount name=license_number ng-model=license.amount placeholder=\"Enter amount\"></div></div></div><div class=form-group><label class=col-sm-2>Notes</label><div class=col-sm-10><textarea type=text class=form-control id=license_notes name=license_notes ng-model=license.notes placeholder=\"Enter text\"></textarea></div></div><div class=\"form-group container\"><div class=pull-left><a class=\"btn btn-xs btn-default\" ng-click=closeModal();>Cancel</a> <button type=submit class=\"btn btn-xs btn-primary\" ng-click=\"submitted=true\">Save</button></div></div></form></v-dialog></v-modal>");
$templateCache.put("app/logout/logout.html","You have logged out");
$templateCache.put("app/main/main.html","<div class=container><div><acme-navbar creation-date=main.creationDate></acme-navbar></div><div class=\"jumbotron text-center\"><h1>\'Allo, \'Allo!</h1><p class=lead><img src=assets/images/yeoman.png alt=\"I\'m Yeoman\"><br>Always a pleasure scaffolding your apps.</p><p class=\"animated infinite\" ng-class=main.classAnimation><button type=button class=\"btn btn-xs btn-lg btn-success\" ng-click=main.showToastr()>Splendid Toastr</button></p><p>With ♥ thanks to the contributions of<acme-malarkey extra-values=\"[\'Yeoman\', \'Gulp\', \'Angular\']\"></acme-malarkey></p></div><div class=row><div class=\"col-sm-6 col-md-4\" ng-repeat=\"awesomeThing in main.awesomeThings | orderBy:\'rank\'\"><div class=thumbnail><img class=pull-right ng-src=\"assets/images/{{ awesomeThing.logo }}\" alt=\"{{ awesomeThing.title }}\"><div class=caption><h3>{{ awesomeThing.title }}</h3><p>{{ awesomeThing.description }}</p><p><a ng-href={{awesomeThing.url}}>{{ awesomeThing.url }}</a></p></div></div></div></div></div>");
$templateCache.put("app/signin/login.html","<form class=\"form--narrow align--center signin\" novalidate ng-controller=SignInController ng-submit=\"attemptLogin(email, password)\"><h1 class=form__title>License Management System</h1><p ng-show=isAuthenticationError() class=text--error>We do not recognize your username/password combo.</p><label class=label--full for=email><input id=email type=email name=email class=input__text ng-model=email placeholder=\"Email Address\" required></label><label class=label--full for=password><input id=password type=password name=password class=input__text ng-model=password placeholder=Password required></label><button class=button__fill--primary>Log In</button></form><!--<p class=\"form&#45;&#45;narrow align&#45;&#45;center\"><a href=\"#/register\">Need to create an account? Click here</a></p>-->");
$templateCache.put("app/components/navbar/navbar.html","<nav class=\"navbar navbar-static-top navbar-inverse\"><div class=container-fluid><div class=navbar-header><a class=navbar-brand href=https://github.com/Swiip/generator-gulp-angular><span class=\"glyphicon glyphicon-home\"></span> Gulp Angular</a></div><div class=\"collapse navbar-collapse\" id=bs-example-navbar-collapse-6><ul class=\"nav navbar-nav\"><li class=active><a ng-href=#>Home</a></li><li><a ng-href=#>About</a></li><li><a ng-href=#>Contact</a></li></ul><ul class=\"nav navbar-nav navbar-right acme-navbar-text\"><li>Application was created {{ vm.relativeDate }}.</li></ul></div></div></nav>");
$templateCache.put("app/config_settings/business_types/business_types.html","<div class=container><h3>Business Types</h3><table class=\"table table-striped\"><thead><tr><th>Name</th><th>Annual License Required</th><th>Actions</th></tr></thead><tbody><tr ng-repeat=\"businessType in businessTypes\"><td>{{businessType.name | uppercase}}</td><td><button ng-if=\"businessType.annual_license_required === 1\" class=\"btn btn-primary\" ng-click=\"updateAnnualLicenseRequirement($index, 0);\">YES</button> <button ng-if=\"businessType.annual_license_required === 0\" class=\"btn btn-secondary\" ng-click=\"updateAnnualLicenseRequirement($index, 1);\">NO</button></td><td><button class=\"btn btn-xs btn-danger\" ng-click=removeBusinessType($index)>Remove</button></td></tr></tbody></table><form ng-submit=addBusinessType(newBusinessType) class=form-inline><div class=form-group><input class=form-control id=newBusinessType type=text name=newBusinessType ng-model=newBusinessType.name placeholder=\"Enter Business Type\" required> &nbsp;&nbsp;Annual License Required?&nbsp;&nbsp;<input class=form-control id=newAnnualLicense type=checkbox name=newAnnualLicense ng-model=newBusinessType.annual_license_required> &nbsp;&nbsp;<button class=\"btn btn-primary\">Add Business Type</button></div></form></div>");
$templateCache.put("app/config_settings/contact_types/contact_types.html","<div class=container><h3>Contact Types</h3><table class=\"table table-striped\"><thead><tr><th>Name</th><th>Actions</th></tr></thead><tbody><tr ng-repeat=\"contactType in contactTypes\"><td>{{contactType.name | uppercase}}</td><td><button class=\"btn btn-xs btn-danger\" ng-click=removeContactType($index)>Remove</button></td></tr></tbody></table><form ng-submit=addContactType(newContactType) class=form-inline><div class=form-group><input class=form-control id=newContactType type=text name=newContactType ng-model=newContactType.name placeholder=\"Enter Contact Type\" required> <button class=\"btn btn-primary\">Add Contact Type</button></div></form></div>");
$templateCache.put("app/config_settings/contractor_types/contractor_types.html","<div class=container><h3>Contractor Types</h3><table class=\"table table-striped\"><thead><tr><th>Name</th><th>Actions</th></tr></thead><tbody><tr ng-repeat=\"contractorType in contractorTypes\"><td>{{contractorType.name | uppercase}}</td><td><button class=\"btn btn-xs btn-danger\" ng-click=removeContractorType($index)>Remove</button></td></tr></tbody></table><form ng-submit=addContractorType(newContractorType) class=form-inline><div class=form-group><input class=form-control id=newContractorType type=text name=newContractorType ng-model=newContractorType.name placeholder=\"Enter Contractor Type\" required> <button class=\"btn btn-primary\">Add Contractor Type</button></div></form></div>");
$templateCache.put("app/config_settings/contractors/contractors.html","<div class=container><h3>Contractors</h3><button class=\"btn btn-primary\" ng-click=addContractor()>Add Contractor</button><dir-pagination-controls class=pull-right on-page-change=getMoreResults(); pagination-id=contractorPagination></dir-pagination-controls><table class=\"table table-striped\"><!-- infinite-scroll=\'getMoreResults();\' --><thead><tr><th><a href=\"\" ng-click=\"setConditions(\'contractor_name\',sortReverse);sortReverse=!sortReverse;\">Contractor Name<span ng-show=\"sortReverse && sortColumnz==\'contractor_name\'\" class=\"glyphicon glyphicon-chevron-down\"></span> <span ng-show=\"!sortReverse && sortColumnz==\'contractor_name\'\" class=\"glyphicon glyphicon-chevron-up\"></span></a></th><th><a href=\"\" ng-click=\"setConditions(\'contractor_type\',sortReverse);sortReverse=!sortReverse;\">Type<span ng-show=\"sortReverse && sortColumnz==\'contractor_type\'\" class=\"glyphicon glyphicon-chevron-down\"></span> <span ng-show=\"!sortReverse && sortColumnz==\'contractor_type\'\" class=\"glyphicon glyphicon-chevron-up\"></span> </a></th><th><a href=\"\" ng-click=\"setConditions(\'street\',sortReverse);sortReverse=!sortReverse;\">Address<span ng-show=\"sortReverse && sortColumnz==\'street\'\" class=\"glyphicon glyphicon-chevron-down\"></span> <span ng-show=\"!sortReverse && sortColumnz==\'street\'\" class=\"glyphicon glyphicon-chevron-up\"></span> </a></th><th><a href=\"\" ng-click=\"setConditions(\'city\',sortReverse);sortReverse=!sortReverse;\">City<span ng-show=\"sortReverse && sortColumnz==\'city\'\" class=\"glyphicon glyphicon-chevron-down\"></span> <span ng-show=\"!sortReverse && sortColumnz==\'city\'\" class=\"glyphicon glyphicon-chevron-up\"></span> </a></th><th><a href=\"\" ng-click=\"setConditions(\'phone\',sortReverse);sortReverse=!sortReverse;\">Phone<span ng-show=\"sortReverse && sortColumnz==\'phone\'\" class=\"glyphicon glyphicon-chevron-down\"></span> <span ng-show=\"!sortReverse && sortColumnz==\'phone\'\" class=\"glyphicon glyphicon-chevron-up\"></span> </a></th><th>Actions</th></tr></thead><tbody><!-- <tr ng-repeat=\"contractor in contractors\"> --><tr dir-paginate=\"contractor in contractors | itemsPerPage: itemsPerPage\" total-items=totalContractors current-page=currentPage pagination-id=contractorPagination><td>{{contractor.name | uppercase}}</td><td>{{contractor.contractor_type.name | uppercase}}</td><td>{{contractor.addresses[0].primary_street | uppercase}}</td><td>{{contractor.addresses[0].city | uppercase}}</td><td>{{contractor.phone | uppercase | tel}}</td><td><input type=hidden ng-model=contractor.id value={{contractor.id}}> <button class=\"btn btn-xs btn-secondary\" ng-click=editContractor($index)>Edit</button> <button class=\"btn btn-xs btn-danger\" ng-click=removeContractor($index)>Remove</button></td></tr></tbody></table><dir-pagination-controls class=pull-right on-page-change=getMoreResults(); pagination-id=contractorPagination></dir-pagination-controls></div>");
$templateCache.put("app/config_settings/evaluation_statuses/evaluation_statuses.html","<div class=container><h3>Evaluation Statuses</h3><table class=\"table table-striped\"><thead><tr><th>Name</th><th>Actions</th></tr></thead><tbody><tr ng-repeat=\"evaluationStatus in evaluationStatuses\"><td>{{evaluationStatus.name | uppercase}}</td><td><button class=\"btn btn-xs btn-danger\" ng-click=removeEvaluationStatus($index)>Remove</button></td></tr></tbody></table><form ng-submit=addEvaluationStatus(newEvaluationStatus) class=form-inline><div class=form-group><input class=form-control id=newEvaluationStatus type=text name=newEvaluationStatus ng-model=newEvaluationStatus.name placeholder=\"Enter Evaluation Status\" required> <button class=\"btn btn-primary\">Add Evaluation Status</button></div></form></div>");
$templateCache.put("app/config_settings/inspection_reasons/inspection_reasons.html","<div class=container><h3>Inspection Reasons</h3><table class=\"table table-striped\"><thead><tr><th>Name</th><th>Actions</th></tr></thead><tbody><tr ng-repeat=\"inspectionReason in inspectionReasons\"><td>{{inspectionReason.name | uppercase}}</td><td><button class=\"btn btn-xs btn-danger\" ng-click=removeInspectionReason($index)>Remove</button></td></tr></tbody></table><form ng-submit=addInspectionReason(newInspectionReason) class=form-inline><div class=form-group><input class=form-control id=newInspectionReason type=text name=newInspectionReason ng-model=newInspectionReason.name placeholder=\"Enter Inspection Reason\" required> <button class=\"btn btn-primary\">Add Inspection Reason</button></div></form></div>");
$templateCache.put("app/config_settings/inspection_types/inspection_types.html","<div class=container><h3>Inspection Types</h3><table class=\"table table-striped\"><thead><tr><th>Name</th><th>Actions</th></tr></thead><tbody><tr ng-repeat=\"inspectionType in inspectionTypes\"><td>{{inspectionType.name | uppercase}}</td><td><button class=\"btn btn-xs btn-danger\" ng-click=removeInspectionType($index)>Remove</button></td></tr></tbody></table><form ng-submit=addInspectionType(newInspectionType) class=form-inline><div class=form-group><input class=form-control id=newInspectionType type=text name=newInspectionType ng-model=newInspectionType.name placeholder=\"Enter Inspection Type\" required> <button class=\"btn btn-primary\">Add Inspection Type</button></div></form></div>");
$templateCache.put("app/config_settings/license_officials/license_officials.html","<div class=container><h3>License Officials</h3><table class=\"table table-striped\"><thead><tr><th>Name</th><th>Title</th><th>Actions</th></tr></thead><tbody><tr ng-repeat=\"licenseOfficial in licenseOfficials\"><td>{{licenseOfficial.name | uppercase}}</td><td>{{licenseOfficial.title | uppercase}}</td><td><button class=\"btn btn-xs btn-danger\" ng-click=removeLicenseOfficial($index)>Remove</button></td></tr></tbody></table><form ng-submit=addLicenseOfficial(newLicenseOfficial) class=form-inline><div class=form-group><input class=form-control id=newLicenseOfficial type=text name=newLicenseOfficial ng-model=newLicenseOfficial.name placeholder=\"Enter Official Name\" required> <input class=form-control id=newLicenseOfficialTitle type=text name=newOfficialTitle ng-model=newLicenseOfficial.title placeholder=\"Enter Official Title\" required> <button class=\"btn btn-primary\">Add License Official</button></div></form></div>");
$templateCache.put("app/config_settings/license_purposes/license_purposes.html","<div class=container><h3>License Purpose</h3><table class=\"table table-striped\"><thead><tr><th>Name</th><th>Actions</th></tr></thead><tbody><tr ng-repeat=\"licensePurpose in licensePurposes\"><td>{{licensePurpose.name | uppercase}}</td><td><button class=\"btn btn-xs btn-danger\" ng-click=removeLicensePurpose($index)>Remove</button></td></tr></tbody></table><form ng-submit=addLicensePurpose(newLicensePurpose) class=form-inline><div class=form-group><input class=form-control id=newLicensePurpose type=text name=newLicensePurpose ng-model=newLicensePurpose.name placeholder=\"Enter License Purpose\" required> <button class=\"btn btn-primary\">Add License Purpose</button></div></form></div>");
$templateCache.put("app/config_settings/license_settings/license_settings.html","<div class=container><h3>License Settings</h3><form ng-submit=updateLicenseSetting(licenseSetting) class=form><div class=form-group><label for=title_1>Title 1</label><input class=form-control id=title_1 type=text name=title_1 ng-model=licenseSetting.title_1 placeholder=\"Smallville Health Department\" required></div><div class=form-group><label for=title_2>Title 2</label><input class=form-control id=title_2 type=text name=title_2 ng-model=licenseSetting.title_2 placeholder=\"Common County\" required></div><div class=form-group><label for=title_3>Title 3</label><input class=form-control id=title_3 type=text name=title_3 ng-model=licenseSetting.title_3 placeholder=\"New Jersey\"></div><div class=form-group><label for=fine_print>Fine Print</label><textarea class=form-control id=fine_print name=fine_print ng-model=licenseSetting.fine_print></textarea></div><div class=form-group><label for=title_3>Current License Number (Set to zero to reset)</label><input class=form-control id=current_license_number type=number min=0 name=current_license_number ng-model=licenseSetting.current_license_number placeholder=1 required></div><br><br><button class=\"btn btn-primary\">Update</button></form></div>");
$templateCache.put("app/config_settings/license_types/license_types.html","<div class=container><h3>License Types</h3><table class=\"table table-striped\"><thead><tr><th>Name</th><th>Actions</th></tr></thead><tbody><tr ng-repeat=\"licenseType in licenseTypes\"><td>{{licenseType.name | uppercase}}</td><td><button class=\"btn btn-xs btn-danger\" ng-click=removeLicenseType($index)>Remove</button></td></tr></tbody></table><form ng-submit=addLicenseType(newLicenseType) class=form-inline><div class=form-group><input class=form-control id=newLicenseType type=text name=newLicenseType ng-model=newLicenseType.name placeholder=\"Enter License Type\" required> <button class=\"btn btn-primary\">Add License Type</button></div></form></div>");
$templateCache.put("app/config_settings/states/states.html","<div class=container><h3>States</h3><table class=\"table table-striped\"><thead><tr><th>Name</th><th>Abbreviation</th><th>Actions</th></tr></thead><tbody><tr ng-repeat=\"state in states\"><td>{{state.name | uppercase}}</td><td>{{state.abbreviation | uppercase}}</td><td><button class=\"btn btn-xs btn-danger\" ng-click=removeState($index)>Remove</button></td></tr></tbody></table><form ng-submit=addState(newState) class=form-inline><div class=form-group><input class=form-control id=newState type=text name=newState ng-model=newState.name placeholder=\"Enter State\" required> <input class=form-control id=newAbbreviation type=text name=newAbbreviation ng-model=newState.abbreviation placeholder=\"Enter Abbreviation\" required maxlength=2> <button class=\"btn btn-primary\">Add State</button></div></form></div>");}]);